var _objectWithoutProperties = require("/app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _assertThisInitialized = require("/app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _regeneratorRuntime = require("/app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

var _toConsumableArray = require("/app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _defineProperty = require("/app/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/app/node_modules/@babel/runtime/helpers/slicedToArray");

var _wrapNativeSuper = require("/app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var _inherits = require("/app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e20) { throw _e20; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e21) { didErr = true; err = _e21; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

require("core-js/modules/es.array.reduce.js");

require("core-js/modules/es.promise.finally.js");

/*! For license information please see react-carousel.js.LICENSE.txt */
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react"), require("react-dom")) : "function" == typeof define && define.amd ? define("react-carousel", ["react", "react-dom"], t) : "object" == typeof exports ? exports["react-carousel"] = t(require("react"), require("react-dom")) : e["react-carousel"] = t(e.React, e.ReactDOM);
}(this, function (e, t) {
  return function (e) {
    var t = {};

    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        n.d(r, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 244);
  }([function (t, n) {
    t.exports = e;
  }, function (e, t, n) {
    "use strict";

    e.exports = n(110);
  }, function (e, t, n) {
    var r = n(85);
    e.exports = n(183)(r.isElement, !0);
  }, function (e, t, n) {
    var r = n(64),
        o = "object" == typeof self && self && self.Object === Object && self,
        a = r || o || Function("return this")();
    e.exports = a;
  }, function (e, t) {
    var n = Array.isArray;
    e.exports = n;
  }, function (e, t) {
    e.exports = function (e) {
      var t = typeof e;
      return null != e && ("object" == t || "function" == t);
    };
  }, function (e, t, n) {
    var r;
    !function () {
      "use strict";

      var n = {}.hasOwnProperty;

      function o() {
        for (var e = [], t = 0; t < arguments.length; t++) {
          var r = arguments[t];

          if (r) {
            var a = typeof r;
            if ("string" === a || "number" === a) e.push(r);else if (Array.isArray(r) && r.length) {
              var i = o.apply(null, r);
              i && e.push(i);
            } else if ("object" === a) for (var u in r) {
              n.call(r, u) && r[u] && e.push(u);
            }
          }
        }

        return e.join(" ");
      }

      e.exports ? (o.default = o, e.exports = o) : void 0 === (r = function () {
        return o;
      }.apply(t, [])) || (e.exports = r);
    }();
  }, function (e, t) {
    e.exports = function (e) {
      return null != e && "object" == typeof e;
    };
  }, function (e, t, n) {
    var r = n(122),
        o = n(127);

    e.exports = function (e, t) {
      var n = o(e, t);
      return r(n) ? n : void 0;
    };
  }, function (e, t, n) {
    var r = n(10),
        o = n(123),
        a = n(124),
        i = r ? r.toStringTag : void 0;

    e.exports = function (e) {
      return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : i && i in Object(e) ? o(e) : a(e);
    };
  }, function (e, t, n) {
    var r = n(3).Symbol;
    e.exports = r;
  }, function (e, t) {
    e.exports = function (e) {
      return e;
    };
  }, function (e, t, n) {
    var r = n(67),
        o = n(68);

    e.exports = function (e, t, n, a) {
      var i = !n;
      n || (n = {});

      for (var u = -1, c = t.length; ++u < c;) {
        var s = t[u],
            l = a ? a(n[s], e[s], s, n, e) : void 0;
        void 0 === l && (l = e[s]), i ? o(n, s, l) : r(n, s, l);
      }

      return n;
    };
  }, function (e, t, n) {
    var r = n(70),
        o = n(144),
        a = n(14);

    e.exports = function (e) {
      return a(e) ? r(e) : o(e);
    };
  }, function (e, t, n) {
    var r = n(63),
        o = n(45);

    e.exports = function (e) {
      return null != e && o(e.length) && !r(e);
    };
  }, function (e, t, n) {
    var r = n(9),
        o = n(7);

    e.exports = function (e) {
      return "symbol" == typeof e || o(e) && "[object Symbol]" == r(e);
    };
  }, function (e, t, n) {
    var r = n(15);

    e.exports = function (e) {
      if ("string" == typeof e || r(e)) return e;
      var t = e + "";
      return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
    };
  }, function (e, t) {
    e.exports = function (e) {
      return null == e;
    };
  }, function (e, t, n) {
    var r = n(187)();
    e.exports = r;
  }, function (e, t, n) {
    var r = n(89),
        o = n(192),
        a = n(61),
        i = n(33),
        u = r(function (e, t, n) {
      var r = 1;

      if (n.length) {
        var c = i(n, a(u));
        r |= 32;
      }

      return o(e, r, t, n, c);
    });
    u.placeholder = {}, e.exports = u;
  }, function (e, t, n) {
    var r = n(112),
        o = n(113),
        a = n(114),
        i = n(115),
        u = n(116);

    function c(e) {
      var t = -1,
          n = null == e ? 0 : e.length;

      for (this.clear(); ++t < n;) {
        var r = e[t];
        this.set(r[0], r[1]);
      }
    }

    c.prototype.clear = r, c.prototype.delete = o, c.prototype.get = a, c.prototype.has = i, c.prototype.set = u, e.exports = c;
  }, function (e, t, n) {
    var r = n(22);

    e.exports = function (e, t) {
      for (var n = e.length; n--;) {
        if (r(e[n][0], t)) return n;
      }

      return -1;
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      return e === t || e != e && t != t;
    };
  }, function (e, t, n) {
    var r = n(8)(Object, "create");
    e.exports = r;
  }, function (e, t, n) {
    var r = n(136);

    e.exports = function (e, t) {
      var n = e.__data__;
      return r(t) ? n["string" == typeof t ? "string" : "hash"] : n.map;
    };
  }, function (e, t) {
    var n = /^(?:0|[1-9]\d*)$/;

    e.exports = function (e, t) {
      var r = typeof e;
      return !!(t = null == t ? 9007199254740991 : t) && ("number" == r || "symbol" != r && n.test(e)) && e > -1 && e % 1 == 0 && e < t;
    };
  }, function (e, t) {
    e.exports = function (e) {
      return function (t) {
        return e(t);
      };
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      var n = -1,
          r = e.length;

      for (t || (t = Array(r)); ++n < r;) {
        t[n] = e[n];
      }

      return t;
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      for (var n = -1, r = t.length, o = e.length; ++n < r;) {
        e[o + n] = t[n];
      }

      return e;
    };
  }, function (e, t, n) {
    var r = n(153),
        o = n(39),
        a = n(154),
        i = n(155),
        u = n(80),
        c = n(9),
        s = n(65),
        l = s(r),
        f = s(o),
        p = s(a),
        d = s(i),
        b = s(u),
        h = c;
    (r && "[object DataView]" != h(new r(new ArrayBuffer(1))) || o && "[object Map]" != h(new o()) || a && "[object Promise]" != h(a.resolve()) || i && "[object Set]" != h(new i()) || u && "[object WeakMap]" != h(new u())) && (h = function h(e) {
      var t = c(e),
          n = "[object Object]" == t ? e.constructor : void 0,
          r = n ? s(n) : "";
      if (r) switch (r) {
        case l:
          return "[object DataView]";

        case f:
          return "[object Map]";

        case p:
          return "[object Promise]";

        case d:
          return "[object Set]";

        case b:
          return "[object WeakMap]";
      }
      return t;
    }), e.exports = h;
  }, function (e, t, n) {
    var r = n(5),
        o = Object.create,
        a = function () {
      function e() {}

      return function (t) {
        if (!r(t)) return {};
        if (o) return o(t);
        e.prototype = t;
        var n = new e();
        return e.prototype = void 0, n;
      };
    }();

    e.exports = a;
  }, function (e, t, n) {
    var r = n(4),
        o = n(51),
        a = n(168),
        i = n(171);

    e.exports = function (e, t) {
      return r(e) ? e : o(e, t) ? [e] : a(i(e));
    };
  }, function (e, t, n) {
    var r = n(30),
        o = n(5);

    e.exports = function (e) {
      return function () {
        var t = arguments;

        switch (t.length) {
          case 0:
            return new e();

          case 1:
            return new e(t[0]);

          case 2:
            return new e(t[0], t[1]);

          case 3:
            return new e(t[0], t[1], t[2]);

          case 4:
            return new e(t[0], t[1], t[2], t[3]);

          case 5:
            return new e(t[0], t[1], t[2], t[3], t[4]);

          case 6:
            return new e(t[0], t[1], t[2], t[3], t[4], t[5]);

          case 7:
            return new e(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
        }

        var n = r(e.prototype),
            a = e.apply(n, t);
        return o(a) ? a : n;
      };
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      for (var n = -1, r = e.length, o = 0, a = []; ++n < r;) {
        var i = e[n];
        i !== t && "__lodash_placeholder__" !== i || (e[n] = "__lodash_placeholder__", a[o++] = n);
      }

      return a;
    };
  }, function (e, n) {
    e.exports = t;
  }, function (e, t, n) {
    var r = n(53);

    e.exports = function (e) {
      return null != e && e.length ? r(e, 1) : [];
    };
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      var n = function () {
        if ("undefined" != typeof Map) return Map;

        function e(e, t) {
          var n = -1;
          return e.some(function (e, r) {
            return e[0] === t && (n = r, !0);
          }), n;
        }

        return function () {
          function t() {
            this.__entries__ = [];
          }

          return Object.defineProperty(t.prototype, "size", {
            get: function get() {
              return this.__entries__.length;
            },
            enumerable: !0,
            configurable: !0
          }), t.prototype.get = function (t) {
            var n = e(this.__entries__, t),
                r = this.__entries__[n];
            return r && r[1];
          }, t.prototype.set = function (t, n) {
            var r = e(this.__entries__, t);
            ~r ? this.__entries__[r][1] = n : this.__entries__.push([t, n]);
          }, t.prototype.delete = function (t) {
            var n = this.__entries__,
                r = e(n, t);
            ~r && n.splice(r, 1);
          }, t.prototype.has = function (t) {
            return !!~e(this.__entries__, t);
          }, t.prototype.clear = function () {
            this.__entries__.splice(0);
          }, t.prototype.forEach = function (e, t) {
            void 0 === t && (t = null);

            for (var n = 0, r = this.__entries__; n < r.length; n++) {
              var o = r[n];
              e.call(t, o[1], o[0]);
            }
          }, t;
        }();
      }(),
          r = "undefined" != typeof window && "undefined" != typeof document && window.document === document,
          o = void 0 !== e && e.Math === Math ? e : "undefined" != typeof self && self.Math === Math ? self : "undefined" != typeof window && window.Math === Math ? window : Function("return this")(),
          a = "function" == typeof requestAnimationFrame ? requestAnimationFrame.bind(o) : function (e) {
        return setTimeout(function () {
          return e(Date.now());
        }, 1e3 / 60);
      },
          i = ["top", "right", "bottom", "left", "width", "height", "size", "weight"],
          u = "undefined" != typeof MutationObserver,
          c = function () {
        function e() {
          this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = function (e, t) {
            var n = !1,
                r = !1,
                o = 0;

            function i() {
              n && (n = !1, e()), r && c();
            }

            function u() {
              a(i);
            }

            function c() {
              var e = Date.now();

              if (n) {
                if (e - o < 2) return;
                r = !0;
              } else n = !0, r = !1, setTimeout(u, 20);

              o = e;
            }

            return c;
          }(this.refresh.bind(this));
        }

        return e.prototype.addObserver = function (e) {
          ~this.observers_.indexOf(e) || this.observers_.push(e), this.connected_ || this.connect_();
        }, e.prototype.removeObserver = function (e) {
          var t = this.observers_,
              n = t.indexOf(e);
          ~n && t.splice(n, 1), !t.length && this.connected_ && this.disconnect_();
        }, e.prototype.refresh = function () {
          this.updateObservers_() && this.refresh();
        }, e.prototype.updateObservers_ = function () {
          var e = this.observers_.filter(function (e) {
            return e.gatherActive(), e.hasActive();
          });
          return e.forEach(function (e) {
            return e.broadcastActive();
          }), e.length > 0;
        }, e.prototype.connect_ = function () {
          r && !this.connected_ && (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), u ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
            attributes: !0,
            childList: !0,
            characterData: !0,
            subtree: !0
          })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
        }, e.prototype.disconnect_ = function () {
          r && this.connected_ && (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
        }, e.prototype.onTransitionEnd_ = function (e) {
          var t = e.propertyName,
              n = void 0 === t ? "" : t;
          i.some(function (e) {
            return !!~n.indexOf(e);
          }) && this.refresh();
        }, e.getInstance = function () {
          return this.instance_ || (this.instance_ = new e()), this.instance_;
        }, e.instance_ = null, e;
      }(),
          s = function s(e, t) {
        for (var n = 0, r = Object.keys(t); n < r.length; n++) {
          var o = r[n];
          Object.defineProperty(e, o, {
            value: t[o],
            enumerable: !1,
            writable: !1,
            configurable: !0
          });
        }

        return e;
      },
          l = function l(e) {
        return e && e.ownerDocument && e.ownerDocument.defaultView || o;
      },
          f = y(0, 0, 0, 0);

      function p(e) {
        return parseFloat(e) || 0;
      }

      function d(e) {
        for (var t = [], n = 1; n < arguments.length; n++) {
          t[n - 1] = arguments[n];
        }

        return t.reduce(function (t, n) {
          return t + p(e["border-" + n + "-width"]);
        }, 0);
      }

      var b = "undefined" != typeof SVGGraphicsElement ? function (e) {
        return e instanceof l(e).SVGGraphicsElement;
      } : function (e) {
        return e instanceof l(e).SVGElement && "function" == typeof e.getBBox;
      };

      function h(e) {
        return r ? b(e) ? function (e) {
          var t = e.getBBox();
          return y(0, 0, t.width, t.height);
        }(e) : function (e) {
          var t = e.clientWidth,
              n = e.clientHeight;
          if (!t && !n) return f;

          var r = l(e).getComputedStyle(e),
              o = function (e) {
            for (var t = {}, n = 0, r = ["top", "right", "bottom", "left"]; n < r.length; n++) {
              var o = r[n],
                  a = e["padding-" + o];
              t[o] = p(a);
            }

            return t;
          }(r),
              a = o.left + o.right,
              i = o.top + o.bottom,
              u = p(r.width),
              c = p(r.height);

          if ("border-box" === r.boxSizing && (Math.round(u + a) !== t && (u -= d(r, "left", "right") + a), Math.round(c + i) !== n && (c -= d(r, "top", "bottom") + i)), !function (e) {
            return e === l(e).document.documentElement;
          }(e)) {
            var s = Math.round(u + a) - t,
                b = Math.round(c + i) - n;
            1 !== Math.abs(s) && (u -= s), 1 !== Math.abs(b) && (c -= b);
          }

          return y(o.left, o.top, u, c);
        }(e) : f;
      }

      function y(e, t, n, r) {
        return {
          x: e,
          y: t,
          width: n,
          height: r
        };
      }

      var v = function () {
        function e(e) {
          this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = y(0, 0, 0, 0), this.target = e;
        }

        return e.prototype.isActive = function () {
          var e = h(this.target);
          return this.contentRect_ = e, e.width !== this.broadcastWidth || e.height !== this.broadcastHeight;
        }, e.prototype.broadcastRect = function () {
          var e = this.contentRect_;
          return this.broadcastWidth = e.width, this.broadcastHeight = e.height, e;
        }, e;
      }(),
          m = function m(e, t) {
        var n,
            r,
            o,
            a,
            i,
            u,
            c,
            l = (r = (n = t).x, o = n.y, a = n.width, i = n.height, u = "undefined" != typeof DOMRectReadOnly ? DOMRectReadOnly : Object, c = Object.create(u.prototype), s(c, {
          x: r,
          y: o,
          width: a,
          height: i,
          top: o,
          right: r + a,
          bottom: i + o,
          left: r
        }), c);
        s(this, {
          target: e,
          contentRect: l
        });
      },
          g = function () {
        function e(e, t, r) {
          if (this.activeObservations_ = [], this.observations_ = new n(), "function" != typeof e) throw new TypeError("The callback provided as parameter 1 is not a function.");
          this.callback_ = e, this.controller_ = t, this.callbackCtx_ = r;
        }

        return e.prototype.observe = function (e) {
          if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");

          if ("undefined" != typeof Element && Element instanceof Object) {
            if (!(e instanceof l(e).Element)) throw new TypeError('parameter 1 is not of type "Element".');
            var t = this.observations_;
            t.has(e) || (t.set(e, new v(e)), this.controller_.addObserver(this), this.controller_.refresh());
          }
        }, e.prototype.unobserve = function (e) {
          if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");

          if ("undefined" != typeof Element && Element instanceof Object) {
            if (!(e instanceof l(e).Element)) throw new TypeError('parameter 1 is not of type "Element".');
            var t = this.observations_;
            t.has(e) && (t.delete(e), t.size || this.controller_.removeObserver(this));
          }
        }, e.prototype.disconnect = function () {
          this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
        }, e.prototype.gatherActive = function () {
          var e = this;
          this.clearActive(), this.observations_.forEach(function (t) {
            t.isActive() && e.activeObservations_.push(t);
          });
        }, e.prototype.broadcastActive = function () {
          if (this.hasActive()) {
            var e = this.callbackCtx_,
                t = this.activeObservations_.map(function (e) {
              return new m(e.target, e.broadcastRect());
            });
            this.callback_.call(e, t, e), this.clearActive();
          }
        }, e.prototype.clearActive = function () {
          this.activeObservations_.splice(0);
        }, e.prototype.hasActive = function () {
          return this.activeObservations_.length > 0;
        }, e;
      }(),
          S = "undefined" != typeof WeakMap ? new WeakMap() : new n(),
          w = function e(t) {
        if (!(this instanceof e)) throw new TypeError("Cannot call a class as a function.");
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        var n = c.getInstance(),
            r = new g(t, n, this);
        S.set(this, r);
      };

      ["observe", "unobserve", "disconnect"].forEach(function (e) {
        w.prototype[e] = function () {
          var t;
          return (t = S.get(this))[e].apply(t, arguments);
        };
      });
      var O = void 0 !== o.ResizeObserver ? o.ResizeObserver : w;
      t.a = O;
    }).call(this, n(40));
  }, function (e, t) {
    e.exports = function (e, t) {
      for (var n = -1, r = null == e ? 0 : e.length, o = Array(r); ++n < r;) {
        o[n] = t(e[n], n, e);
      }

      return o;
    };
  }, function (e, t, n) {
    var r = n(20),
        o = n(117),
        a = n(118),
        i = n(119),
        u = n(120),
        c = n(121);

    function s(e) {
      var t = this.__data__ = new r(e);
      this.size = t.size;
    }

    s.prototype.clear = o, s.prototype.delete = a, s.prototype.get = i, s.prototype.has = u, s.prototype.set = c, e.exports = s;
  }, function (e, t, n) {
    var r = n(8)(n(3), "Map");
    e.exports = r;
  }, function (e, t) {
    var n;

    n = function () {
      return this;
    }();

    try {
      n = n || new Function("return this")();
    } catch (e) {
      "object" == typeof window && (n = window);
    }

    e.exports = n;
  }, function (e, t, n) {
    var r = n(128),
        o = n(135),
        a = n(137),
        i = n(138),
        u = n(139);

    function c(e) {
      var t = -1,
          n = null == e ? 0 : e.length;

      for (this.clear(); ++t < n;) {
        var r = e[t];
        this.set(r[0], r[1]);
      }
    }

    c.prototype.clear = r, c.prototype.delete = o, c.prototype.get = a, c.prototype.has = i, c.prototype.set = u, e.exports = c;
  }, function (e, t, n) {
    var r = n(141),
        o = n(7),
        a = Object.prototype,
        i = a.hasOwnProperty,
        u = a.propertyIsEnumerable,
        c = r(function () {
      return arguments;
    }()) ? r : function (e) {
      return o(e) && i.call(e, "callee") && !u.call(e, "callee");
    };
    e.exports = c;
  }, function (e, t, n) {
    (function (e) {
      var r = n(3),
          o = n(142),
          a = t && !t.nodeType && t,
          i = a && "object" == typeof e && e && !e.nodeType && e,
          u = i && i.exports === a ? r.Buffer : void 0,
          c = (u ? u.isBuffer : void 0) || o;
      e.exports = c;
    }).call(this, n(44)(e));
  }, function (e, t) {
    e.exports = function (e) {
      return e.webpackPolyfill || (e.deprecate = function () {}, e.paths = [], e.children || (e.children = []), Object.defineProperty(e, "loaded", {
        enumerable: !0,
        get: function get() {
          return e.l;
        }
      }), Object.defineProperty(e, "id", {
        enumerable: !0,
        get: function get() {
          return e.i;
        }
      }), e.webpackPolyfill = 1), e;
    };
  }, function (e, t) {
    e.exports = function (e) {
      return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 9007199254740991;
    };
  }, function (e, t, n) {
    (function (e) {
      var r = n(64),
          o = t && !t.nodeType && t,
          a = o && "object" == typeof e && e && !e.nodeType && e,
          i = a && a.exports === o && r.process,
          u = function () {
        try {
          return a && a.require && a.require("util").types || i && i.binding && i.binding("util");
        } catch (e) {}
      }();

      e.exports = u;
    }).call(this, n(44)(e));
  }, function (e, t) {
    var n = Object.prototype;

    e.exports = function (e) {
      var t = e && e.constructor;
      return e === ("function" == typeof t && t.prototype || n);
    };
  }, function (e, t, n) {
    var r = n(151),
        o = n(75),
        a = Object.prototype.propertyIsEnumerable,
        i = Object.getOwnPropertySymbols,
        u = i ? function (e) {
      return null == e ? [] : (e = Object(e), r(i(e), function (t) {
        return a.call(e, t);
      }));
    } : o;
    e.exports = u;
  }, function (e, t, n) {
    var r = n(73)(Object.getPrototypeOf, Object);
    e.exports = r;
  }, function (e, t, n) {
    var r = n(81);

    e.exports = function (e) {
      var t = new e.constructor(e.byteLength);
      return new r(t).set(new r(e)), t;
    };
  }, function (e, t, n) {
    var r = n(4),
        o = n(15),
        a = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
        i = /^\w*$/;

    e.exports = function (e, t) {
      if (r(e)) return !1;
      var n = typeof e;
      return !("number" != n && "symbol" != n && "boolean" != n && null != e && !o(e)) || i.test(e) || !a.test(e) || null != t && e in Object(t);
    };
  }, function (e, t, n) {
    var r = n(31),
        o = n(16);

    e.exports = function (e, t) {
      for (var n = 0, a = (t = r(t, e)).length; null != e && n < a;) {
        e = e[o(t[n++])];
      }

      return n && n == a ? e : void 0;
    };
  }, function (e, t, n) {
    var r = n(28),
        o = n(178);

    e.exports = function e(t, n, a, i, u) {
      var c = -1,
          s = t.length;

      for (a || (a = o), u || (u = []); ++c < s;) {
        var l = t[c];
        n > 0 && a(l) ? n > 1 ? e(l, n - 1, a, i, u) : r(u, l) : i || (u[u.length] = l);
      }

      return u;
    };
  }, function (e, t) {
    e.exports = function (e, t, n) {
      switch (n.length) {
        case 0:
          return e.call(t);

        case 1:
          return e.call(t, n[0]);

        case 2:
          return e.call(t, n[0], n[1]);

        case 3:
          return e.call(t, n[0], n[1], n[2]);
      }

      return e.apply(t, n);
    };
  }, function (e, t, n) {
    var r = n(179),
        o = n(84)(r);
    e.exports = o;
  }, function (e, t, n) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (e, t, n) {
    var r = n(30),
        o = n(58);

    function a(e, t) {
      this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!t, this.__index__ = 0, this.__values__ = void 0;
    }

    a.prototype = r(o.prototype), a.prototype.constructor = a, e.exports = a;
  }, function (e, t) {
    e.exports = function () {};
  }, function (e, t, n) {
    var r = n(86),
        o = n(188),
        a = r ? function (e) {
      return r.get(e);
    } : o;
    e.exports = a;
  }, function (e, t, n) {
    var r = n(30),
        o = n(58);

    function a(e) {
      this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = 4294967295, this.__views__ = [];
    }

    a.prototype = r(o.prototype), a.prototype.constructor = a, e.exports = a;
  }, function (e, t) {
    e.exports = function (e) {
      return e.placeholder;
    };
  }, function (e, t, n) {
    var r = n(71),
        o = n(243),
        a = n(97),
        i = Math.min;

    e.exports = function (e, t) {
      if ((e = a(e)) < 1 || e > 9007199254740991) return [];
      var n = 4294967295,
          u = i(e, 4294967295);
      t = o(t), e -= 4294967295;

      for (var c = r(u, t); ++n < e;) {
        t(n);
      }

      return c;
    };
  }, function (e, t, n) {
    var r = n(9),
        o = n(5);

    e.exports = function (e) {
      if (!o(e)) return !1;
      var t = r(e);
      return "[object Function]" == t || "[object GeneratorFunction]" == t || "[object AsyncFunction]" == t || "[object Proxy]" == t;
    };
  }, function (e, t, n) {
    (function (t) {
      var n = "object" == typeof t && t && t.Object === Object && t;
      e.exports = n;
    }).call(this, n(40));
  }, function (e, t) {
    var n = Function.prototype.toString;

    e.exports = function (e) {
      if (null != e) {
        try {
          return n.call(e);
        } catch (e) {}

        try {
          return e + "";
        } catch (e) {}
      }

      return "";
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      for (var n = -1, r = null == e ? 0 : e.length; ++n < r && !1 !== t(e[n], n, e);) {
        ;
      }

      return e;
    };
  }, function (e, t, n) {
    var r = n(68),
        o = n(22),
        a = Object.prototype.hasOwnProperty;

    e.exports = function (e, t, n) {
      var i = e[t];
      a.call(e, t) && o(i, n) && (void 0 !== n || t in e) || r(e, t, n);
    };
  }, function (e, t, n) {
    var r = n(69);

    e.exports = function (e, t, n) {
      "__proto__" == t && r ? r(e, t, {
        configurable: !0,
        enumerable: !0,
        value: n,
        writable: !0
      }) : e[t] = n;
    };
  }, function (e, t, n) {
    var r = n(8),
        o = function () {
      try {
        var e = r(Object, "defineProperty");
        return e({}, "", {}), e;
      } catch (e) {}
    }();

    e.exports = o;
  }, function (e, t, n) {
    var r = n(71),
        o = n(42),
        a = n(4),
        i = n(43),
        u = n(25),
        c = n(72),
        s = Object.prototype.hasOwnProperty;

    e.exports = function (e, t) {
      var n = a(e),
          l = !n && o(e),
          f = !n && !l && i(e),
          p = !n && !l && !f && c(e),
          d = n || l || f || p,
          b = d ? r(e.length, String) : [],
          h = b.length;

      for (var y in e) {
        !t && !s.call(e, y) || d && ("length" == y || f && ("offset" == y || "parent" == y) || p && ("buffer" == y || "byteLength" == y || "byteOffset" == y) || u(y, h)) || b.push(y);
      }

      return b;
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      for (var n = -1, r = Array(e); ++n < e;) {
        r[n] = t(n);
      }

      return r;
    };
  }, function (e, t, n) {
    var r = n(143),
        o = n(26),
        a = n(46),
        i = a && a.isTypedArray,
        u = i ? o(i) : r;
    e.exports = u;
  }, function (e, t) {
    e.exports = function (e, t) {
      return function (n) {
        return e(t(n));
      };
    };
  }, function (e, t, n) {
    var r = n(70),
        o = n(147),
        a = n(14);

    e.exports = function (e) {
      return a(e) ? r(e, !0) : o(e);
    };
  }, function (e, t) {
    e.exports = function () {
      return [];
    };
  }, function (e, t, n) {
    var r = n(28),
        o = n(49),
        a = n(48),
        i = n(75),
        u = Object.getOwnPropertySymbols ? function (e) {
      for (var t = []; e;) {
        r(t, a(e)), e = o(e);
      }

      return t;
    } : i;
    e.exports = u;
  }, function (e, t, n) {
    var r = n(78),
        o = n(48),
        a = n(13);

    e.exports = function (e) {
      return r(e, a, o);
    };
  }, function (e, t, n) {
    var r = n(28),
        o = n(4);

    e.exports = function (e, t, n) {
      var a = t(e);
      return o(e) ? a : r(a, n(e));
    };
  }, function (e, t, n) {
    var r = n(78),
        o = n(76),
        a = n(74);

    e.exports = function (e) {
      return r(e, a, o);
    };
  }, function (e, t, n) {
    var r = n(8)(n(3), "WeakMap");
    e.exports = r;
  }, function (e, t, n) {
    var r = n(3).Uint8Array;
    e.exports = r;
  }, function (e, t, n) {
    var r = n(35),
        o = n(83),
        a = n(55);

    e.exports = function (e) {
      return a(o(e, void 0, r), e + "");
    };
  }, function (e, t, n) {
    var r = n(54),
        o = Math.max;

    e.exports = function (e, t, n) {
      return t = o(void 0 === t ? e.length - 1 : t, 0), function () {
        for (var a = arguments, i = -1, u = o(a.length - t, 0), c = Array(u); ++i < u;) {
          c[i] = a[t + i];
        }

        i = -1;

        for (var s = Array(t + 1); ++i < t;) {
          s[i] = a[i];
        }

        return s[t] = n(c), r(e, this, s);
      };
    };
  }, function (e, t) {
    var n = Date.now;

    e.exports = function (e) {
      var t = 0,
          r = 0;
      return function () {
        var o = n(),
            a = 16 - (o - r);

        if (r = o, a > 0) {
          if (++t >= 800) return arguments[0];
        } else t = 0;

        return e.apply(void 0, arguments);
      };
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = n(182);
  }, function (e, t, n) {
    var r = n(80),
        o = r && new r();
    e.exports = o;
  }, function (e, t, n) {
    var r = n(189),
        o = Object.prototype.hasOwnProperty;

    e.exports = function (e) {
      for (var t = e.name + "", n = r[t], a = o.call(r, t) ? n.length : 0; a--;) {
        var i = n[a],
            u = i.func;
        if (null == u || u == e) return i.name;
      }

      return t;
    };
  }, function (e, t, n) {
    var r = n(60),
        o = n(59),
        a = n(87),
        i = n(190);

    e.exports = function (e) {
      var t = a(e),
          n = i[t];
      if ("function" != typeof n || !(t in r.prototype)) return !1;
      if (e === n) return !0;
      var u = o(n);
      return !!u && e === u[0];
    };
  }, function (e, t, n) {
    var r = n(11),
        o = n(83),
        a = n(55);

    e.exports = function (e, t) {
      return a(o(e, t, r), e + "");
    };
  }, function (e, t, n) {
    var r = n(11),
        o = n(86),
        a = o ? function (e, t) {
      return o.set(e, t), e;
    } : r;
    e.exports = a;
  }, function (e, t, n) {
    var r = n(92),
        o = n(93),
        a = n(195),
        i = n(32),
        u = n(94),
        c = n(61),
        s = n(204),
        l = n(33),
        f = n(3);

    e.exports = function e(t, n, p, d, b, h, y, v, m, g) {
      var S = 128 & n,
          w = 1 & n,
          O = 2 & n,
          _ = 24 & n,
          j = 512 & n,
          A = O ? void 0 : i(t);

      return function R() {
        for (var E = arguments.length, T = Array(E), x = E; x--;) {
          T[x] = arguments[x];
        }

        if (_) var M = c(R),
            k = a(T, M);

        if (d && (T = r(T, d, b, _)), h && (T = o(T, h, y, _)), E -= k, _ && E < g) {
          var N = l(T, M);
          return u(t, n, e, R.placeholder, p, T, N, v, m, g - E);
        }

        var V = w ? p : this,
            P = O ? V[t] : t;
        return E = T.length, v ? T = s(T, v) : j && E > 1 && T.reverse(), S && m < E && (T.length = m), this && this !== f && this instanceof R && (P = A || i(P)), P.apply(V, T);
      };
    };
  }, function (e, t) {
    var n = Math.max;

    e.exports = function (e, t, r, o) {
      for (var a = -1, i = e.length, u = r.length, c = -1, s = t.length, l = n(i - u, 0), f = Array(s + l), p = !o; ++c < s;) {
        f[c] = t[c];
      }

      for (; ++a < u;) {
        (p || a < i) && (f[r[a]] = e[a]);
      }

      for (; l--;) {
        f[c++] = e[a++];
      }

      return f;
    };
  }, function (e, t) {
    var n = Math.max;

    e.exports = function (e, t, r, o) {
      for (var a = -1, i = e.length, u = -1, c = r.length, s = -1, l = t.length, f = n(i - c, 0), p = Array(f + l), d = !o; ++a < f;) {
        p[a] = e[a];
      }

      for (var b = a; ++s < l;) {
        p[b + s] = t[s];
      }

      for (; ++u < c;) {
        (d || a < i) && (p[b + r[u]] = e[a++]);
      }

      return p;
    };
  }, function (e, t, n) {
    var r = n(88),
        o = n(95),
        a = n(96);

    e.exports = function (e, t, n, i, u, c, s, l, f, p) {
      var d = 8 & t;
      t |= d ? 32 : 64, 4 & (t &= ~(d ? 64 : 32)) || (t &= -4);
      var b = [e, t, u, d ? c : void 0, d ? s : void 0, d ? void 0 : c, d ? void 0 : s, l, f, p],
          h = n.apply(void 0, b);
      return r(e) && o(h, b), h.placeholder = i, a(h, e, t);
    };
  }, function (e, t, n) {
    var r = n(90),
        o = n(84)(r);
    e.exports = o;
  }, function (e, t, n) {
    var r = n(196),
        o = n(197),
        a = n(55),
        i = n(198);

    e.exports = function (e, t, n) {
      var u = t + "";
      return a(e, o(u, i(r(u), n)));
    };
  }, function (e, t, n) {
    var r = n(207);

    e.exports = function (e) {
      var t = r(e),
          n = t % 1;
      return t == t ? n ? t - n : t : 0;
    };
  }, function (e, t, n) {
    var r = n(5),
        o = n(15),
        a = /^\s+|\s+$/g,
        i = /^[-+]0x[0-9a-f]+$/i,
        u = /^0b[01]+$/i,
        c = /^0o[0-7]+$/i,
        s = parseInt;

    e.exports = function (e) {
      if ("number" == typeof e) return e;
      if (o(e)) return NaN;

      if (r(e)) {
        var t = "function" == typeof e.valueOf ? e.valueOf() : e;
        e = r(t) ? t + "" : t;
      }

      if ("string" != typeof e) return 0 === e ? e : +e;
      e = e.replace(a, "");
      var n = u.test(e);
      return n || c.test(e) ? s(e.slice(2), n ? 2 : 8) : i.test(e) ? NaN : +e;
    };
  }, function (e, t, n) {
    var r = n(214),
        o = n(7);

    e.exports = function e(t, n, a, i, u) {
      return t === n || (null == t || null == n || !o(t) && !o(n) ? t != t && n != n : r(t, n, a, i, e, u));
    };
  }, function (e, t, n) {
    var r = n(215),
        o = n(218),
        a = n(219);

    e.exports = function (e, t, n, i, u, c) {
      var s = 1 & n,
          l = e.length,
          f = t.length;
      if (l != f && !(s && f > l)) return !1;
      var p = c.get(e);
      if (p && c.get(t)) return p == t;
      var d = -1,
          b = !0,
          h = 2 & n ? new r() : void 0;

      for (c.set(e, t), c.set(t, e); ++d < l;) {
        var y = e[d],
            v = t[d];
        if (i) var m = s ? i(v, y, d, t, e, c) : i(y, v, d, e, t, c);

        if (void 0 !== m) {
          if (m) continue;
          b = !1;
          break;
        }

        if (h) {
          if (!o(t, function (e, t) {
            if (!a(h, t) && (y === e || u(y, e, n, i, c))) return h.push(t);
          })) {
            b = !1;
            break;
          }
        } else if (y !== v && !u(y, v, n, i, c)) {
          b = !1;
          break;
        }
      }

      return c.delete(e), c.delete(t), b;
    };
  }, function (e, t, n) {
    var r = n(5);

    e.exports = function (e) {
      return e == e && !r(e);
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      return function (n) {
        return null != n && n[e] === t && (void 0 !== t || e in Object(n));
      };
    };
  }, function (e, t, n) {
    var r = n(37),
        o = n(111),
        a = n(167),
        i = n(31),
        u = n(12),
        c = n(176),
        s = n(82),
        l = n(79),
        f = s(function (e, t) {
      var n = {};
      if (null == e) return n;
      var s = !1;
      t = r(t, function (t) {
        return t = i(t, e), s || (s = t.length > 1), t;
      }), u(e, l(e), n), s && (n = o(n, 7, c));

      for (var f = t.length; f--;) {
        a(n, t[f]);
      }

      return n;
    });
    e.exports = f;
  }, function (e, t) {
    e.exports = function (e) {
      for (var t = -1, n = null == e ? 0 : e.length, r = 0, o = []; ++t < n;) {
        var a = e[t];
        a && (o[r++] = a);
      }

      return o;
    };
  }, function (e, t, n) {
    var r = n(208),
        o = n(5);

    e.exports = function (e, t, n) {
      var a = !0,
          i = !0;
      if ("function" != typeof e) throw new TypeError("Expected a function");
      return o(n) && (a = "leading" in n ? !!n.leading : a, i = "trailing" in n ? !!n.trailing : i), r(e, t, {
        leading: a,
        maxWait: t,
        trailing: i
      });
    };
  }, function (e, t, n) {
    var r = n(53),
        o = n(210),
        a = n(89),
        i = n(242),
        u = a(function (e, t) {
      if (null == e) return [];
      var n = t.length;
      return n > 1 && i(e, t[0], t[1]) ? t = [] : n > 2 && i(t[0], t[1], t[2]) && (t = [t[0]]), o(e, r(t, 1), []);
    });
    e.exports = u;
  }, function (e, t, n) {
    var r = n(28),
        o = n(53),
        a = n(27),
        i = n(4);

    e.exports = function () {
      var e = arguments.length;
      if (!e) return [];

      for (var t = Array(e - 1), n = arguments[0], u = e; u--;) {
        t[u - 1] = arguments[u];
      }

      return r(i(n) ? a(n) : [n], o(t, 1));
    };
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      var n = "object" == typeof e && e && e.Object === Object && e;
      t.a = n;
    }).call(this, n(40));
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return e && "object" == typeof e && "default" in e ? e.default : e;
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = r(n(0)),
        a = r(n(34));

    function i(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    var u = function u(e) {
      _classCallCheck(this, u);

      i(this, "key", void 0), this.key = e;
    };

    var c = /*#__PURE__*/function (_u) {
      _inherits(c, _u);

      var _super = _createSuper(c);

      function c() {
        _classCallCheck(this, c);

        return _super.apply(this, arguments);
      }

      return c;
    }(u);

    var s = /*#__PURE__*/function (_u2) {
      _inherits(s, _u2);

      var _super2 = _createSuper(s);

      function s() {
        _classCallCheck(this, s);

        return _super2.apply(this, arguments);
      }

      return s;
    }(u);

    var l = {
      AbstractRecoilValue: u,
      RecoilState: c,
      RecoilValueReadOnly: s,
      isRecoilValue: function isRecoilValue(e) {
        return e instanceof c || e instanceof s;
      }
    },
        f = l.AbstractRecoilValue,
        p = l.RecoilState,
        d = l.RecoilValueReadOnly,
        b = l.isRecoilValue;

    function h(e) {
      return e && e.default || e;
    }

    var y = h(Object.freeze({
      __proto__: null,
      AbstractRecoilValue: f,
      RecoilState: p,
      RecoilValueReadOnly: d,
      isRecoilValue: b
    }));

    var v = function v() {
      _classCallCheck(this, v);
    };

    var m = new v();

    var g = /*#__PURE__*/function (_Error) {
      _inherits(g, _Error);

      var _super3 = _createSuper(g);

      function g(e) {
        _classCallCheck(this, g);

        return _super3.call(this, "Tried to set the value of Recoil selector ".concat(e, " using an updater function, but it is an async selector in a pending or error state; this is not supported."));
      }

      return g;
    }( /*#__PURE__*/_wrapNativeSuper(Error));

    var S = new Map();

    var w = /*#__PURE__*/function (_Error2) {
      _inherits(w, _Error2);

      var _super4 = _createSuper(w);

      function w() {
        _classCallCheck(this, w);

        return _super4.apply(this, arguments);
      }

      return w;
    }( /*#__PURE__*/_wrapNativeSuper(Error));

    var O = {
      nodes: S,
      registerNode: function registerNode(e) {
        return S.has(e.key) && e.key, S.set(e.key, e), null == e.set ? new y.RecoilValueReadOnly(e.key) : new y.RecoilState(e.key);
      },
      getNode: function getNode(e) {
        var t = S.get(e);
        if (null == t) throw new w("Missing definition for RecoilValue: \"".concat(e, "\"\""));
        return t;
      },
      NodeMissingError: w,
      DefaultValue: v,
      DEFAULT_VALUE: m,
      RecoilValueNotReady: g
    },
        _ = {
      setByAddingToSet: function setByAddingToSet(e, t) {
        var n = new Set(e);
        return n.add(t), n;
      },
      setByDeletingFromSet: function setByDeletingFromSet(e, t) {
        var n = new Set(e);
        return n.delete(t), n;
      },
      mapBySettingInMap: function mapBySettingInMap(e, t, n) {
        var r = new Map(e);
        return r.set(t, n), r;
      },
      mapByUpdatingInMap: function mapByUpdatingInMap(e, t, n) {
        var r = new Map(e);
        return r.set(t, n(r.get(t))), r;
      },
      mapByDeletingFromMap: function mapByDeletingFromMap(e, t) {
        var n = new Map(e);
        return n.delete(t), n;
      }
    },
        j = function j(e, t, n) {
      return n();
    };

    var A = _.mapByDeletingFromMap,
        R = _.mapBySettingInMap,
        E = _.mapByUpdatingInMap,
        T = _.setByAddingToSet,
        x = O.getNode,
        M = Object.freeze(new Map()),
        k = Object.freeze(new Set());

    var N = /*#__PURE__*/function (_Error3) {
      _inherits(N, _Error3);

      var _super5 = _createSuper(N);

      function N() {
        _classCallCheck(this, N);

        return _super5.apply(this, arguments);
      }

      return N;
    }( /*#__PURE__*/_wrapNativeSuper(Error));

    function V(e, t, n) {
      return x(n).get(e, t);
    }

    var P = 0;

    var C = {
      getNodeLoadable: V,
      peekNodeLoadable: function peekNodeLoadable(e, t, n) {
        return V(e, t, n)[1];
      },
      setNodeValue: function setNodeValue(e, t, n, r) {
        var o = x(n);
        if (null == o.set) throw new N("Attempt to set read-only RecoilValue: " + n);

        var _o$set = o.set(e, t, r),
            _o$set2 = _slicedToArray(_o$set, 2),
            a = _o$set2[0],
            i = _o$set2[1];

        return [a, i];
      },
      setUnvalidatedAtomValue: function setUnvalidatedAtomValue(e, t, n) {
        return _objectSpread(_objectSpread({}, e), {}, {
          atomValues: A(e.atomValues, t),
          nonvalidatedAtoms: R(e.nonvalidatedAtoms, t, n),
          dirtyAtoms: T(e.dirtyAtoms, t)
        });
      },
      subscribeComponentToNode: function subscribeComponentToNode(e, t, n) {
        var r = P++;
        return [_objectSpread(_objectSpread({}, e), {}, {
          nodeToComponentSubscriptions: E(e.nodeToComponentSubscriptions, t, function (e) {
            return R(null != e ? e : M, r, ["TODO debug name", n]);
          })
        }), function (e) {
          return _objectSpread(_objectSpread({}, e), {}, {
            nodeToComponentSubscriptions: E(e.nodeToComponentSubscriptions, t, function (e) {
              return A(null != e ? e : M, r);
            })
          });
        }];
      },
      fireNodeSubscriptions: function fireNodeSubscriptions(e, t, n) {
        var r;

        var o = "enqueue" === n && null !== (r = e.getState().nextTree) && void 0 !== r ? r : e.getState().currentTree,
            a = function (e, t) {
          var n = new Set(),
              r = new Set(),
              o = Array.from(t);

          for (var _t2 = o.pop(); _t2; _t2 = o.pop()) {
            var a;
            n.add(_t2), r.add(_t2);

            var _i = null !== (a = e.nodeToNodeSubscriptions.get(_t2)) && void 0 !== a ? a : k;

            var _iterator = _createForOfIteratorHelper(_i),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var _e2 = _step.value;
                r.has(_e2) || o.push(_e2);
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          }

          return n;
        }(o, t);

        var _iterator2 = _createForOfIteratorHelper(a),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _t3 = _step2.value;
            var i;
            (null !== (i = o.nodeToComponentSubscriptions.get(_t3)) && void 0 !== i ? i : []).forEach(function (_ref) {
              var _ref2 = _slicedToArray(_ref, 2),
                  t = _ref2[0],
                  r = _ref2[1];

              "enqueue" === n ? e.getState().queuedComponentCallbacks.push(r) : r(o);
            });
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        j(0, Array.from(t).join(", "), function () {
          var t = e.getState().suspendedComponentResolvers;
          t.forEach(function (e) {
            return e();
          }), t.clear();
        });
      },
      detectCircularDependencies: function e(t, n) {
        if (!n.length) return;
        var r = n[n.length - 1],
            o = t.nodeToNodeSubscriptions.get(r);
        if (!(null == o ? void 0 : o.size)) return;
        var a = n[0];
        if (o.has(a)) throw new Error("Recoil selector has circular dependencies: " + [].concat(_toConsumableArray(n), [a]).reverse().join(" → "));

        var _iterator3 = _createForOfIteratorHelper(o),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _r = _step3.value;
            e(t, [].concat(_toConsumableArray(n), [_r]));
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
    },
        L = function L(e, t) {
      var n = new Map();
      return e.forEach(function (e, r) {
        n.set(r, t(e, r));
      }), n;
    };

    var I = C.getNodeLoadable,
        D = C.peekNodeLoadable,
        U = C.setNodeValue,
        B = C.setUnvalidatedAtomValue,
        F = C.subscribeComponentToNode,
        $ = O.RecoilValueNotReady,
        z = y.AbstractRecoilValue,
        W = y.RecoilState,
        q = y.RecoilValueReadOnly;
    var H = {
      RecoilValueReadOnly: q,
      AbstractRecoilValue: z,
      RecoilState: W,
      valueFromValueOrUpdater: function valueFromValueOrUpdater(e, _ref3, n) {
        var t = _ref3.key;

        if ("function" == typeof n) {
          var r;

          var _o = e.getState(),
              _a = null !== (r = _o.nextTree) && void 0 !== r ? r : _o.currentTree,
              _i2 = D(e, _a, t);

          if ("loading" === _i2.state) throw new $(t);
          if ("hasError" === _i2.state) throw _i2.contents;
          return n(_i2.contents);
        }

        return n;
      },
      getRecoilValueAsLoadable: function getRecoilValueAsLoadable(e, _ref4) {
        var t = _ref4.key;
        var n;
        return j(0, 0, function () {
          return e.replaceState(function (r) {
            var _I = I(e, r, t),
                _I2 = _slicedToArray(_I, 2),
                o = _I2[0],
                a = _I2[1];

            return n = a, o;
          });
        }), n;
      },
      setRecoilValue: function setRecoilValue(e, _ref5, n) {
        var t = _ref5.key;
        j(0, 0, function () {
          return e.replaceState(function (r) {
            var _U = U(e, r, t, n),
                _U2 = _slicedToArray(_U, 2),
                o = _U2[0],
                a = _U2[1];

            return e.fireNodeSubscriptions(a, "enqueue"), o;
          });
        });
      },
      setUnvalidatedRecoilValue: function setUnvalidatedRecoilValue(e, _ref6, n) {
        var t = _ref6.key;
        j(0, 0, function () {
          return e.replaceState(function (r) {
            var o = B(r, t, n);
            return e.fireNodeSubscriptions(new Set([t]), "enqueue"), o;
          });
        });
      },
      subscribeToRecoilValue: function subscribeToRecoilValue(e, _ref7, n) {
        var t = _ref7.key;
        var r, o;
        return j(0, 0, function () {
          return e.replaceState(function (e) {
            var _F, _F2;

            return (_F = F(e, t, n), _F2 = _slicedToArray(_F, 2), r = _F2[0], o = _F2[1], _F), r;
          });
        }), {
          release: function release(e) {
            return e.replaceState(o);
          }
        };
      }
    };

    function G() {
      return {
        transactionMetadata: {},
        atomValues: new Map(),
        nonvalidatedAtoms: new Map(),
        dirtyAtoms: new Set(),
        nodeDeps: new Map(),
        nodeToNodeSubscriptions: new Map(),
        nodeToComponentSubscriptions: new Map()
      };
    }

    function Y(e) {
      return {
        currentTree: e,
        nextTree: null,
        transactionSubscriptions: new Map(),
        queuedComponentCallbacks: [],
        suspendedComponentResolvers: new Set()
      };
    }

    var X = {
      makeEmptyTreeState: G,
      makeEmptyStoreState: function makeEmptyStoreState() {
        return Y(G());
      },
      makeStoreState: Y
    };
    var J = O.DEFAULT_VALUE,
        K = H.getRecoilValueAsLoadable,
        Q = H.setRecoilValue,
        Z = H.valueFromValueOrUpdater,
        ee = X.makeEmptyTreeState,
        te = X.makeStoreState;

    var ne = /*#__PURE__*/function () {
      function ne(e) {
        var _this = this;

        _classCallCheck(this, ne);

        i(this, "_store", void 0), i(this, "getLoadable", function (e) {
          return K(_this._store, e);
        }), i(this, "getPromise", function (e) {
          return _this.getLoadable(e).toPromise();
        }), i(this, "map", function (e) {
          var t = new ae(_this._store.getState().currentTree);
          return e(t), oe(t.getStore_INTERNAL().getState().currentTree);
        }), i(this, "asyncMap", /*#__PURE__*/function () {
          var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
            var t;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    t = new ae(_this._store.getState().currentTree);
                    _context.next = 3;
                    return e(t);

                  case 3:
                    return _context.abrupt("return", oe(t.getStore_INTERNAL().getState().currentTree));

                  case 4:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function (_x) {
            return _ref8.apply(this, arguments);
          };
        }()), this._store = function (e) {
          var t = te(e);
          return {
            getState: function getState() {
              return t;
            },
            replaceState: function replaceState(e) {
              t.currentTree = e(t.currentTree);
            },
            subscribeToTransactions: function subscribeToTransactions() {
              throw new Error("Cannot subscribe to Snapshots");
            },
            addTransactionMetadata: function addTransactionMetadata() {
              throw new Error("Cannot subscribe to Snapshots");
            },
            fireNodeSubscriptions: function fireNodeSubscriptions() {}
          };
        }(e);
      }

      _createClass(ne, [{
        key: "getStore_INTERNAL",
        value: function getStore_INTERNAL() {
          return this._store;
        }
      }]);

      return ne;
    }();

    function re(e) {
      return {
        transactionMetadata: _objectSpread({}, e.transactionMetadata),
        atomValues: new Map(e.atomValues),
        nonvalidatedAtoms: new Map(e.nonvalidatedAtoms),
        dirtyAtoms: new Set(e.dirtyAtoms),
        nodeDeps: new Map(e.nodeDeps),
        nodeToNodeSubscriptions: L(e.nodeToNodeSubscriptions, function (e) {
          return new Set(e);
        }),
        nodeToComponentSubscriptions: new Map()
      };
    }

    function oe(e) {
      return new ne(re(e));
    }

    var ae = /*#__PURE__*/function (_ne) {
      _inherits(ae, _ne);

      var _super6 = _createSuper(ae);

      function ae(e) {
        var _this2;

        _classCallCheck(this, ae);

        _this2 = _super6.call(this, re(e)), i(_assertThisInitialized(_this2), "set", function (e, t) {
          var n = _this2.getStore_INTERNAL(),
              r = Z(n, e, t);

          Q(n, e, r);
        }), i(_assertThisInitialized(_this2), "reset", function (e) {
          return Q(_this2.getStore_INTERNAL(), e, J);
        });
        return _this2;
      }

      return ae;
    }(ne);

    var ie = {
      Snapshot: ne,
      MutableSnapshot: ae,
      freshSnapshot: function freshSnapshot() {
        return new ne(ee());
      },
      cloneSnapshot: oe
    },
        ue = ie.Snapshot,
        ce = ie.MutableSnapshot,
        se = ie.freshSnapshot,
        le = ie.cloneSnapshot,
        fe = function fe(e, t) {
      if (null != e) return e;
      throw new Error(null != t ? t : "Got unexpected null or undefined");
    },
        pe = h(Object.freeze({
      __proto__: null,
      Snapshot: ue,
      MutableSnapshot: ce,
      freshSnapshot: se,
      cloneSnapshot: le
    }));

    var de = o.useContext,
        be = o.useEffect,
        he = o.useRef,
        ye = o.useState,
        ve = C.fireNodeSubscriptions,
        me = C.setNodeValue,
        ge = C.setUnvalidatedAtomValue,
        Se = pe.freshSnapshot,
        we = X.makeEmptyStoreState,
        Oe = X.makeStoreState;

    function _e() {
      throw new Error("This component must be used inside a <RecoilRoot> component.");
    }

    var je = Object.freeze({
      getState: _e,
      replaceState: _e,
      subscribeToTransactions: _e,
      addTransactionMetadata: _e,
      fireNodeSubscriptions: _e
    });

    function Ae(e) {
      null === e.nextTree && (e.nextTree = _objectSpread(_objectSpread({}, e.currentTree), {}, {
        dirtyAtoms: new Set(),
        transactionMetadata: {}
      }));
    }

    var Re = o.createContext({
      current: je
    }),
        Ee = function Ee() {
      return de(Re);
    };

    function Te(e) {
      var t = Ee(),
          _ye = ye([]),
          _ye2 = _slicedToArray(_ye, 2),
          n = _ye2[0],
          r = _ye2[1];

      return e.setNotifyBatcherOfChange(function () {
        return r({});
      }), be(function () {
        !function (e, t) {
          t();
        }(0, function () {
          var e = t.current.getState(),
              n = e.nextTree;
          null !== n && (n.dirtyAtoms.size && e.transactionSubscriptions.forEach(function (e) {
            return e(t.current);
          }), e.queuedComponentCallbacks.forEach(function (e) {
            return e(n);
          }), e.queuedComponentCallbacks.splice(0, e.queuedComponentCallbacks.length), e.currentTree = n, e.nextTree = null);
        });
      }), null;
    }

    var xe = 0;

    var Me = {
      useStoreRef: Ee,
      RecoilRoot: function RecoilRoot(_ref9) {
        var e = _ref9.initializeState_DEPRECATED,
            t = _ref9.initializeState,
            n = _ref9.children;
        var r;
        var a = he(null),
            i = {
          getState: function getState() {
            return r.current;
          },
          replaceState: function replaceState(e) {
            var t = u.current.getState();
            Ae(t);
            var n = fe(t.nextTree),
                r = e(n);
            r !== n && (t.nextTree = r, fe(a.current)());
          },
          subscribeToTransactions: function subscribeToTransactions(e) {
            var t = xe++;
            return u.current.getState().transactionSubscriptions.set(t, e), {
              release: function release() {
                u.current.getState().transactionSubscriptions.delete(t);
              }
            };
          },
          addTransactionMetadata: function addTransactionMetadata(e) {
            Ae(u.current.getState());

            for (var _i3 = 0, _Object$keys = Object.keys(e); _i3 < _Object$keys.length; _i3++) {
              var _t4 = _Object$keys[_i3];
              fe(u.current.getState().nextTree).transactionMetadata[_t4] = e[_t4];
            }
          },
          fireNodeSubscriptions: function fireNodeSubscriptions(e, t) {
            ve(u.current, e, t);
          }
        },
            u = he(i);
        return r = he(null != e ? function (e, t) {
          var n = we();
          return t({
            set: function set(t, r) {
              n.currentTree = me(e, n.currentTree, t.key, r)[0];
            },
            setUnvalidatedAtomValues: function setUnvalidatedAtomValues(e) {
              e.forEach(function (e, t) {
                n.currentTree = ge(n.currentTree, t, e);
              });
            }
          }), n;
        }(i, e) : null != t ? function (e) {
          var t = Se().map(e);
          return Oe(t.getStore_INTERNAL().getState().currentTree);
        }(t) : we()), o.createElement(Re.Provider, {
          value: u
        }, o.createElement(Te, {
          setNotifyBatcherOfChange: function setNotifyBatcherOfChange(e) {
            a.current = e;
          }
        }), n);
      }
    },
        ke = function ke(e) {
      var n = new Set();

      for (var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        t[_key - 1] = arguments[_key];
      }

      var _iterator4 = _createForOfIteratorHelper(e),
          _step4;

      try {
        e: for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _r2 = _step4.value;

          var _iterator5 = _createForOfIteratorHelper(t),
              _step5;

          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var _e3 = _step5.value;
              if (_e3.has(_r2)) continue e;
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }

          n.add(_r2);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      return n;
    };

    var Ne = o.useCallback,
        Ve = o.useEffect,
        Pe = o.useMemo,
        Ce = o.useRef,
        Le = o.useState,
        Ie = C.peekNodeLoadable,
        De = C.setNodeValue,
        Ue = O.DEFAULT_VALUE,
        Be = O.getNode,
        Fe = O.nodes,
        $e = Me.useStoreRef,
        ze = H.AbstractRecoilValue,
        We = H.getRecoilValueAsLoadable,
        qe = H.setRecoilValue,
        He = H.setUnvalidatedRecoilValue,
        Ge = H.subscribeToRecoilValue,
        Ye = H.valueFromValueOrUpdater,
        Xe = pe.Snapshot,
        Je = pe.cloneSnapshot,
        Ke = _.setByAddingToSet;

    function Qe() {
      var e = $e(),
          _Le = Le([]),
          _Le2 = _slicedToArray(_Le, 2),
          t = _Le2[0],
          n = _Le2[1],
          r = Ce(new Set());

      r.current = new Set();
      var o = Ce(new Set()),
          a = Ce(new Map()),
          i = Ne(function (t) {
        var n = a.current.get(t);
        n && (n.release(e.current), a.current.delete(t));
      }, [e, a]);
      return Ve(function () {
        var t = e.current;

        function u(e, t) {
          a.current.has(t) && n([]);
        }

        ke(r.current, o.current).forEach(function (e) {
          if (a.current.has(e)) return;
          var n = Ge(t, new ze(e), function (t) {
            j(0, 0, function () {
              u(0, e);
            });
          });
          a.current.set(e, n), j(0, 0, function () {
            u(t.getState(), e);
          });
        }), ke(o.current, r.current).forEach(function (e) {
          i(e);
        }), o.current = r.current;
      }), Ve(function () {
        var e = a.current;
        return function () {
          return e.forEach(function (e, t) {
            return i(t);
          });
        };
      }, [i]), Pe(function () {
        function t(t) {
          return function (n) {
            var r = Ye(e.current, t, n);
            qe(e.current, t, r);
          };
        }

        function n(t) {
          return r.current.has(t.key) || (r.current = Ke(r.current, t.key)), We(e.current, t);
        }

        function o(t) {
          return function (e, t, n) {
            if ("hasValue" === e.state) return e.contents;
            if ("loading" === e.state) throw new Promise(function (e) {
              n.current.getState().suspendedComponentResolvers.add(e);
            });
            throw "hasError" === e.state ? e.contents : new Error("Invalid value of loadable atom \"".concat(t.key, "\""));
          }(n(t), t, e);
        }

        return {
          getRecoilValue: o,
          getRecoilValueLoadable: n,
          getRecoilState: function getRecoilState(e) {
            return [o(e), t(e)];
          },
          getRecoilStateLoadable: function getRecoilStateLoadable(e) {
            return [n(e), t(e)];
          },
          getSetRecoilState: t,
          getResetRecoilState: function getResetRecoilState(t) {
            return function () {
              return qe(e.current, t, Ue);
            };
          }
        };
      }, [r, e]);
    }

    function Ze(e) {
      var t = $e();
      Ve(function () {
        return t.current.subscribeToTransactions(e).release;
      }, [e, t]);
    }

    function et(e) {
      var t = e.atomValues,
          n = L(function (e, t) {
        var n = new Map();

        var _iterator6 = _createForOfIteratorHelper(e),
            _step6;

        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var _step6$value = _slicedToArray(_step6.value, 2),
                _r3 = _step6$value[0],
                _o2 = _step6$value[1];

            t(_o2, _r3) && n.set(_r3, _o2);
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }

        return n;
      }(t, function (e, t) {
        var n;
        var r = null === (n = Be(t).options) || void 0 === n ? void 0 : n.persistence_UNSTABLE;
        return null != r && "none" !== r.type && "hasValue" === e.state;
      }), function (e) {
        return e.contents;
      });
      return function () {
        var t = new Map();

        for (var _len2 = arguments.length, e = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          e[_key2] = arguments[_key2];
        }

        for (var _n2 = 0; _n2 < e.length; _n2++) {
          var _r4 = e[_n2].keys();

          var _o3 = void 0;

          for (; !(_o3 = _r4.next()).done;) {
            t.set(_o3.value, e[_n2].get(_o3.value));
          }
        }

        return t;
      }(e.nonvalidatedAtoms, n);
    }

    function tt() {
      var e = $e();
      return Ne(function (t) {
        a.unstable_batchedUpdates(function () {
          e.current.replaceState(function (n) {
            var r = t.getStore_INTERNAL().getState().currentTree,
                o = new Set();

            for (var _i4 = 0, _arr = [n.atomValues.keys(), r.atomValues.keys()]; _i4 < _arr.length; _i4++) {
              var _e4 = _arr[_i4];

              var _iterator7 = _createForOfIteratorHelper(_e4),
                  _step7;

              try {
                for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                  var _t5 = _step7.value;
                  var a, i;
                  (null === (a = n.atomValues.get(_t5)) || void 0 === a ? void 0 : a.contents) !== (null === (i = r.atomValues.get(_t5)) || void 0 === i ? void 0 : i.contents) && o.add(_t5);
                }
              } catch (err) {
                _iterator7.e(err);
              } finally {
                _iterator7.f();
              }
            }

            return e.current.fireNodeSubscriptions(o, "enqueue"), _objectSpread(_objectSpread({}, r), {}, {
              nodeToComponentSubscriptions: n.nodeToComponentSubscriptions
            });
          });
        });
      }, [e]);
    }

    var nt = function nt() {
      _classCallCheck(this, nt);
    };

    var rt = new nt();

    var ot = {
      useRecoilCallback: function useRecoilCallback(e, t) {
        var n = $e(),
            r = tt();
        return Ne(function () {
          for (var _len3 = arguments.length, t = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            t[_key3] = arguments[_key3];
          }

          var o = Je(n.current.getState().currentTree);

          function i(e, t) {
            var r = Ye(n.current, e, t);
            qe(n.current, e, r);
          }

          function u(e) {
            qe(n.current, e, Ue);
          }

          var c = rt;
          return a.unstable_batchedUpdates(function () {
            c = e({
              set: i,
              reset: u,
              snapshot: o,
              gotoSnapshot: r
            }).apply(void 0, t);
          }), c instanceof nt && function (e, t) {
            throw new Error(void 0);
          }(), c;
        }, null != t ? [].concat(_toConsumableArray(t), [n]) : void 0);
      },
      useRecoilValue: function useRecoilValue(e) {
        return Qe().getRecoilValue(e);
      },
      useRecoilValueLoadable: function useRecoilValueLoadable(e) {
        return Qe().getRecoilValueLoadable(e);
      },
      useRecoilState: function useRecoilState(e) {
        var t = Qe(),
            _t$getRecoilState = t.getRecoilState(e),
            _t$getRecoilState2 = _slicedToArray(_t$getRecoilState, 1),
            n = _t$getRecoilState2[0];

        return [n, Ne(t.getSetRecoilState(e), [e])];
      },
      useRecoilStateLoadable: function useRecoilStateLoadable(e) {
        var t = Qe(),
            _t$getRecoilStateLoad = t.getRecoilStateLoadable(e),
            _t$getRecoilStateLoad2 = _slicedToArray(_t$getRecoilStateLoad, 1),
            n = _t$getRecoilStateLoad2[0];

        return [n, Ne(t.getSetRecoilState(e), [e])];
      },
      useSetRecoilState: function useSetRecoilState(e) {
        return Ne(Qe().getSetRecoilState(e), [e]);
      },
      useResetRecoilState: function useResetRecoilState(e) {
        return Ne(Qe().getResetRecoilState(e), [e]);
      },
      useRecoilInterface: Qe,
      useSnapshotWithStateChange_DEPRECATED: function useSnapshotWithStateChange_DEPRECATED(e) {
        var t = $e();

        var n = function () {
          var _Le3 = Le(0),
              _Le4 = _slicedToArray(_Le3, 2),
              e = _Le4[0],
              t = _Le4[1];

          return Ze(Ne(function () {
            return t(function (e) {
              return e + 1;
            });
          }, [])), {
            transactionMetadata: _objectSpread({}, (n = $e().current.getState().currentTree).transactionMetadata),
            atomValues: new Map(n.atomValues),
            nonvalidatedAtoms: new Map(n.nonvalidatedAtoms),
            dirtyAtoms: new Set(n.dirtyAtoms),
            nodeDeps: new Map(n.nodeDeps),
            nodeToNodeSubscriptions: L(n.nodeToNodeSubscriptions, function (e) {
              return new Set(e);
            }),
            nodeToComponentSubscriptions: L(n.nodeToComponentSubscriptions, function (e) {
              return new Map(e);
            })
          };
          var n;
        }();

        e(function (_ref10, r) {
          var e = _ref10.key;

          var _De = De(t.current, n, e, Ie(t.current, n, e).map(r));

          var _De2 = _slicedToArray(_De, 1);

          n = _De2[0];
        });

        var r = L(n.atomValues, function (e) {
          return e.contents;
        }),
            o = function (e) {
          var n = new Set();

          for (var _len4 = arguments.length, t = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
            t[_key4 - 1] = arguments[_key4];
          }

          var _iterator8 = _createForOfIteratorHelper(e),
              _step8;

          try {
            e: for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
              var _r5 = _step8.value;

              var _iterator9 = _createForOfIteratorHelper(t),
                  _step9;

              try {
                for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                  var _e5 = _step9.value;
                  if (!_e5.has(_r5)) continue e;
                }
              } catch (err) {
                _iterator9.e(err);
              } finally {
                _iterator9.f();
              }

              n.add(_r5);
            }
          } catch (err) {
            _iterator8.e(err);
          } finally {
            _iterator8.f();
          }

          return n;
        }(n.dirtyAtoms, new Set(r.keys()));

        return {
          atomValues: r,
          updatedAtoms: o
        };
      },
      useTransactionSubscription_DEPRECATED: Ze,
      useTransactionObservation_DEPRECATED: function useTransactionObservation_DEPRECATED(e) {
        Ze(Ne(function (t) {
          var n = t.getState().currentTree;
          var r = t.getState().nextTree;
          r || (r = t.getState().currentTree);
          var o = et(r),
              a = et(n),
              i = L(Fe, function (e) {
            var t, n, r, o, a, i;
            return {
              persistence_UNSTABLE: {
                type: null !== (t = null === (n = e.options) || void 0 === n || null === (r = n.persistence_UNSTABLE) || void 0 === r ? void 0 : r.type) && void 0 !== t ? t : "none",
                backButton: null !== (o = null === (a = e.options) || void 0 === a || null === (i = a.persistence_UNSTABLE) || void 0 === i ? void 0 : i.backButton) && void 0 !== o && o
              }
            };
          }),
              u = new Set(r.dirtyAtoms);
          e({
            atomValues: o,
            previousAtomValues: a,
            atomInfo: i,
            modifiedAtoms: u,
            transactionMetadata: _objectSpread({}, r.transactionMetadata)
          });
        }, [e]));
      },
      useRecoilTransactionObserver: function useRecoilTransactionObserver(e) {
        Ze(Ne(function (t) {
          var n = t.getState().currentTree;
          var r = t.getState().nextTree;
          r || (r = n), e({
            snapshot: Je(r),
            previousSnapshot: Je(n)
          });
        }, [e]));
      },
      useRecoilSnapshot: function useRecoilSnapshot() {
        var e = $e(),
            _Le5 = Le(function () {
          return Je(e.current.getState().currentTree);
        }),
            _Le6 = _slicedToArray(_Le5, 2),
            t = _Le6[0],
            n = _Le6[1];

        return Ze(Ne(function (e) {
          var t;
          return n(Je(null !== (t = e.getState().nextTree) && void 0 !== t ? t : e.getState().currentTree));
        }, [])), t;
      },
      useGoToSnapshot_DEPRECATED: function useGoToSnapshot_DEPRECATED() {
        var e = $e();
        return function (t) {
          a.unstable_batchedUpdates(function () {
            t.updatedAtoms.forEach(function (n) {
              qe(e.current, new ze(n), t.atomValues.get(n));
            });
          });
        };
      },
      useGotoRecoilSnapshot: tt,
      useSetUnvalidatedAtomValues: function useSetUnvalidatedAtomValues() {
        var e = $e();
        return function (t) {
          var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          a.unstable_batchedUpdates(function () {
            e.current.addTransactionMetadata(n), t.forEach(function (t, n) {
              return He(e.current, new ze(n), t);
            });
          });
        };
      }
    },
        at = function at(e) {
      return !!e && "function" == typeof e.then;
    };

    var it = {
      getValue: function getValue() {
        if ("hasValue" !== this.state) throw this.contents;
        return this.contents;
      },
      toPromise: function toPromise() {
        return "hasValue" === this.state ? Promise.resolve(this.contents) : "hasError" === this.state ? Promise.reject(this.contents) : this.contents;
      },
      valueMaybe: function valueMaybe() {
        return "hasValue" === this.state ? this.contents : void 0;
      },
      valueOrThrow: function valueOrThrow() {
        if ("hasValue" !== this.state) throw new Error("Loadable expected value, but in \"".concat(this.state, "\" state"));
        return this.contents;
      },
      errorMaybe: function errorMaybe() {
        return "hasError" === this.state ? this.contents : void 0;
      },
      errorOrThrow: function errorOrThrow() {
        if ("hasError" !== this.state) throw new Error("Loadable expected error, but in \"".concat(this.state, "\" state"));
        return this.contents;
      },
      promiseMaybe: function promiseMaybe() {
        return "loading" === this.state ? this.contents : void 0;
      },
      promiseOrThrow: function promiseOrThrow() {
        if ("loading" !== this.state) throw new Error("Loadable expected promise, but in \"".concat(this.state, "\" state"));
        return this.contents;
      },
      map: function map(e) {
        var _this3 = this;

        if ("hasError" === this.state) return this;
        if ("hasValue" === this.state) try {
          var _t6 = e(this.contents);

          return at(_t6) ? st(_t6) : ut(_t6);
        } catch (t) {
          return at(t) ? st(t.next(function () {
            return e(_this3.contents);
          })) : ct(t);
        }
        if ("loading" === this.state) return st(this.contents.then(e).catch(function (t) {
          if (at(t)) return t.then(function () {
            return e(_this3.contents);
          });
          throw t;
        }));
        throw new Error("Invalid Loadable state");
      }
    };

    function ut(e) {
      return Object.freeze(_objectSpread({
        state: "hasValue",
        contents: e
      }, it));
    }

    function ct(e) {
      return Object.freeze(_objectSpread({
        state: "hasError",
        contents: e
      }, it));
    }

    function st(e) {
      return Object.freeze(_objectSpread({
        state: "loading",
        contents: e
      }, it));
    }

    var lt = {
      loadableWithValue: ut,
      loadableWithError: ct,
      loadableWithPromise: st,
      loadableLoading: function loadableLoading() {
        return st(new Promise(function () {}));
      },
      loadableAll: function loadableAll(e) {
        return e.every(function (e) {
          return "hasValue" === e.state;
        }) ? ut(e.map(function (e) {
          return e.contents;
        })) : e.some(function (e) {
          return "hasError" === e.state;
        }) ? ct(fe(e.find(function (e) {
          return "hasError" === e.state;
        }), "Invalid loadable passed to loadableAll").contents) : st(Promise.all(e.map(function (e) {
          return e.contents;
        })));
      }
    },
        ft = function e(t) {
      if ("object" == typeof t && !function (e) {
        if (null === e || "object" != typeof e) return !0;

        switch (typeof e.$$typeof) {
          case "symbol":
          case "number":
            return !0;
        }

        return null != e["@@__IMMUTABLE_ITERABLE__@@"] || null != e["@@__IMMUTABLE_KEYED__@@"] || null != e["@@__IMMUTABLE_INDEXED__@@"] || null != e["@@__IMMUTABLE_ORDERED__@@"] || null != e["@@__IMMUTABLE_RECORD__@@"] || !!function (e) {
          var t, n;
          if ("undefined" == typeof window) return !1;
          var r = null !== (n = (null != e ? null !== (t = e.ownerDocument) && void 0 !== t ? t : e : document).defaultView) && void 0 !== n ? n : window;
          return !(null == e || !("function" == typeof r.Node ? e instanceof r.Node : "object" == typeof e && "number" == typeof e.nodeType && "string" == typeof e.nodeName));
        }(e) || !!at(e);
      }(t)) {
        Object.freeze(t);

        for (var _n3 in t) {
          if (Object.prototype.hasOwnProperty.call(t, _n3)) {
            var _r6 = t[_n3];
            "object" != typeof _r6 || null == _r6 || Object.isFrozen(_r6) || e(_r6);
          }
        }

        Object.seal(t);
      }
    };

    var pt = Symbol("ArrayKeyedMap"),
        dt = new Map();

    var bt = /*#__PURE__*/function () {
      function bt(e) {
        _classCallCheck(this, bt);

        if (this._base = new Map(), e instanceof bt) {
          var _iterator10 = _createForOfIteratorHelper(e.entries()),
              _step10;

          try {
            for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
              var _step10$value = _slicedToArray(_step10.value, 2),
                  _t7 = _step10$value[0],
                  _n4 = _step10$value[1];

              this.set(_t7, _n4);
            }
          } catch (err) {
            _iterator10.e(err);
          } finally {
            _iterator10.f();
          }
        } else if (e) {
          var _iterator11 = _createForOfIteratorHelper(e),
              _step11;

          try {
            for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
              var _step11$value = _slicedToArray(_step11.value, 2),
                  _t8 = _step11$value[0],
                  _n5 = _step11$value[1];

              this.set(_t8, _n5);
            }
          } catch (err) {
            _iterator11.e(err);
          } finally {
            _iterator11.f();
          }
        }

        return this;
      }

      _createClass(bt, [{
        key: "get",
        value: function get(e) {
          var t = Array.isArray(e) ? e : [e];
          var n = this._base;
          return t.forEach(function (e) {
            var t;
            n = null !== (t = n.get(e)) && void 0 !== t ? t : dt;
          }), void 0 === n ? void 0 : n.get(pt);
        }
      }, {
        key: "set",
        value: function set(e, t) {
          var n = Array.isArray(e) ? e : [e];
          var r = this._base,
              o = r;
          return n.forEach(function (e) {
            o = r.get(e), o || (o = new Map(), r.set(e, o)), r = o;
          }), o.set(pt, t), this;
        }
      }, {
        key: "delete",
        value: function _delete(e) {
          var t = Array.isArray(e) ? e : [e];
          var n = this._base,
              r = n;
          return t.forEach(function (e) {
            r = n.get(e), r || (r = new Map(), n.set(e, r)), n = r;
          }), r.delete(pt), this;
        }
      }, {
        key: "entries",
        value: function entries() {
          var e = [];
          return function t(n, r) {
            n.forEach(function (n, o) {
              o === pt ? e.push([r, n]) : t(n, r.concat(o));
            });
          }(this._base, []), e.values();
        }
      }, {
        key: "toBuiltInMap",
        value: function toBuiltInMap() {
          return new Map(this.entries());
        }
      }]);

      return bt;
    }();

    var ht = bt,
        yt = function yt() {
      return new ht();
    },
        vt = function vt(e, t, n) {
      var r = e.entries();
      var o = r.next();

      for (; !o.done;) {
        var _a2 = o.value;
        if (!t.call(n, _a2[1], _a2[0], e)) return !1;
        o = r.next();
      }

      return !0;
    };

    Object.freeze(new Set());
    var mt = _.mapBySettingInMap,
        gt = _.mapByUpdatingInMap,
        St = _.setByAddingToSet,
        wt = _.setByDeletingFromSet,
        Ot = C.detectCircularDependencies,
        _t = C.getNodeLoadable,
        jt = C.setNodeValue,
        At = lt.loadableWithError,
        Rt = lt.loadableWithPromise,
        Et = lt.loadableWithValue,
        Tt = O.DEFAULT_VALUE,
        xt = O.RecoilValueNotReady,
        Mt = O.registerNode,
        _startPerfBlock = {
      startPerfBlock: function startPerfBlock(e) {
        return function () {
          return null;
        };
      }
    },
        kt = _startPerfBlock.startPerfBlock,
        Nt = y.isRecoilValue,
        Vt = Object.freeze(new Set());

    function Pt(e) {
      var t = [];

      var _iterator12 = _createForOfIteratorHelper(Array.from(e.keys()).sort()),
          _step12;

      try {
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          var _n6 = _step12.value;

          var _r7 = fe(e.get(_n6));

          t.push(_n6), t.push(_r7.contents);
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }

      return t;
    }

    var Ct = function Ct(e) {
      var t = e.key,
          n = e.get,
          r = e.cacheImplementation_UNSTABLE,
          o = null != e.set ? e.set : void 0;
      var a = null != r ? r : yt();

      function i(r, o) {
        var u;
        var c = o;
        var s = null !== (u = o.nodeDeps.get(t)) && void 0 !== u ? u : Vt,
            l = Pt(new Map(Array.from(s).sort().map(function (e) {
          var _t9 = _t(r, c, e),
              _t10 = _slicedToArray(_t9, 2),
              t = _t10[0],
              n = _t10[1];

          return c = t, [e, n];
        }))),
            f = a.get(l);
        if (null != f) return [c, f];

        var _ref11 = function (e, r) {
          var o;

          var _ref13 = function (e, r) {
            var o = kt(t);
            var a = r;
            var u = new Map();

            function c(_ref15) {
              var _t11, _t12;

              var t = _ref15.key;
              var n;
              if ((_t11 = _t(e, a, t), _t12 = _slicedToArray(_t11, 2), a = _t12[0], n = _t12[1], _t11), u.set(t, n), "hasValue" === n.state) return n.contents;
              throw n.contents;
            }

            try {
              var _e6 = n({
                get: c
              }),
                  _t13 = Nt(_e6) ? c(_e6) : _e6,
                  _r8 = at(_t13) ? Rt(_t13.finally(o)) : (o(), Et(_t13));

              return [a, _r8, u];
            } catch (t) {
              var _n7 = at(t) ? Rt(t.then(function () {
                var t = At(new Error("Internal Recoil Selector Error"));
                if (e.replaceState(function (n) {
                  var _i5, _i6;

                  var r;
                  return (_i5 = i(e, n), _i6 = _slicedToArray(_i5, 2), r = _i6[0], t = _i6[1], _i5), r;
                }), "hasError" === t.state) throw t.contents;
                return t.contents;
              }).finally(o)) : (o(), At(t));

              return [a, _n7, u];
            }
          }(e, r),
              _ref14 = _slicedToArray(_ref13, 3),
              a = _ref14[0],
              u = _ref14[1],
              c = _ref14[2];

          var s = a;
          var l = null !== (o = r.nodeDeps.get(t)) && void 0 !== o ? o : Vt,
              f = new Set(c.keys());
          var p, d;
          d = f, s = (p = l).size === d.size && vt(p, function (e) {
            return d.has(e);
          }) ? s : _objectSpread(_objectSpread({}, s), {}, {
            nodeDeps: mt(s.nodeDeps, t, f)
          });
          var b = ke(f, l),
              h = ke(l, f);

          var _iterator13 = _createForOfIteratorHelper(b),
              _step13;

          try {
            for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
              var _e7 = _step13.value;
              s = _objectSpread(_objectSpread({}, s), {}, {
                nodeToNodeSubscriptions: gt(s.nodeToNodeSubscriptions, _e7, function (e) {
                  return St(null != e ? e : Vt, t);
                })
              });
            }
          } catch (err) {
            _iterator13.e(err);
          } finally {
            _iterator13.f();
          }

          var _iterator14 = _createForOfIteratorHelper(h),
              _step14;

          try {
            for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
              var _e8 = _step14.value;
              s = _objectSpread(_objectSpread({}, s), {}, {
                nodeToNodeSubscriptions: gt(s.nodeToNodeSubscriptions, _e8, function (e) {
                  return wt(null != e ? e : Vt, t);
                })
              });
            }
          } catch (err) {
            _iterator14.e(err);
          } finally {
            _iterator14.f();
          }

          return [s, u, c];
        }(r, c),
            _ref12 = _slicedToArray(_ref11, 3),
            p = _ref12[0],
            d = _ref12[1],
            b = _ref12[2];

        c = p;
        var h = Pt(b);
        return function (n, r, o) {
          "loading" !== o.state ? 1 == !e.dangerouslyAllowMutability && ft(o.contents) : o.contents.then(function (o) {
            return 1 == !e.dangerouslyAllowMutability && ft(o), a = a.set(r, Et(o)), n.fireNodeSubscriptions(new Set([t]), "now"), o;
          }).catch(function (o) {
            return at(o) || (1 == !e.dangerouslyAllowMutability && ft(o), a = a.set(r, At(o)), n.fireNodeSubscriptions(new Set([t]), "now")), o;
          }), a = a.set(r, o);
        }(r, h, d), [c, d];
      }

      function u(e, t) {
        return i(e, t);
      }

      return Mt(null != o ? {
        key: t,
        options: e,
        get: u,
        set: function set(e, t, n) {
          var r = t;
          var a = new Set();

          function i(_ref16) {
            var t = _ref16.key;

            var _t14 = _t(e, r, t),
                _t15 = _slicedToArray(_t14, 2),
                n = _t15[0],
                o = _t15[1];

            if (r = n, "hasValue" === o.state) return o.contents;
            throw "loading" === o.state ? new xt(t) : o.contents;
          }

          function u(t, n) {
            var _jt, _jt2;

            var o = "function" == typeof n ? n(i(t)) : n;
            var u;
            (_jt = jt(e, r, t.key, o), _jt2 = _slicedToArray(_jt, 2), r = _jt2[0], u = _jt2[1], _jt), u.forEach(function (e) {
              return a.add(e);
            });
          }

          return o({
            set: u,
            get: i,
            reset: function reset(e) {
              u(e, Tt);
            }
          }, n), [r, a];
        }
      } : {
        key: t,
        options: e,
        get: u
      });
    };

    var Lt = lt.loadableWithValue,
        It = O.DEFAULT_VALUE,
        Dt = O.DefaultValue,
        Ut = O.registerNode,
        Bt = y.isRecoilValue,
        Ft = _.mapByDeletingFromMap,
        $t = _.mapBySettingInMap,
        zt = _.setByAddingToSet;

    var Wt = function e(t) {
      var n = t.default,
          r = _objectWithoutProperties(t, ["default"]);

      return Bt(n) || at(n) ? function (t) {
        var n = e(_objectSpread(_objectSpread({}, t), {}, {
          default: It,
          persistence_UNSTABLE: void 0 === t.persistence_UNSTABLE ? void 0 : _objectSpread(_objectSpread({}, t.persistence_UNSTABLE), {}, {
            validator: function validator(e) {
              return e instanceof Dt ? e : fe(t.persistence_UNSTABLE).validator(e, It);
            }
          })
        }));
        return Ct({
          key: t.key + "__withFallback",
          get: function get(_ref17) {
            var e = _ref17.get;
            var r = e(n);
            return r instanceof Dt ? t.default : r;
          },
          set: function set(_ref18, t) {
            var e = _ref18.set;
            return e(n, t);
          },
          dangerouslyAllowMutability: t.dangerouslyAllowMutability
        });
      }(_objectSpread(_objectSpread({}, r), {}, {
        default: n
      })) : function (e) {
        var t = e.key,
            n = e.persistence_UNSTABLE;
        return Ut({
          key: t,
          options: e,
          get: function get(r, o) {
            if (o.atomValues.has(t)) return [o, fe(o.atomValues.get(t))];

            if (o.nonvalidatedAtoms.has(t)) {
              if (null == n) return [o, Lt(e.default)];

              var _r9 = o.nonvalidatedAtoms.get(t),
                  _a3 = n.validator(_r9, It);

              return _a3 instanceof Dt ? [_objectSpread(_objectSpread({}, o), {}, {
                nonvalidatedAtoms: Ft(o.nonvalidatedAtoms, t)
              }), Lt(e.default)] : [_objectSpread(_objectSpread({}, o), {}, {
                atomValues: $t(o.atomValues, t, Lt(_a3)),
                nonvalidatedAtoms: Ft(o.nonvalidatedAtoms, t)
              }), Lt(_a3)];
            }

            return [o, Lt(e.default)];
          },
          set: function set(n, r, o) {
            return !0 !== e.dangerouslyAllowMutability && ft(o), [_objectSpread(_objectSpread({}, r), {}, {
              dirtyAtoms: zt(r.dirtyAtoms, t),
              atomValues: o instanceof Dt ? Ft(r.atomValues, t) : $t(r.atomValues, t, Lt(o)),
              nonvalidatedAtoms: Ft(r.nonvalidatedAtoms, t)
            }), new Set([t])];
          }
        });
      }(_objectSpread(_objectSpread({}, r), {}, {
        default: n
      }));
    },
        qt = function qt(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        allowFunctions: !1
      };
      return function e(t, n, r) {
        if ("string" == typeof t && !t.includes('"') && !t.includes("\\")) return "\"".concat(t, "\"");

        switch (typeof t) {
          case "undefined":
            return "";

          case "boolean":
            return t ? "true" : "false";

          case "number":
          case "symbol":
            return String(t);

          case "string":
            return JSON.stringify(t);

          case "function":
            if (!0 !== (null == n ? void 0 : n.allowFunctions)) throw new Error("Attempt to serialize function in a Recoil cache key");
            return "__FUNCTION(".concat(t.name, ")__");
        }

        return null === t ? "null" : "object" != typeof t ? null !== (o = JSON.stringify(t)) && void 0 !== o ? o : "" : at(t) ? "__PROMISE__" : Array.isArray(t) ? "[".concat(t.map(function (t, r) {
          return e(t, n, r.toString());
        }), "]") : "function" == typeof t.toJSON ? e(t.toJSON(r), n, r) : t instanceof Map ? e(Array.from(t).reduce(function (t, _ref19) {
          var _ref20 = _slicedToArray(_ref19, 2),
              r = _ref20[0],
              o = _ref20[1];

          return _objectSpread(_objectSpread({}, t), {}, _defineProperty({}, "string" == typeof r ? r : e(r, n), o));
        }, {}), n, r) : t instanceof Set ? e(Array.from(t).sort(function (t, r) {
          return e(t, n).localeCompare(e(r, n));
        }), n, r) : null != t[Symbol.iterator] && "function" == typeof t[Symbol.iterator] ? e(Array.from(t), n, r) : "{".concat(Object.keys(t).filter(function (e) {
          return void 0 !== t[e];
        }).sort().map(function (r) {
          return "".concat(e(r, n), ":").concat(e(t[r], n, r));
        }).join(","), "}");
        var o;
      }(e, t);
    },
        Ht = function Ht() {
      var e = new Map(),
          t = {
        get: function get(t) {
          return e.get(qt(t));
        },
        set: function set(n, r) {
          return e.set(qt(n), r), t;
        },
        map: e
      };
      return t;
    };

    var Gt = 0;

    var Yt = function Yt(e) {
      var t, n;
      var r = null !== (t = null === (n = e.cacheImplementationForParams_UNSTABLE) || void 0 === n ? void 0 : n.call(e)) && void 0 !== t ? t : Ht();
      return function (t) {
        var n, o;
        var a = r.get(t);
        if (null != a) return a;

        var i = "".concat(e.key, "__selectorFamily/").concat(null !== (n = qt(t, {
          allowFunctions: !0
        })) && void 0 !== n ? n : "void", "/").concat(Gt++),
            u = function u(n) {
          return e.get(t)(n);
        },
            c = null === (o = e.cacheImplementation_UNSTABLE) || void 0 === o ? void 0 : o.call(e);

        var s;

        if (null != e.set) {
          var _n8 = e.set;
          s = Ct({
            key: i,
            get: u,
            set: function set(e, r) {
              return _n8(t)(e, r);
            },
            cacheImplementation_UNSTABLE: c,
            dangerouslyAllowMutability: e.dangerouslyAllowMutability
          });
        } else s = Ct({
          key: i,
          get: u,
          cacheImplementation_UNSTABLE: c,
          dangerouslyAllowMutability: e.dangerouslyAllowMutability
        });

        return r = r.set(t, s), s;
      };
    },
        Xt = h(Object.freeze({
      __proto__: null
    }));

    var Jt = O.DEFAULT_VALUE,
        Kt = O.DefaultValue;

    function Qt(e, t) {
      return vt(t, function (t) {
        return e.has(t);
      });
    }

    var Zt = function Zt(e, t) {
      return Array.from(t).reduce(function (t, n) {
        return _objectSpread(_objectSpread({}, t), {}, _defineProperty({}, n, e[n]));
      }, {});
    };

    function en(e) {
      if (null == e) return;
      var t = Object.assign({}, e);
      return _objectSpread(_objectSpread({}, t), {}, {
        validator: function validator(e) {
          return e instanceof Xt ? new Xt(e.value.filter(function (_ref21) {
            var _ref22 = _slicedToArray(_ref21, 2),
                e = _ref22[0],
                t = _ref22[1];

            return e instanceof Set && t instanceof Map;
          }).map(function (_ref23) {
            var _ref24 = _slicedToArray(_ref23, 2),
                e = _ref24[0],
                n = _ref24[1];

            return [e, Array.from(n.entries()).reduce(function (e, _ref25) {
              var _ref26 = _slicedToArray(_ref25, 2),
                  n = _ref26[0],
                  r = _ref26[1];

              var o = t.validator(r, Jt);
              return o instanceof Kt || e.set(n, o), e;
            }, new Map())];
          })) : t.validator(e, Jt);
        }
      });
    }

    var tn = Yt({
      key: "__constant",
      get: function get(e) {
        return function () {
          return e;
        };
      },
      cacheImplementationForParams_UNSTABLE: yt
    }),
        nn = Yt({
      key: "__error",
      get: function get(e) {
        return function () {
          throw new Error(e);
        };
      },
      cacheImplementationForParams_UNSTABLE: yt
    }),
        rn = lt.loadableWithError,
        on = lt.loadableWithPromise,
        an = lt.loadableWithValue;

    function un(e, t) {
      var n = Array(t.length).fill(void 0),
          r = Array(t.length).fill(void 0);

      var _iterator15 = _createForOfIteratorHelper(t.entries()),
          _step15;

      try {
        for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
          var _step15$value = _slicedToArray(_step15.value, 2),
              _o4 = _step15$value[0],
              _a4 = _step15$value[1];

          try {
            n[_o4] = e(_a4);
          } catch (e) {
            r[_o4] = e;
          }
        }
      } catch (err) {
        _iterator15.e(err);
      } finally {
        _iterator15.f();
      }

      return [n, r];
    }

    function cn(e) {
      return null != e && !at(e);
    }

    function sn(e) {
      return Array.isArray(e) ? e : Object.getOwnPropertyNames(e).map(function (t) {
        return e[t];
      });
    }

    function ln(e, t) {
      return Array.isArray(e) ? t : Object.getOwnPropertyNames(e).reduce(function (e, n, r) {
        return _objectSpread(_objectSpread({}, e), {}, _defineProperty({}, n, t[r]));
      }, {});
    }

    function fn(e, t, n) {
      return ln(e, n.map(function (e, n) {
        return null == e ? an(t[n]) : at(e) ? on(e) : rn(e);
      }));
    }

    var pn = {
      waitForNone: Yt({
        key: "__waitForNone",
        get: function get(e) {
          return function (_ref27) {
            var t = _ref27.get;

            var n = sn(e),
                _un = un(t, n),
                _un2 = _slicedToArray(_un, 2),
                r = _un2[0],
                o = _un2[1];

            return fn(e, r, o);
          };
        }
      }),
      waitForAny: Yt({
        key: "__waitForAny",
        get: function get(e) {
          return function (_ref28) {
            var t = _ref28.get;

            var n = sn(e),
                _un3 = un(t, n),
                _un4 = _slicedToArray(_un3, 2),
                r = _un4[0],
                o = _un4[1];

            if (o.some(function (e) {
              return null == e;
            })) return fn(e, r, o);
            if (o.every(cn)) throw o.find(cn);
            throw new Promise(function (t, n) {
              var _iterator16 = _createForOfIteratorHelper(o.entries()),
                  _step16;

              try {
                var _loop = function _loop() {
                  var _step16$value = _slicedToArray(_step16.value, 2),
                      a = _step16$value[0],
                      i = _step16$value[1];

                  at(i) && i.then(function (n) {
                    r[a] = n, o[a] = null, t(fn(e, r, o));
                  }).catch(function (e) {
                    o[a] = e, o.every(cn) && n(o[0]);
                  });
                };

                for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
                  _loop();
                }
              } catch (err) {
                _iterator16.e(err);
              } finally {
                _iterator16.f();
              }
            });
          };
        }
      }),
      waitForAll: Yt({
        key: "__waitForAll",
        get: function get(e) {
          return function (_ref29) {
            var t = _ref29.get;

            var n = sn(e),
                _un5 = un(t, n),
                _un6 = _slicedToArray(_un5, 2),
                r = _un6[0],
                o = _un6[1];

            if (o.every(function (e) {
              return null == e;
            })) return ln(e, r);
            var a = o.find(cn);
            if (null != a) throw a;
            throw Promise.all(o).then(function (t) {
              return ln(e, t);
            });
          };
        }
      }),
      noWait: Yt({
        key: "__noWait",
        get: function get(e) {
          return function (_ref30) {
            var t = _ref30.get;

            try {
              return an(t(e));
            } catch (e) {
              return at(e) ? on(e) : rn(e);
            }
          };
        }
      })
    };
    var dn = O.DefaultValue,
        bn = Me.RecoilRoot,
        hn = y.isRecoilValue,
        yn = ot.useGotoRecoilSnapshot,
        vn = ot.useRecoilCallback,
        mn = ot.useRecoilSnapshot,
        gn = ot.useRecoilState,
        Sn = ot.useRecoilStateLoadable,
        wn = ot.useRecoilTransactionObserver,
        On = ot.useRecoilValue,
        _n = ot.useRecoilValueLoadable,
        jn = ot.useResetRecoilState,
        An = ot.useSetRecoilState,
        Rn = ot.useSetUnvalidatedAtomValues,
        En = ot.useTransactionObservation_DEPRECATED,
        Tn = pn.noWait,
        xn = pn.waitForAll,
        Mn = pn.waitForAny,
        kn = pn.waitForNone;
    var Nn = {
      DefaultValue: dn,
      RecoilRoot: bn,
      atom: Wt,
      selector: Ct,
      atomFamily: function atomFamily(e) {
        var t = Ht();
        var n = {
          key: e.key,
          default: Jt,
          persistence_UNSTABLE: en(e.persistence_UNSTABLE)
        };
        var r;
        r = Wt(n);
        var o = Yt({
          key: e.key + "__atomFamily/Default",
          get: function get(t) {
            return function (_ref31) {
              var n = _ref31.get;
              var o = n("function" == typeof r ? r(t) : r);

              if (!(o instanceof Kt)) {
                var _e9 = function (e, t) {
                  if (!(e instanceof Xt)) return e;
                  if ("object" != typeof t || null == t || Array.isArray(t)) return Jt;
                  var n = e.value,
                      r = new Set(Object.keys(t));

                  var _iterator17 = _createForOfIteratorHelper(n),
                      _step17;

                  try {
                    for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
                      var _step17$value = _slicedToArray(_step17.value, 2),
                          _e10 = _step17$value[0],
                          _o5 = _step17$value[1];

                      if (Qt(r, _e10)) {
                        var _n9 = r.size === _e10.size ? t : Zt(t, _e10),
                            _a5 = _o5.get(qt(_n9));

                        if (void 0 !== _a5) return _a5;
                      }
                    }
                  } catch (err) {
                    _iterator17.e(err);
                  } finally {
                    _iterator17.f();
                  }

                  return Jt;
                }(o, t);

                if (!(_e9 instanceof Kt)) return _e9;
              }

              return "function" == typeof e.default ? e.default(t) : e.default;
            };
          },
          dangerouslyAllowMutability: e.dangerouslyAllowMutability
        });
        return function (n) {
          var r;
          var a = t.get(n);
          if (null != a) return a;
          var i = Wt({
            key: "".concat(e.key, "__").concat(null !== (r = qt(n)) && void 0 !== r ? r : "void"),
            default: o(n),
            persistence_UNSTABLE: e.persistence_UNSTABLE,
            dangerouslyAllowMutability: e.dangerouslyAllowMutability
          });
          return t = t.set(n, i), i;
        };
      },
      selectorFamily: Yt,
      constSelector: function constSelector(e) {
        return tn(e);
      },
      errorSelector: function errorSelector(e) {
        return nn(e);
      },
      readOnlySelector: function readOnlySelector(e) {
        return e;
      },
      useRecoilValue: On,
      useRecoilValueLoadable: _n,
      useRecoilState: gn,
      useRecoilStateLoadable: Sn,
      useSetRecoilState: An,
      useResetRecoilState: jn,
      useRecoilCallback: vn,
      useGotoRecoilSnapshot: yn,
      useRecoilSnapshot: mn,
      useRecoilTransactionObserver_UNSTABLE: wn,
      useTransactionObservation_UNSTABLE: En,
      useSetUnvalidatedAtomValues_UNSTABLE: Rn,
      noWait: Tn,
      waitForNone: kn,
      waitForAny: Mn,
      waitForAll: xn,
      isRecoilValue: hn
    },
        Vn = Nn.DefaultValue,
        Pn = Nn.RecoilRoot,
        Cn = Nn.atom,
        Ln = Nn.selector,
        In = Nn.atomFamily,
        Dn = Nn.selectorFamily,
        Un = Nn.constSelector,
        Bn = Nn.errorSelector,
        Fn = Nn.readOnlySelector,
        $n = Nn.useRecoilValue,
        zn = Nn.useRecoilValueLoadable,
        Wn = Nn.useRecoilState,
        qn = Nn.useRecoilStateLoadable,
        Hn = Nn.useSetRecoilState,
        Gn = Nn.useResetRecoilState,
        Yn = Nn.useRecoilCallback,
        Xn = Nn.useGotoRecoilSnapshot,
        Jn = Nn.useRecoilSnapshot,
        Kn = Nn.useRecoilTransactionObserver_UNSTABLE,
        Qn = Nn.useTransactionObservation_UNSTABLE,
        Zn = Nn.useSetUnvalidatedAtomValues_UNSTABLE,
        er = Nn.noWait,
        tr = Nn.waitForNone,
        nr = Nn.waitForAny,
        rr = Nn.waitForAll,
        or = Nn.isRecoilValue;
    t.DefaultValue = Vn, t.RecoilRoot = Pn, t.atom = Cn, t.atomFamily = In, t.constSelector = Un, t.default = Nn, t.errorSelector = Bn, t.isRecoilValue = or, t.noWait = er, t.readOnlySelector = Fn, t.selector = Ln, t.selectorFamily = Dn, t.useGotoRecoilSnapshot = Xn, t.useRecoilCallback = Yn, t.useRecoilSnapshot = Jn, t.useRecoilState = Wn, t.useRecoilStateLoadable = qn, t.useRecoilTransactionObserver_UNSTABLE = Kn, t.useRecoilValue = $n, t.useRecoilValueLoadable = zn, t.useResetRecoilState = Gn, t.useSetRecoilState = Hn, t.useSetUnvalidatedAtomValues_UNSTABLE = Zn, t.useTransactionObservation_UNSTABLE = Qn, t.waitForAll = rr, t.waitForAny = nr, t.waitForNone = tr;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return e && "object" == typeof e && "default" in e ? e.default : e;
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var o = r(n(0)),
        a = r(n(34)),
        i = function i(e) {
      for (var _len5 = arguments.length, t = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        t[_key5 - 1] = arguments[_key5];
      }

      var n = 0;
      return e.replace(/%s/g, function () {
        return String(t[n++]);
      });
    },
        u = function u(e) {
      {
        for (var _len6 = arguments.length, t = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
          t[_key6 - 1] = arguments[_key6];
        }

        var _n10 = i.call.apply(i, [null, e].concat(t)),
            _r10 = new Error(_n10);

        _r10.name = "Expectation Violation", console.error(_r10);
      }
    },
        c = function c(e, t) {
      var _ref32 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          n = _ref32.error;

      return console.error(e, n), null;
    };

    function s(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    var l = function l(e) {
      _classCallCheck(this, l);

      s(this, "key", void 0), this.key = e;
    };

    var f = /*#__PURE__*/function (_l) {
      _inherits(f, _l);

      var _super7 = _createSuper(f);

      function f() {
        _classCallCheck(this, f);

        return _super7.apply(this, arguments);
      }

      return f;
    }(l);

    var p = /*#__PURE__*/function (_l2) {
      _inherits(p, _l2);

      var _super8 = _createSuper(p);

      function p() {
        _classCallCheck(this, p);

        return _super8.apply(this, arguments);
      }

      return p;
    }(l);

    var d = {
      AbstractRecoilValue: l,
      RecoilState: f,
      RecoilValueReadOnly: p,
      isRecoilValue: function isRecoilValue(e) {
        return e instanceof f || e instanceof p;
      }
    },
        b = d.AbstractRecoilValue,
        h = d.RecoilState,
        y = d.RecoilValueReadOnly,
        v = d.isRecoilValue,
        m = Object.freeze({
      __proto__: null,
      AbstractRecoilValue: b,
      RecoilState: h,
      RecoilValueReadOnly: y,
      isRecoilValue: v
    });

    var g = function g() {
      _classCallCheck(this, g);
    };

    var S = new g();

    var w = /*#__PURE__*/function (_Error4) {
      _inherits(w, _Error4);

      var _super9 = _createSuper(w);

      function w(e) {
        _classCallCheck(this, w);

        return _super9.call(this, "Tried to set the value of Recoil selector ".concat(e, " using an updater function, but it is an async selector in a pending or error state; this is not supported."));
      }

      return w;
    }( /*#__PURE__*/_wrapNativeSuper(Error));

    var O = new Map();

    var _ = /*#__PURE__*/function (_Error5) {
      _inherits(_, _Error5);

      var _super10 = _createSuper(_);

      function _() {
        _classCallCheck(this, _);

        return _super10.apply(this, arguments);
      }

      return _;
    }( /*#__PURE__*/_wrapNativeSuper(Error));

    var j = {
      nodes: O,
      registerNode: function registerNode(e) {
        if (O.has(e.key)) {
          var _t16 = "Duplicate atom key \"".concat(e.key, "\". This is a FATAL ERROR in\n      production. But it is safe to ignore this warning if it occurred because of\n      hot module replacement.");

          c(_t16);
        }

        return O.set(e.key, e), null == e.set ? new m.RecoilValueReadOnly(e.key) : new m.RecoilState(e.key);
      },
      getNode: function getNode(e) {
        var t = O.get(e);
        if (null == t) throw new _("Missing definition for RecoilValue: \"".concat(e, "\"\""));
        return t;
      },
      NodeMissingError: _,
      DefaultValue: g,
      DEFAULT_VALUE: S,
      RecoilValueNotReady: w
    },
        A = function A(e, t) {
      t();
    },
        R = {
      setByAddingToSet: function setByAddingToSet(e, t) {
        var n = new Set(e);
        return n.add(t), n;
      },
      setByDeletingFromSet: function setByDeletingFromSet(e, t) {
        var n = new Set(e);
        return n.delete(t), n;
      },
      mapBySettingInMap: function mapBySettingInMap(e, t, n) {
        var r = new Map(e);
        return r.set(t, n), r;
      },
      mapByUpdatingInMap: function mapByUpdatingInMap(e, t, n) {
        var r = new Map(e);
        return r.set(t, n(r.get(t))), r;
      },
      mapByDeletingFromMap: function mapByDeletingFromMap(e, t) {
        var n = new Map(e);
        return n.delete(t), n;
      }
    },
        E = function E(e, t, n) {
      return n();
    },
        T = function T(e) {
      return e;
    };

    var x = R.mapByDeletingFromMap,
        M = R.mapBySettingInMap,
        k = R.mapByUpdatingInMap,
        N = R.setByAddingToSet,
        V = j.getNode,
        P = Object.freeze(new Map()),
        C = Object.freeze(new Set());

    var L = /*#__PURE__*/function (_Error6) {
      _inherits(L, _Error6);

      var _super11 = _createSuper(L);

      function L() {
        _classCallCheck(this, L);

        return _super11.apply(this, arguments);
      }

      return L;
    }( /*#__PURE__*/_wrapNativeSuper(Error));

    function I(e, t, n) {
      return V(n).get(e, t);
    }

    var D = 0;

    var U = {
      getNodeLoadable: I,
      peekNodeLoadable: function peekNodeLoadable(e, t, n) {
        return I(e, t, n)[1];
      },
      setNodeValue: function setNodeValue(e, t, n, r) {
        var o = V(n);
        if (null == o.set) throw new L("Attempt to set read-only RecoilValue: " + n);

        var _o$set3 = o.set(e, t, r),
            _o$set4 = _slicedToArray(_o$set3, 2),
            a = _o$set4[0],
            i = _o$set4[1];

        return [a, i];
      },
      setUnvalidatedAtomValue: function setUnvalidatedAtomValue(e, t, n) {
        return _objectSpread(_objectSpread({}, e), {}, {
          atomValues: x(e.atomValues, t),
          nonvalidatedAtoms: M(e.nonvalidatedAtoms, t, n),
          dirtyAtoms: N(e.dirtyAtoms, t)
        });
      },
      subscribeComponentToNode: function subscribeComponentToNode(e, t, n) {
        var r = D++;
        return [_objectSpread(_objectSpread({}, e), {}, {
          nodeToComponentSubscriptions: k(e.nodeToComponentSubscriptions, t, function (e) {
            return M(null != e ? e : P, r, ["TODO debug name", n]);
          })
        }), function (e) {
          return _objectSpread(_objectSpread({}, e), {}, {
            nodeToComponentSubscriptions: k(e.nodeToComponentSubscriptions, t, function (e) {
              return x(null != e ? e : P, r);
            })
          });
        }];
      },
      fireNodeSubscriptions: function fireNodeSubscriptions(e, t, n) {
        var r;

        var o = "enqueue" === n && null !== (r = e.getState().nextTree) && void 0 !== r ? r : e.getState().currentTree,
            a = function (e, t) {
          var n = new Set(),
              r = new Set(),
              o = Array.from(t);

          for (var _t17 = o.pop(); _t17; _t17 = o.pop()) {
            var a;
            n.add(_t17), r.add(_t17);

            var _i7 = null !== (a = e.nodeToNodeSubscriptions.get(_t17)) && void 0 !== a ? a : C;

            var _iterator18 = _createForOfIteratorHelper(_i7),
                _step18;

            try {
              for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
                var _e11 = _step18.value;
                r.has(_e11) || o.push(_e11);
              }
            } catch (err) {
              _iterator18.e(err);
            } finally {
              _iterator18.f();
            }
          }

          return n;
        }(o, t);

        var _iterator19 = _createForOfIteratorHelper(a),
            _step19;

        try {
          for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
            var _t18 = _step19.value;
            var i;
            (null !== (i = o.nodeToComponentSubscriptions.get(_t18)) && void 0 !== i ? i : []).forEach(function (_ref33) {
              var _ref34 = _slicedToArray(_ref33, 2),
                  t = _ref34[0],
                  r = _ref34[1];

              "enqueue" === n ? e.getState().queuedComponentCallbacks.push(r) : r(o);
            });
          }
        } catch (err) {
          _iterator19.e(err);
        } finally {
          _iterator19.f();
        }

        E("value became available, waking components", Array.from(t).join(", "), function () {
          var t = e.getState().suspendedComponentResolvers;
          t.forEach(function (e) {
            return e();
          }), t.clear();
        });
      },
      detectCircularDependencies: function e(t, n) {
        if (!n.length) return;
        var r = n[n.length - 1],
            o = t.nodeToNodeSubscriptions.get(r);
        if (!(null == o ? void 0 : o.size)) return;
        var a = n[0];
        if (o.has(a)) throw new Error("Recoil selector has circular dependencies: " + [].concat(_toConsumableArray(n), [a]).reverse().join(" → "));

        var _iterator20 = _createForOfIteratorHelper(o),
            _step20;

        try {
          for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
            var _r11 = _step20.value;
            e(t, [].concat(_toConsumableArray(n), [_r11]));
          }
        } catch (err) {
          _iterator20.e(err);
        } finally {
          _iterator20.f();
        }
      }
    },
        B = function B(e, t) {
      var n = new Map();
      return e.forEach(function (e, r) {
        n.set(r, t(e, r));
      }), n;
    };

    var F = U.getNodeLoadable,
        $ = U.peekNodeLoadable,
        z = U.setNodeValue,
        W = U.setUnvalidatedAtomValue,
        q = U.subscribeComponentToNode,
        H = j.RecoilValueNotReady,
        G = m.AbstractRecoilValue,
        Y = m.RecoilState,
        X = m.RecoilValueReadOnly;
    var J = {
      RecoilValueReadOnly: X,
      AbstractRecoilValue: G,
      RecoilState: Y,
      valueFromValueOrUpdater: function valueFromValueOrUpdater(e, _ref35, n) {
        var t = _ref35.key;

        if ("function" == typeof n) {
          var r;

          var _o6 = e.getState(),
              _a6 = null !== (r = _o6.nextTree) && void 0 !== r ? r : _o6.currentTree,
              _i8 = $(e, _a6, t);

          if ("loading" === _i8.state) throw new H(t);
          if ("hasError" === _i8.state) throw _i8.contents;
          return n(_i8.contents);
        }

        return n;
      },
      getRecoilValueAsLoadable: function getRecoilValueAsLoadable(e, _ref36) {
        var t = _ref36.key;
        var n;
        return E("get RecoilValue", t, function () {
          return e.replaceState(T(function (r) {
            var _F3 = F(e, r, t),
                _F4 = _slicedToArray(_F3, 2),
                o = _F4[0],
                a = _F4[1];

            return n = a, o;
          }));
        }), n;
      },
      setRecoilValue: function setRecoilValue(e, _ref37, n) {
        var t = _ref37.key;
        E("set RecoilValue", t, function () {
          return e.replaceState(T(function (r) {
            var _z = z(e, r, t, n),
                _z2 = _slicedToArray(_z, 2),
                o = _z2[0],
                a = _z2[1];

            return e.fireNodeSubscriptions(a, "enqueue"), o;
          }));
        });
      },
      setUnvalidatedRecoilValue: function setUnvalidatedRecoilValue(e, _ref38, n) {
        var t = _ref38.key;
        E("set unvalidated persisted atom", t, function () {
          return e.replaceState(T(function (r) {
            var o = W(r, t, n);
            return e.fireNodeSubscriptions(new Set([t]), "enqueue"), o;
          }));
        });
      },
      subscribeToRecoilValue: function subscribeToRecoilValue(e, _ref39, n) {
        var t = _ref39.key;
        var r, o;
        return E("subscribe component to RecoilValue", t, function () {
          return e.replaceState(T(function (e) {
            var _q, _q2;

            return (_q = q(e, t, n), _q2 = _slicedToArray(_q, 2), r = _q2[0], o = _q2[1], _q), r;
          }));
        }), {
          release: function release(e) {
            return e.replaceState(o);
          }
        };
      }
    };

    function K() {
      return {
        transactionMetadata: {},
        atomValues: new Map(),
        nonvalidatedAtoms: new Map(),
        dirtyAtoms: new Set(),
        nodeDeps: new Map(),
        nodeToNodeSubscriptions: new Map(),
        nodeToComponentSubscriptions: new Map()
      };
    }

    function Q(e) {
      return {
        currentTree: e,
        nextTree: null,
        transactionSubscriptions: new Map(),
        queuedComponentCallbacks: [],
        suspendedComponentResolvers: new Set()
      };
    }

    var Z = {
      makeEmptyTreeState: K,
      makeEmptyStoreState: function makeEmptyStoreState() {
        return Q(K());
      },
      makeStoreState: Q
    };
    var ee = j.DEFAULT_VALUE,
        te = J.getRecoilValueAsLoadable,
        ne = J.setRecoilValue,
        re = J.valueFromValueOrUpdater,
        oe = Z.makeEmptyTreeState,
        ae = Z.makeStoreState;

    var ie = /*#__PURE__*/function () {
      function ie(e) {
        var _this4 = this;

        _classCallCheck(this, ie);

        s(this, "_store", void 0), s(this, "getLoadable", function (e) {
          return te(_this4._store, e);
        }), s(this, "getPromise", function (e) {
          return _this4.getLoadable(e).toPromise();
        }), s(this, "map", function (e) {
          var t = new se(_this4._store.getState().currentTree);
          return e(t), ce(t.getStore_INTERNAL().getState().currentTree);
        }), s(this, "asyncMap", /*#__PURE__*/function () {
          var _ref40 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e) {
            var t;
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    t = new se(_this4._store.getState().currentTree);
                    _context2.next = 3;
                    return e(t);

                  case 3:
                    return _context2.abrupt("return", ce(t.getStore_INTERNAL().getState().currentTree));

                  case 4:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }));

          return function (_x2) {
            return _ref40.apply(this, arguments);
          };
        }()), this._store = function (e) {
          var t = ae(e);
          return {
            getState: function getState() {
              return t;
            },
            replaceState: function replaceState(e) {
              t.currentTree = e(t.currentTree);
            },
            subscribeToTransactions: function subscribeToTransactions() {
              throw new Error("Cannot subscribe to Snapshots");
            },
            addTransactionMetadata: function addTransactionMetadata() {
              throw new Error("Cannot subscribe to Snapshots");
            },
            fireNodeSubscriptions: function fireNodeSubscriptions() {}
          };
        }(e);
      }

      _createClass(ie, [{
        key: "getStore_INTERNAL",
        value: function getStore_INTERNAL() {
          return this._store;
        }
      }]);

      return ie;
    }();

    function ue(e) {
      return {
        transactionMetadata: _objectSpread({}, e.transactionMetadata),
        atomValues: new Map(e.atomValues),
        nonvalidatedAtoms: new Map(e.nonvalidatedAtoms),
        dirtyAtoms: new Set(e.dirtyAtoms),
        nodeDeps: new Map(e.nodeDeps),
        nodeToNodeSubscriptions: B(e.nodeToNodeSubscriptions, function (e) {
          return new Set(e);
        }),
        nodeToComponentSubscriptions: new Map()
      };
    }

    function ce(e) {
      return new ie(ue(e));
    }

    var se = /*#__PURE__*/function (_ie) {
      _inherits(se, _ie);

      var _super12 = _createSuper(se);

      function se(e) {
        var _this5;

        _classCallCheck(this, se);

        _this5 = _super12.call(this, ue(e)), s(_assertThisInitialized(_this5), "set", function (e, t) {
          var n = _this5.getStore_INTERNAL(),
              r = re(n, e, t);

          ne(n, e, r);
        }), s(_assertThisInitialized(_this5), "reset", function (e) {
          return ne(_this5.getStore_INTERNAL(), e, ee);
        });
        return _this5;
      }

      return se;
    }(ie);

    var le = {
      Snapshot: ie,
      MutableSnapshot: se,
      freshSnapshot: function freshSnapshot() {
        return new ie(oe());
      },
      cloneSnapshot: ce
    },
        fe = le.Snapshot,
        pe = le.MutableSnapshot,
        de = le.freshSnapshot,
        be = le.cloneSnapshot,
        he = Object.freeze({
      __proto__: null,
      Snapshot: fe,
      MutableSnapshot: pe,
      freshSnapshot: de,
      cloneSnapshot: be
    }),
        ye = function ye(e, t) {
      if (null != e) return e;
      throw new Error(null != t ? t : "Got unexpected null or undefined");
    };

    var ve = o.useContext,
        me = o.useEffect,
        ge = o.useRef,
        Se = o.useState,
        we = U.fireNodeSubscriptions,
        Oe = U.setNodeValue,
        _e = U.setUnvalidatedAtomValue,
        je = he.freshSnapshot,
        Ae = Z.makeEmptyStoreState,
        Re = Z.makeStoreState;

    function Ee() {
      throw new Error("This component must be used inside a <RecoilRoot> component.");
    }

    var Te = Object.freeze({
      getState: Ee,
      replaceState: Ee,
      subscribeToTransactions: Ee,
      addTransactionMetadata: Ee,
      fireNodeSubscriptions: Ee
    });

    function xe(e) {
      null === e.nextTree && (e.nextTree = _objectSpread(_objectSpread({}, e.currentTree), {}, {
        dirtyAtoms: new Set(),
        transactionMetadata: {}
      }));
    }

    var Me = o.createContext({
      current: Te
    }),
        ke = function ke() {
      return ve(Me);
    };

    function Ne(e) {
      var t = ke(),
          _Se = Se([]),
          _Se2 = _slicedToArray(_Se, 2),
          n = _Se2[0],
          r = _Se2[1];

      return e.setNotifyBatcherOfChange(function () {
        return r({});
      }), me(function () {
        A("Batcher", function () {
          var e = t.current.getState(),
              n = e.nextTree;
          null !== n && (n.dirtyAtoms.size && e.transactionSubscriptions.forEach(function (e) {
            return e(t.current);
          }), e.queuedComponentCallbacks.forEach(function (e) {
            return e(n);
          }), e.queuedComponentCallbacks.splice(0, e.queuedComponentCallbacks.length), e.currentTree = n, e.nextTree = null);
        });
      }), null;
    }

    "undefined" == typeof window || window.$recoilDebugStates || (window.$recoilDebugStates = []);
    var Ve = 0;

    var Pe = {
      useStoreRef: ke,
      RecoilRoot: function RecoilRoot(_ref41) {
        var e = _ref41.initializeState_DEPRECATED,
            t = _ref41.initializeState,
            n = _ref41.children;
        var r;
        var a = ge(null),
            i = {
          getState: function getState() {
            return r.current;
          },
          replaceState: function replaceState(e) {
            var t = u.current.getState();
            xe(t);
            var n = ye(t.nextTree),
                r = e(n);
            r !== n && ("undefined" != typeof window && window.$recoilDebugStates.push(r), t.nextTree = r, ye(a.current)());
          },
          subscribeToTransactions: function subscribeToTransactions(e) {
            var t = Ve++;
            return u.current.getState().transactionSubscriptions.set(t, e), {
              release: function release() {
                u.current.getState().transactionSubscriptions.delete(t);
              }
            };
          },
          addTransactionMetadata: function addTransactionMetadata(e) {
            xe(u.current.getState());

            for (var _i9 = 0, _Object$keys2 = Object.keys(e); _i9 < _Object$keys2.length; _i9++) {
              var _t19 = _Object$keys2[_i9];
              ye(u.current.getState().nextTree).transactionMetadata[_t19] = e[_t19];
            }
          },
          fireNodeSubscriptions: function fireNodeSubscriptions(e, t) {
            we(u.current, e, t);
          }
        },
            u = ge(i);
        return r = ge(null != e ? function (e, t) {
          var n = Ae();
          return t({
            set: function set(t, r) {
              n.currentTree = Oe(e, n.currentTree, t.key, r)[0];
            },
            setUnvalidatedAtomValues: function setUnvalidatedAtomValues(e) {
              e.forEach(function (e, t) {
                n.currentTree = _e(n.currentTree, t, e);
              });
            }
          }), n;
        }(i, e) : null != t ? function (e) {
          var t = je().map(e);
          return Re(t.getStore_INTERNAL().getState().currentTree);
        }(t) : Ae()), o.createElement(Me.Provider, {
          value: u
        }, o.createElement(Ne, {
          setNotifyBatcherOfChange: function setNotifyBatcherOfChange(e) {
            a.current = e;
          }
        }), n);
      }
    },
        Ce = function Ce(e) {
      var n = new Set();

      for (var _len7 = arguments.length, t = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
        t[_key7 - 1] = arguments[_key7];
      }

      var _iterator21 = _createForOfIteratorHelper(e),
          _step21;

      try {
        e: for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
          var _r12 = _step21.value;

          var _iterator22 = _createForOfIteratorHelper(t),
              _step22;

          try {
            for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
              var _e12 = _step22.value;
              if (_e12.has(_r12)) continue e;
            }
          } catch (err) {
            _iterator22.e(err);
          } finally {
            _iterator22.f();
          }

          n.add(_r12);
        }
      } catch (err) {
        _iterator21.e(err);
      } finally {
        _iterator21.f();
      }

      return n;
    };

    var Le = o.useCallback,
        Ie = o.useEffect,
        De = o.useMemo,
        Ue = o.useRef,
        Be = o.useState,
        Fe = U.peekNodeLoadable,
        $e = U.setNodeValue,
        ze = j.DEFAULT_VALUE,
        We = j.getNode,
        qe = j.nodes,
        He = Pe.useStoreRef,
        Ge = m.isRecoilValue,
        Ye = J.AbstractRecoilValue,
        Xe = J.getRecoilValueAsLoadable,
        Je = J.setRecoilValue,
        Ke = J.setUnvalidatedRecoilValue,
        Qe = J.subscribeToRecoilValue,
        Ze = J.valueFromValueOrUpdater,
        et = he.Snapshot,
        tt = he.cloneSnapshot,
        nt = R.setByAddingToSet;

    function rt(e, t) {
      if (!Ge(e)) throw new Error("Invalid argument to ".concat(t, ": expected an atom or selector but got ").concat(String(e)));
    }

    function ot() {
      var e = He(),
          _Be = Be([]),
          _Be2 = _slicedToArray(_Be, 2),
          t = _Be2[0],
          n = _Be2[1],
          r = Ue(new Set());

      r.current = new Set();
      var o = Ue(new Set()),
          a = Ue(new Map()),
          i = Le(function (t) {
        var n = a.current.get(t);
        n && (n.release(e.current), a.current.delete(t));
      }, [e, a]);
      return Ie(function () {
        var t = e.current;

        function c(e, t) {
          a.current.has(t) && n([]);
        }

        Ce(r.current, o.current).forEach(function (e) {
          if (a.current.has(e)) return void u("Double subscription to RecoilValue \"".concat(e, "\""));
          var n = Qe(t, new Ye(e), function (t) {
            E("RecoilValue subscription fired", e, function () {
              c(0, e);
            });
          });
          a.current.set(e, n), E("initial update on subscribing", e, function () {
            c(t.getState(), e);
          });
        }), Ce(o.current, r.current).forEach(function (e) {
          i(e);
        }), o.current = r.current;
      }), Ie(function () {
        var e = a.current;
        return function () {
          return e.forEach(function (e, t) {
            return i(t);
          });
        };
      }, [i]), De(function () {
        function t(t) {
          return rt(t, "useSetRecoilState"), function (n) {
            var r = Ze(e.current, t, n);
            Je(e.current, t, r);
          };
        }

        function n(t) {
          return rt(t, "useRecoilValueLoadable"), r.current.has(t.key) || (r.current = nt(r.current, t.key)), Xe(e.current, t);
        }

        function o(t) {
          return rt(t, "useRecoilValue"), function (e, t, n) {
            if ("hasValue" === e.state) return e.contents;
            if ("loading" === e.state) throw new Promise(function (e) {
              n.current.getState().suspendedComponentResolvers.add(e);
            });
            throw "hasError" === e.state ? e.contents : new Error("Invalid value of loadable atom \"".concat(t.key, "\""));
          }(n(t), t, e);
        }

        return {
          getRecoilValue: o,
          getRecoilValueLoadable: n,
          getRecoilState: function getRecoilState(e) {
            return rt(e, "useRecoilState"), [o(e), t(e)];
          },
          getRecoilStateLoadable: function getRecoilStateLoadable(e) {
            return rt(e, "useRecoilStateLoadable"), [n(e), t(e)];
          },
          getSetRecoilState: t,
          getResetRecoilState: function getResetRecoilState(t) {
            return rt(t, "useResetRecoilState"), function () {
              return Je(e.current, t, ze);
            };
          }
        };
      }, [r, e]);
    }

    function at(e) {
      var t = He();
      Ie(function () {
        return t.current.subscribeToTransactions(e).release;
      }, [e, t]);
    }

    function it(e) {
      var t = e.atomValues,
          n = B(function (e, t) {
        var n = new Map();

        var _iterator23 = _createForOfIteratorHelper(e),
            _step23;

        try {
          for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
            var _step23$value = _slicedToArray(_step23.value, 2),
                _r13 = _step23$value[0],
                _o7 = _step23$value[1];

            t(_o7, _r13) && n.set(_r13, _o7);
          }
        } catch (err) {
          _iterator23.e(err);
        } finally {
          _iterator23.f();
        }

        return n;
      }(t, function (e, t) {
        var n;
        var r = null === (n = We(t).options) || void 0 === n ? void 0 : n.persistence_UNSTABLE;
        return null != r && "none" !== r.type && "hasValue" === e.state;
      }), function (e) {
        return e.contents;
      });
      return function () {
        var t = new Map();

        for (var _len8 = arguments.length, e = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
          e[_key8] = arguments[_key8];
        }

        for (var _n11 = 0; _n11 < e.length; _n11++) {
          var _r14 = e[_n11].keys();

          var _o8 = void 0;

          for (; !(_o8 = _r14.next()).done;) {
            t.set(_o8.value, e[_n11].get(_o8.value));
          }
        }

        return t;
      }(e.nonvalidatedAtoms, n);
    }

    function ut() {
      var e = He();
      return Le(function (t) {
        a.unstable_batchedUpdates(function () {
          e.current.replaceState(function (n) {
            var r = t.getStore_INTERNAL().getState().currentTree,
                o = new Set();

            for (var _i10 = 0, _arr2 = [n.atomValues.keys(), r.atomValues.keys()]; _i10 < _arr2.length; _i10++) {
              var _e13 = _arr2[_i10];

              var _iterator24 = _createForOfIteratorHelper(_e13),
                  _step24;

              try {
                for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
                  var _t20 = _step24.value;
                  var a, i;
                  (null === (a = n.atomValues.get(_t20)) || void 0 === a ? void 0 : a.contents) !== (null === (i = r.atomValues.get(_t20)) || void 0 === i ? void 0 : i.contents) && o.add(_t20);
                }
              } catch (err) {
                _iterator24.e(err);
              } finally {
                _iterator24.f();
              }
            }

            return e.current.fireNodeSubscriptions(o, "enqueue"), _objectSpread(_objectSpread({}, r), {}, {
              nodeToComponentSubscriptions: n.nodeToComponentSubscriptions
            });
          });
        });
      }, [e]);
    }

    var ct = function ct() {
      _classCallCheck(this, ct);
    };

    var st = new ct();

    var lt = {
      useRecoilCallback: function useRecoilCallback(e, t) {
        var n = He(),
            r = ut();
        return Le(function () {
          for (var _len9 = arguments.length, t = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
            t[_key9] = arguments[_key9];
          }

          var o = tt(n.current.getState().currentTree);

          function i(e, t) {
            var r = Ze(n.current, e, t);
            Je(n.current, e, r);
          }

          function u(e) {
            Je(n.current, e, ze);
          }

          var c = st;
          return a.unstable_batchedUpdates(function () {
            c = e({
              set: i,
              reset: u,
              snapshot: o,
              gotoSnapshot: r
            }).apply(void 0, t);
          }), c instanceof ct && function (e, t) {
            if (!e) throw new Error(t);
          }(!1, "unstable_batchedUpdates should return immediately"), c;
        }, null != t ? [].concat(_toConsumableArray(t), [n]) : void 0);
      },
      useRecoilValue: function useRecoilValue(e) {
        return ot().getRecoilValue(e);
      },
      useRecoilValueLoadable: function useRecoilValueLoadable(e) {
        return ot().getRecoilValueLoadable(e);
      },
      useRecoilState: function useRecoilState(e) {
        var t = ot(),
            _t$getRecoilState3 = t.getRecoilState(e),
            _t$getRecoilState4 = _slicedToArray(_t$getRecoilState3, 1),
            n = _t$getRecoilState4[0];

        return [n, Le(t.getSetRecoilState(e), [e])];
      },
      useRecoilStateLoadable: function useRecoilStateLoadable(e) {
        var t = ot(),
            _t$getRecoilStateLoad3 = t.getRecoilStateLoadable(e),
            _t$getRecoilStateLoad4 = _slicedToArray(_t$getRecoilStateLoad3, 1),
            n = _t$getRecoilStateLoad4[0];

        return [n, Le(t.getSetRecoilState(e), [e])];
      },
      useSetRecoilState: function useSetRecoilState(e) {
        return Le(ot().getSetRecoilState(e), [e]);
      },
      useResetRecoilState: function useResetRecoilState(e) {
        return Le(ot().getResetRecoilState(e), [e]);
      },
      useRecoilInterface: ot,
      useSnapshotWithStateChange_DEPRECATED: function useSnapshotWithStateChange_DEPRECATED(e) {
        var t = He();

        var n = function () {
          var _Be3 = Be(0),
              _Be4 = _slicedToArray(_Be3, 2),
              e = _Be4[0],
              t = _Be4[1];

          return at(Le(function () {
            return t(function (e) {
              return e + 1;
            });
          }, [])), {
            transactionMetadata: _objectSpread({}, (n = He().current.getState().currentTree).transactionMetadata),
            atomValues: new Map(n.atomValues),
            nonvalidatedAtoms: new Map(n.nonvalidatedAtoms),
            dirtyAtoms: new Set(n.dirtyAtoms),
            nodeDeps: new Map(n.nodeDeps),
            nodeToNodeSubscriptions: B(n.nodeToNodeSubscriptions, function (e) {
              return new Set(e);
            }),
            nodeToComponentSubscriptions: B(n.nodeToComponentSubscriptions, function (e) {
              return new Map(e);
            })
          };
          var n;
        }();

        e(function (_ref42, r) {
          var e = _ref42.key;

          var _$e = $e(t.current, n, e, Fe(t.current, n, e).map(r));

          var _$e2 = _slicedToArray(_$e, 1);

          n = _$e2[0];
        });

        var r = B(n.atomValues, function (e) {
          return e.contents;
        }),
            o = function (e) {
          var n = new Set();

          for (var _len10 = arguments.length, t = new Array(_len10 > 1 ? _len10 - 1 : 0), _key10 = 1; _key10 < _len10; _key10++) {
            t[_key10 - 1] = arguments[_key10];
          }

          var _iterator25 = _createForOfIteratorHelper(e),
              _step25;

          try {
            e: for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
              var _r15 = _step25.value;

              var _iterator26 = _createForOfIteratorHelper(t),
                  _step26;

              try {
                for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
                  var _e14 = _step26.value;
                  if (!_e14.has(_r15)) continue e;
                }
              } catch (err) {
                _iterator26.e(err);
              } finally {
                _iterator26.f();
              }

              n.add(_r15);
            }
          } catch (err) {
            _iterator25.e(err);
          } finally {
            _iterator25.f();
          }

          return n;
        }(n.dirtyAtoms, new Set(r.keys()));

        return {
          atomValues: r,
          updatedAtoms: o
        };
      },
      useTransactionSubscription_DEPRECATED: at,
      useTransactionObservation_DEPRECATED: function useTransactionObservation_DEPRECATED(e) {
        at(Le(function (t) {
          var n = t.getState().currentTree;
          var r = t.getState().nextTree;
          r || (c("Transaction subscribers notified without a next tree being present -- this is a bug in Recoil"), r = t.getState().currentTree);
          var o = it(r),
              a = it(n),
              i = B(qe, function (e) {
            var t, n, r, o, a, i;
            return {
              persistence_UNSTABLE: {
                type: null !== (t = null === (n = e.options) || void 0 === n || null === (r = n.persistence_UNSTABLE) || void 0 === r ? void 0 : r.type) && void 0 !== t ? t : "none",
                backButton: null !== (o = null === (a = e.options) || void 0 === a || null === (i = a.persistence_UNSTABLE) || void 0 === i ? void 0 : i.backButton) && void 0 !== o && o
              }
            };
          }),
              u = new Set(r.dirtyAtoms);
          e({
            atomValues: o,
            previousAtomValues: a,
            atomInfo: i,
            modifiedAtoms: u,
            transactionMetadata: _objectSpread({}, r.transactionMetadata)
          });
        }, [e]));
      },
      useRecoilTransactionObserver: function useRecoilTransactionObserver(e) {
        at(Le(function (t) {
          var n = t.getState().currentTree;
          var r = t.getState().nextTree;
          r || (c("Transaction subscribers notified without a next tree being present -- this is a bug in Recoil"), r = n), e({
            snapshot: tt(r),
            previousSnapshot: tt(n)
          });
        }, [e]));
      },
      useRecoilSnapshot: function useRecoilSnapshot() {
        var e = He(),
            _Be5 = Be(function () {
          return tt(e.current.getState().currentTree);
        }),
            _Be6 = _slicedToArray(_Be5, 2),
            t = _Be6[0],
            n = _Be6[1];

        return at(Le(function (e) {
          var t;
          return n(tt(null !== (t = e.getState().nextTree) && void 0 !== t ? t : e.getState().currentTree));
        }, [])), t;
      },
      useGoToSnapshot_DEPRECATED: function useGoToSnapshot_DEPRECATED() {
        var e = He();
        return function (t) {
          a.unstable_batchedUpdates(function () {
            t.updatedAtoms.forEach(function (n) {
              Je(e.current, new Ye(n), t.atomValues.get(n));
            });
          });
        };
      },
      useGotoRecoilSnapshot: ut,
      useSetUnvalidatedAtomValues: function useSetUnvalidatedAtomValues() {
        var e = He();
        return function (t) {
          var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          a.unstable_batchedUpdates(function () {
            e.current.addTransactionMetadata(n), t.forEach(function (t, n) {
              return Ke(e.current, new Ye(n), t);
            });
          });
        };
      }
    },
        ft = function ft(e) {
      return !!e && "function" == typeof e.then;
    };

    var pt = {
      getValue: function getValue() {
        if ("hasValue" !== this.state) throw this.contents;
        return this.contents;
      },
      toPromise: function toPromise() {
        return "hasValue" === this.state ? Promise.resolve(this.contents) : "hasError" === this.state ? Promise.reject(this.contents) : this.contents;
      },
      valueMaybe: function valueMaybe() {
        return "hasValue" === this.state ? this.contents : void 0;
      },
      valueOrThrow: function valueOrThrow() {
        if ("hasValue" !== this.state) throw new Error("Loadable expected value, but in \"".concat(this.state, "\" state"));
        return this.contents;
      },
      errorMaybe: function errorMaybe() {
        return "hasError" === this.state ? this.contents : void 0;
      },
      errorOrThrow: function errorOrThrow() {
        if ("hasError" !== this.state) throw new Error("Loadable expected error, but in \"".concat(this.state, "\" state"));
        return this.contents;
      },
      promiseMaybe: function promiseMaybe() {
        return "loading" === this.state ? this.contents : void 0;
      },
      promiseOrThrow: function promiseOrThrow() {
        if ("loading" !== this.state) throw new Error("Loadable expected promise, but in \"".concat(this.state, "\" state"));
        return this.contents;
      },
      map: function map(e) {
        var _this6 = this;

        if ("hasError" === this.state) return this;
        if ("hasValue" === this.state) try {
          var _t21 = e(this.contents);

          return ft(_t21) ? ht(_t21) : dt(_t21);
        } catch (t) {
          return ft(t) ? ht(t.next(function () {
            return e(_this6.contents);
          })) : bt(t);
        }
        if ("loading" === this.state) return ht(this.contents.then(e).catch(function (t) {
          if (ft(t)) return t.then(function () {
            return e(_this6.contents);
          });
          throw t;
        }));
        throw new Error("Invalid Loadable state");
      }
    };

    function dt(e) {
      return Object.freeze(_objectSpread({
        state: "hasValue",
        contents: e
      }, pt));
    }

    function bt(e) {
      return Object.freeze(_objectSpread({
        state: "hasError",
        contents: e
      }, pt));
    }

    function ht(e) {
      return Object.freeze(_objectSpread({
        state: "loading",
        contents: e
      }, pt));
    }

    var yt = {
      loadableWithValue: dt,
      loadableWithError: bt,
      loadableWithPromise: ht,
      loadableLoading: function loadableLoading() {
        return ht(new Promise(function () {}));
      },
      loadableAll: function loadableAll(e) {
        return e.every(function (e) {
          return "hasValue" === e.state;
        }) ? dt(e.map(function (e) {
          return e.contents;
        })) : e.some(function (e) {
          return "hasError" === e.state;
        }) ? bt(ye(e.find(function (e) {
          return "hasError" === e.state;
        }), "Invalid loadable passed to loadableAll").contents) : ht(Promise.all(e.map(function (e) {
          return e.contents;
        })));
      }
    },
        vt = function e(t) {
      if ("object" == typeof t && !function (e) {
        if (null === e || "object" != typeof e) return !0;

        switch (typeof e.$$typeof) {
          case "symbol":
          case "number":
            return !0;
        }

        return null != e["@@__IMMUTABLE_ITERABLE__@@"] || null != e["@@__IMMUTABLE_KEYED__@@"] || null != e["@@__IMMUTABLE_INDEXED__@@"] || null != e["@@__IMMUTABLE_ORDERED__@@"] || null != e["@@__IMMUTABLE_RECORD__@@"] || !!function (e) {
          var t, n;
          if ("undefined" == typeof window) return !1;
          var r = null !== (n = (null != e ? null !== (t = e.ownerDocument) && void 0 !== t ? t : e : document).defaultView) && void 0 !== n ? n : window;
          return !(null == e || !("function" == typeof r.Node ? e instanceof r.Node : "object" == typeof e && "number" == typeof e.nodeType && "string" == typeof e.nodeName));
        }(e) || !!ft(e);
      }(t)) {
        Object.freeze(t);

        for (var _n12 in t) {
          if (Object.prototype.hasOwnProperty.call(t, _n12)) {
            var _r16 = t[_n12];
            "object" != typeof _r16 || null == _r16 || Object.isFrozen(_r16) || e(_r16);
          }
        }

        Object.seal(t);
      }
    };

    var mt = Symbol("ArrayKeyedMap"),
        gt = new Map();

    var St = /*#__PURE__*/function () {
      function St(e) {
        _classCallCheck(this, St);

        if (this._base = new Map(), e instanceof St) {
          var _iterator27 = _createForOfIteratorHelper(e.entries()),
              _step27;

          try {
            for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
              var _step27$value = _slicedToArray(_step27.value, 2),
                  _t22 = _step27$value[0],
                  _n13 = _step27$value[1];

              this.set(_t22, _n13);
            }
          } catch (err) {
            _iterator27.e(err);
          } finally {
            _iterator27.f();
          }
        } else if (e) {
          var _iterator28 = _createForOfIteratorHelper(e),
              _step28;

          try {
            for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
              var _step28$value = _slicedToArray(_step28.value, 2),
                  _t23 = _step28$value[0],
                  _n14 = _step28$value[1];

              this.set(_t23, _n14);
            }
          } catch (err) {
            _iterator28.e(err);
          } finally {
            _iterator28.f();
          }
        }

        return this;
      }

      _createClass(St, [{
        key: "get",
        value: function get(e) {
          var t = Array.isArray(e) ? e : [e];
          var n = this._base;
          return t.forEach(function (e) {
            var t;
            n = null !== (t = n.get(e)) && void 0 !== t ? t : gt;
          }), void 0 === n ? void 0 : n.get(mt);
        }
      }, {
        key: "set",
        value: function set(e, t) {
          var n = Array.isArray(e) ? e : [e];
          var r = this._base,
              o = r;
          return n.forEach(function (e) {
            o = r.get(e), o || (o = new Map(), r.set(e, o)), r = o;
          }), o.set(mt, t), this;
        }
      }, {
        key: "delete",
        value: function _delete(e) {
          var t = Array.isArray(e) ? e : [e];
          var n = this._base,
              r = n;
          return t.forEach(function (e) {
            r = n.get(e), r || (r = new Map(), n.set(e, r)), n = r;
          }), r.delete(mt), this;
        }
      }, {
        key: "entries",
        value: function entries() {
          var e = [];
          return function t(n, r) {
            n.forEach(function (n, o) {
              o === mt ? e.push([r, n]) : t(n, r.concat(o));
            });
          }(this._base, []), e.values();
        }
      }, {
        key: "toBuiltInMap",
        value: function toBuiltInMap() {
          return new Map(this.entries());
        }
      }]);

      return St;
    }();

    var wt = St,
        Ot = function Ot() {
      return new wt();
    },
        _t = function _t(e, t, n) {
      var r = e.entries();
      var o = r.next();

      for (; !o.done;) {
        var _a7 = o.value;
        if (!t.call(n, _a7[1], _a7[0], e)) return !1;
        o = r.next();
      }

      return !0;
    };

    Object.freeze(new Set());
    var jt = R.mapBySettingInMap,
        At = R.mapByUpdatingInMap,
        Rt = R.setByAddingToSet,
        Et = R.setByDeletingFromSet,
        Tt = U.detectCircularDependencies,
        xt = U.getNodeLoadable,
        Mt = U.setNodeValue,
        kt = yt.loadableWithError,
        Nt = yt.loadableWithPromise,
        Vt = yt.loadableWithValue,
        Pt = j.DEFAULT_VALUE,
        Ct = j.RecoilValueNotReady,
        Lt = j.registerNode,
        _startPerfBlock2 = {
      startPerfBlock: function startPerfBlock(e) {
        return function () {
          return null;
        };
      }
    },
        It = _startPerfBlock2.startPerfBlock,
        Dt = m.isRecoilValue,
        Ut = Object.freeze(new Set());

    function Bt(e) {
      var t = [];

      var _iterator29 = _createForOfIteratorHelper(Array.from(e.keys()).sort()),
          _step29;

      try {
        for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
          var _n15 = _step29.value;

          var _r17 = ye(e.get(_n15));

          t.push(_n15), t.push(_r17.contents);
        }
      } catch (err) {
        _iterator29.e(err);
      } finally {
        _iterator29.f();
      }

      return t;
    }

    var Ft = function Ft(e) {
      var t = e.key,
          n = e.get,
          r = e.cacheImplementation_UNSTABLE,
          o = null != e.set ? e.set : void 0;
      var a = null != r ? r : Ot();

      function i(r, o) {
        var u;
        var c = o;
        var s = null !== (u = o.nodeDeps.get(t)) && void 0 !== u ? u : Ut,
            l = Bt(new Map(Array.from(s).sort().map(function (e) {
          var _xt = xt(r, c, e),
              _xt2 = _slicedToArray(_xt, 2),
              t = _xt2[0],
              n = _xt2[1];

          return c = t, [e, n];
        }))),
            f = a.get(l);
        if (null != f) return [c, f];

        var _ref43 = function (e, r) {
          var o;

          var _ref45 = function (e, r) {
            var o = It(t);
            var a = r;
            var u = new Map();

            function c(_ref47) {
              var _xt3, _xt4;

              var t = _ref47.key;
              var n;
              if ((_xt3 = xt(e, a, t), _xt4 = _slicedToArray(_xt3, 2), a = _xt4[0], n = _xt4[1], _xt3), u.set(t, n), "hasValue" === n.state) return n.contents;
              throw n.contents;
            }

            try {
              var _e15 = n({
                get: c
              }),
                  _t24 = Dt(_e15) ? c(_e15) : _e15,
                  _r18 = ft(_t24) ? Nt(_t24.finally(o)) : (o(), Vt(_t24));

              return [a, _r18, u];
            } catch (t) {
              var _n16 = ft(t) ? Nt(t.then(function () {
                var t = kt(new Error("Internal Recoil Selector Error"));
                if (e.replaceState(function (n) {
                  var _i11, _i12;

                  var r;
                  return (_i11 = i(e, n), _i12 = _slicedToArray(_i11, 2), r = _i12[0], t = _i12[1], _i11), r;
                }), "hasError" === t.state) throw t.contents;
                return t.contents;
              }).finally(o)) : (o(), kt(t));

              return [a, _n16, u];
            }
          }(e, r),
              _ref46 = _slicedToArray(_ref45, 3),
              a = _ref46[0],
              u = _ref46[1],
              c = _ref46[2];

          var s = a;
          var l = null !== (o = r.nodeDeps.get(t)) && void 0 !== o ? o : Ut,
              f = new Set(c.keys());
          s = function (e, t) {
            return e.size === t.size && _t(e, function (e) {
              return t.has(e);
            });
          }(l, f) ? s : _objectSpread(_objectSpread({}, s), {}, {
            nodeDeps: jt(s.nodeDeps, t, f)
          });
          var p = Ce(f, l),
              d = Ce(l, f);

          var _iterator30 = _createForOfIteratorHelper(p),
              _step30;

          try {
            for (_iterator30.s(); !(_step30 = _iterator30.n()).done;) {
              var _e16 = _step30.value;
              s = _objectSpread(_objectSpread({}, s), {}, {
                nodeToNodeSubscriptions: At(s.nodeToNodeSubscriptions, _e16, function (e) {
                  return Rt(null != e ? e : Ut, t);
                })
              });
            }
          } catch (err) {
            _iterator30.e(err);
          } finally {
            _iterator30.f();
          }

          var _iterator31 = _createForOfIteratorHelper(d),
              _step31;

          try {
            for (_iterator31.s(); !(_step31 = _iterator31.n()).done;) {
              var _e17 = _step31.value;
              s = _objectSpread(_objectSpread({}, s), {}, {
                nodeToNodeSubscriptions: At(s.nodeToNodeSubscriptions, _e17, function (e) {
                  return Et(null != e ? e : Ut, t);
                })
              });
            }
          } catch (err) {
            _iterator31.e(err);
          } finally {
            _iterator31.f();
          }

          return Tt(s, [t]), [s, u, c];
        }(r, c),
            _ref44 = _slicedToArray(_ref43, 3),
            p = _ref44[0],
            d = _ref44[1],
            b = _ref44[2];

        c = p;
        var h = Bt(b);
        return function (n, r, o) {
          "loading" !== o.state ? 1 == !e.dangerouslyAllowMutability && vt(o.contents) : o.contents.then(function (o) {
            return 1 == !e.dangerouslyAllowMutability && vt(o), a = a.set(r, Vt(o)), n.fireNodeSubscriptions(new Set([t]), "now"), o;
          }).catch(function (o) {
            return ft(o) || (1 == !e.dangerouslyAllowMutability && vt(o), a = a.set(r, kt(o)), n.fireNodeSubscriptions(new Set([t]), "now")), o;
          }), a = a.set(r, o);
        }(r, h, d), [c, d];
      }

      function u(e, t) {
        return i(e, t);
      }

      return Lt(null != o ? {
        key: t,
        options: e,
        get: u,
        set: function set(e, t, n) {
          var r = t;
          var a = new Set();

          function i(_ref48) {
            var t = _ref48.key;

            var _xt5 = xt(e, r, t),
                _xt6 = _slicedToArray(_xt5, 2),
                n = _xt6[0],
                o = _xt6[1];

            if (r = n, "hasValue" === o.state) return o.contents;
            throw "loading" === o.state ? new Ct(t) : o.contents;
          }

          function u(t, n) {
            var _Mt, _Mt2;

            var o = "function" == typeof n ? n(i(t)) : n;
            var u;
            (_Mt = Mt(e, r, t.key, o), _Mt2 = _slicedToArray(_Mt, 2), r = _Mt2[0], u = _Mt2[1], _Mt), u.forEach(function (e) {
              return a.add(e);
            });
          }

          return o({
            set: u,
            get: i,
            reset: function reset(e) {
              u(e, Pt);
            }
          }, n), [r, a];
        }
      } : {
        key: t,
        options: e,
        get: u
      });
    };

    var $t = yt.loadableWithValue,
        zt = j.DEFAULT_VALUE,
        Wt = j.DefaultValue,
        qt = j.registerNode,
        Ht = m.isRecoilValue,
        Gt = R.mapByDeletingFromMap,
        Yt = R.mapBySettingInMap,
        Xt = R.setByAddingToSet;

    var Jt = function e(t) {
      var n = t.default,
          r = _objectWithoutProperties(t, ["default"]);

      return Ht(n) || ft(n) ? function (t) {
        var n = e(_objectSpread(_objectSpread({}, t), {}, {
          default: zt,
          persistence_UNSTABLE: void 0 === t.persistence_UNSTABLE ? void 0 : _objectSpread(_objectSpread({}, t.persistence_UNSTABLE), {}, {
            validator: function validator(e) {
              return e instanceof Wt ? e : ye(t.persistence_UNSTABLE).validator(e, zt);
            }
          })
        }));
        return Ft({
          key: t.key + "__withFallback",
          get: function get(_ref49) {
            var e = _ref49.get;
            var r = e(n);
            return r instanceof Wt ? t.default : r;
          },
          set: function set(_ref50, t) {
            var e = _ref50.set;
            return e(n, t);
          },
          dangerouslyAllowMutability: t.dangerouslyAllowMutability
        });
      }(_objectSpread(_objectSpread({}, r), {}, {
        default: n
      })) : function (e) {
        var t = e.key,
            n = e.persistence_UNSTABLE;
        return qt({
          key: t,
          options: e,
          get: function get(r, o) {
            if (o.atomValues.has(t)) return [o, ye(o.atomValues.get(t))];

            if (o.nonvalidatedAtoms.has(t)) {
              if (null == n) return u("Tried to restore a persisted value for atom ".concat(t, " but it has no persistence settings.")), [o, $t(e.default)];

              var _r19 = o.nonvalidatedAtoms.get(t),
                  _a8 = n.validator(_r19, zt);

              return _a8 instanceof Wt ? [_objectSpread(_objectSpread({}, o), {}, {
                nonvalidatedAtoms: Gt(o.nonvalidatedAtoms, t)
              }), $t(e.default)] : [_objectSpread(_objectSpread({}, o), {}, {
                atomValues: Yt(o.atomValues, t, $t(_a8)),
                nonvalidatedAtoms: Gt(o.nonvalidatedAtoms, t)
              }), $t(_a8)];
            }

            return [o, $t(e.default)];
          },
          set: function set(n, r, o) {
            return !0 !== e.dangerouslyAllowMutability && vt(o), [_objectSpread(_objectSpread({}, r), {}, {
              dirtyAtoms: Xt(r.dirtyAtoms, t),
              atomValues: o instanceof Wt ? Gt(r.atomValues, t) : Yt(r.atomValues, t, $t(o)),
              nonvalidatedAtoms: Gt(r.nonvalidatedAtoms, t)
            }), new Set([t])];
          }
        });
      }(_objectSpread(_objectSpread({}, r), {}, {
        default: n
      }));
    },
        Kt = Object.freeze({
      __proto__: null
    });

    function Qt(e, t, n) {
      if ("string" == typeof e && !e.includes('"') && !e.includes("\\")) return "\"".concat(e, "\"");

      switch (typeof e) {
        case "undefined":
          return "";

        case "boolean":
          return e ? "true" : "false";

        case "number":
        case "symbol":
          return String(e);

        case "string":
          return JSON.stringify(e);

        case "function":
          if (!0 !== (null == t ? void 0 : t.allowFunctions)) throw new Error("Attempt to serialize function in a Recoil cache key");
          return "__FUNCTION(".concat(e.name, ")__");
      }

      return null === e ? "null" : "object" != typeof e ? null !== (r = JSON.stringify(e)) && void 0 !== r ? r : "" : ft(e) ? "__PROMISE__" : Array.isArray(e) ? "[".concat(e.map(function (e, n) {
        return Qt(e, t, n.toString());
      }), "]") : "function" == typeof e.toJSON ? Qt(e.toJSON(n), t, n) : e instanceof Map ? Qt(Array.from(e).reduce(function (e, _ref51) {
        var _ref52 = _slicedToArray(_ref51, 2),
            n = _ref52[0],
            r = _ref52[1];

        return _objectSpread(_objectSpread({}, e), {}, _defineProperty({}, "string" == typeof n ? n : Qt(n, t), r));
      }, {}), t, n) : e instanceof Set ? Qt(Array.from(e).sort(function (e, n) {
        return Qt(e, t).localeCompare(Qt(n, t));
      }), t, n) : null != e[Symbol.iterator] && "function" == typeof e[Symbol.iterator] ? Qt(Array.from(e), t, n) : "{".concat(Object.keys(e).filter(function (t) {
        return void 0 !== e[t];
      }).sort().map(function (n) {
        return "".concat(Qt(n, t), ":").concat(Qt(e[n], t, n));
      }).join(","), "}");
      var r;
    }

    var Zt = function Zt(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        allowFunctions: !1
      };

      if ("undefined" != typeof window) {
        var _n17 = window.performance ? window.performance.now() : 0,
            _r20 = Qt(e, t),
            _o9 = window.performance ? window.performance.now() : 0;

        return _o9 - _n17 > 15 && (console.groupCollapsed("Recoil: Spent ".concat(_o9 - _n17, "ms computing a cache key")), console.warn(e, _r20), console.groupEnd()), _r20;
      }

      return Qt(e, t);
    },
        en = function en() {
      var e = new Map(),
          t = {
        get: function get(t) {
          return e.get(Zt(t));
        },
        set: function set(n, r) {
          return e.set(Zt(n), r), t;
        },
        map: e
      };
      return t;
    };

    var tn = 0;

    var nn = function nn(e) {
      var t, n;
      var r = null !== (t = null === (n = e.cacheImplementationForParams_UNSTABLE) || void 0 === n ? void 0 : n.call(e)) && void 0 !== t ? t : en();
      return function (t) {
        var n, o;
        var a = r.get(t);
        if (null != a) return a;

        var i = "".concat(e.key, "__selectorFamily/").concat(null !== (n = Zt(t, {
          allowFunctions: !0
        })) && void 0 !== n ? n : "void", "/").concat(tn++),
            u = function u(n) {
          return e.get(t)(n);
        },
            c = null === (o = e.cacheImplementation_UNSTABLE) || void 0 === o ? void 0 : o.call(e);

        var s;

        if (null != e.set) {
          var _n18 = e.set;
          s = Ft({
            key: i,
            get: u,
            set: function set(e, r) {
              return _n18(t)(e, r);
            },
            cacheImplementation_UNSTABLE: c,
            dangerouslyAllowMutability: e.dangerouslyAllowMutability
          });
        } else s = Ft({
          key: i,
          get: u,
          cacheImplementation_UNSTABLE: c,
          dangerouslyAllowMutability: e.dangerouslyAllowMutability
        });

        return r = r.set(t, s), s;
      };
    };

    var rn = j.DEFAULT_VALUE,
        on = j.DefaultValue;

    function an(e, t) {
      return _t(t, function (t) {
        return e.has(t);
      });
    }

    var un = function un(e, t) {
      return Array.from(t).reduce(function (t, n) {
        return _objectSpread(_objectSpread({}, t), {}, _defineProperty({}, n, e[n]));
      }, {});
    };

    function cn(e) {
      if (null == e) return;
      var t = Object.assign({}, e);
      return _objectSpread(_objectSpread({}, t), {}, {
        validator: function validator(e) {
          return e instanceof Kt ? new Kt(e.value.filter(function (_ref53) {
            var _ref54 = _slicedToArray(_ref53, 2),
                e = _ref54[0],
                t = _ref54[1];

            return e instanceof Set && t instanceof Map;
          }).map(function (_ref55) {
            var _ref56 = _slicedToArray(_ref55, 2),
                e = _ref56[0],
                n = _ref56[1];

            return [e, Array.from(n.entries()).reduce(function (e, _ref57) {
              var _ref58 = _slicedToArray(_ref57, 2),
                  n = _ref58[0],
                  r = _ref58[1];

              var o = t.validator(r, rn);
              return o instanceof on || e.set(n, o), e;
            }, new Map())];
          })) : t.validator(e, rn);
        }
      });
    }

    var sn = nn({
      key: "__constant",
      get: function get(e) {
        return function () {
          return e;
        };
      },
      cacheImplementationForParams_UNSTABLE: Ot
    });
    var ln = nn({
      key: "__error",
      get: function get(e) {
        return function () {
          throw new Error(e);
        };
      },
      cacheImplementationForParams_UNSTABLE: Ot
    });
    var fn = yt.loadableWithError,
        pn = yt.loadableWithPromise,
        dn = yt.loadableWithValue;

    function bn(e, t) {
      var n = Array(t.length).fill(void 0),
          r = Array(t.length).fill(void 0);

      var _iterator32 = _createForOfIteratorHelper(t.entries()),
          _step32;

      try {
        for (_iterator32.s(); !(_step32 = _iterator32.n()).done;) {
          var _step32$value = _slicedToArray(_step32.value, 2),
              _o10 = _step32$value[0],
              _a9 = _step32$value[1];

          try {
            n[_o10] = e(_a9);
          } catch (e) {
            r[_o10] = e;
          }
        }
      } catch (err) {
        _iterator32.e(err);
      } finally {
        _iterator32.f();
      }

      return [n, r];
    }

    function hn(e) {
      return null != e && !ft(e);
    }

    function yn(e) {
      return Array.isArray(e) ? e : Object.getOwnPropertyNames(e).map(function (t) {
        return e[t];
      });
    }

    function vn(e, t) {
      return Array.isArray(e) ? t : Object.getOwnPropertyNames(e).reduce(function (e, n, r) {
        return _objectSpread(_objectSpread({}, e), {}, _defineProperty({}, n, t[r]));
      }, {});
    }

    function mn(e, t, n) {
      return vn(e, n.map(function (e, n) {
        return null == e ? dn(t[n]) : ft(e) ? pn(e) : fn(e);
      }));
    }

    var gn = {
      waitForNone: nn({
        key: "__waitForNone",
        get: function get(e) {
          return function (_ref59) {
            var t = _ref59.get;

            var n = yn(e),
                _bn = bn(t, n),
                _bn2 = _slicedToArray(_bn, 2),
                r = _bn2[0],
                o = _bn2[1];

            return mn(e, r, o);
          };
        }
      }),
      waitForAny: nn({
        key: "__waitForAny",
        get: function get(e) {
          return function (_ref60) {
            var t = _ref60.get;

            var n = yn(e),
                _bn3 = bn(t, n),
                _bn4 = _slicedToArray(_bn3, 2),
                r = _bn4[0],
                o = _bn4[1];

            if (o.some(function (e) {
              return null == e;
            })) return mn(e, r, o);
            if (o.every(hn)) throw o.find(hn);
            throw new Promise(function (t, n) {
              var _iterator33 = _createForOfIteratorHelper(o.entries()),
                  _step33;

              try {
                var _loop2 = function _loop2() {
                  var _step33$value = _slicedToArray(_step33.value, 2),
                      a = _step33$value[0],
                      i = _step33$value[1];

                  ft(i) && i.then(function (n) {
                    r[a] = n, o[a] = null, t(mn(e, r, o));
                  }).catch(function (e) {
                    o[a] = e, o.every(hn) && n(o[0]);
                  });
                };

                for (_iterator33.s(); !(_step33 = _iterator33.n()).done;) {
                  _loop2();
                }
              } catch (err) {
                _iterator33.e(err);
              } finally {
                _iterator33.f();
              }
            });
          };
        }
      }),
      waitForAll: nn({
        key: "__waitForAll",
        get: function get(e) {
          return function (_ref61) {
            var t = _ref61.get;

            var n = yn(e),
                _bn5 = bn(t, n),
                _bn6 = _slicedToArray(_bn5, 2),
                r = _bn6[0],
                o = _bn6[1];

            if (o.every(function (e) {
              return null == e;
            })) return vn(e, r);
            var a = o.find(hn);
            if (null != a) throw a;
            throw Promise.all(o).then(function (t) {
              return vn(e, t);
            });
          };
        }
      }),
      noWait: nn({
        key: "__noWait",
        get: function get(e) {
          return function (_ref62) {
            var t = _ref62.get;

            try {
              return dn(t(e));
            } catch (e) {
              return ft(e) ? pn(e) : fn(e);
            }
          };
        }
      })
    };
    var Sn = j.DefaultValue,
        wn = Pe.RecoilRoot,
        On = m.isRecoilValue,
        _n = lt.useGotoRecoilSnapshot,
        jn = lt.useRecoilCallback,
        An = lt.useRecoilSnapshot,
        Rn = lt.useRecoilState,
        En = lt.useRecoilStateLoadable,
        Tn = lt.useRecoilTransactionObserver,
        xn = lt.useRecoilValue,
        Mn = lt.useRecoilValueLoadable,
        kn = lt.useResetRecoilState,
        Nn = lt.useSetRecoilState,
        Vn = lt.useSetUnvalidatedAtomValues,
        Pn = lt.useTransactionObservation_DEPRECATED,
        Cn = gn.noWait,
        Ln = gn.waitForAll,
        In = gn.waitForAny,
        Dn = gn.waitForNone;
    var Un = {
      DefaultValue: Sn,
      RecoilRoot: wn,
      atom: Jt,
      selector: Ft,
      atomFamily: function atomFamily(e) {
        var t = en();
        var n = {
          key: e.key,
          default: rn,
          persistence_UNSTABLE: cn(e.persistence_UNSTABLE)
        };
        var r;
        r = Jt(n);
        var o = nn({
          key: e.key + "__atomFamily/Default",
          get: function get(t) {
            return function (_ref63) {
              var n = _ref63.get;
              var o = n("function" == typeof r ? r(t) : r);

              if (!(o instanceof on)) {
                var _e18 = function (e, t) {
                  if (!(e instanceof Kt)) return e;
                  if ("object" != typeof t || null == t || Array.isArray(t)) return rn;
                  var n = e.value,
                      r = new Set(Object.keys(t));

                  var _iterator34 = _createForOfIteratorHelper(n),
                      _step34;

                  try {
                    for (_iterator34.s(); !(_step34 = _iterator34.n()).done;) {
                      var _step34$value = _slicedToArray(_step34.value, 2),
                          _e19 = _step34$value[0],
                          _o11 = _step34$value[1];

                      if (an(r, _e19)) {
                        var _n19 = r.size === _e19.size ? t : un(t, _e19),
                            _a10 = _o11.get(Zt(_n19));

                        if (void 0 !== _a10) return _a10;
                      }
                    }
                  } catch (err) {
                    _iterator34.e(err);
                  } finally {
                    _iterator34.f();
                  }

                  return rn;
                }(o, t);

                if (!(_e18 instanceof on)) return _e18;
              }

              return "function" == typeof e.default ? e.default(t) : e.default;
            };
          },
          dangerouslyAllowMutability: e.dangerouslyAllowMutability
        });
        return function (n) {
          var r;
          var a = t.get(n);
          if (null != a) return a;
          var i = Jt({
            key: "".concat(e.key, "__").concat(null !== (r = Zt(n)) && void 0 !== r ? r : "void"),
            default: o(n),
            persistence_UNSTABLE: e.persistence_UNSTABLE,
            dangerouslyAllowMutability: e.dangerouslyAllowMutability
          });
          return t = t.set(n, i), i;
        };
      },
      selectorFamily: nn,
      constSelector: function constSelector(e) {
        return sn(e);
      },
      errorSelector: function errorSelector(e) {
        return ln(e);
      },
      readOnlySelector: function readOnlySelector(e) {
        return e;
      },
      useRecoilValue: xn,
      useRecoilValueLoadable: Mn,
      useRecoilState: Rn,
      useRecoilStateLoadable: En,
      useSetRecoilState: Nn,
      useResetRecoilState: kn,
      useRecoilCallback: jn,
      useGotoRecoilSnapshot: _n,
      useRecoilSnapshot: An,
      useRecoilTransactionObserver_UNSTABLE: Tn,
      useTransactionObservation_UNSTABLE: Pn,
      useSetUnvalidatedAtomValues_UNSTABLE: Vn,
      noWait: Cn,
      waitForNone: Dn,
      waitForAny: In,
      waitForAll: Ln,
      isRecoilValue: On
    },
        Bn = Un.DefaultValue,
        Fn = Un.RecoilRoot,
        $n = Un.atom,
        zn = Un.selector,
        Wn = Un.atomFamily,
        qn = Un.selectorFamily,
        Hn = Un.constSelector,
        Gn = Un.errorSelector,
        Yn = Un.readOnlySelector,
        Xn = Un.useRecoilValue,
        Jn = Un.useRecoilValueLoadable,
        Kn = Un.useRecoilState,
        Qn = Un.useRecoilStateLoadable,
        Zn = Un.useSetRecoilState,
        er = Un.useResetRecoilState,
        tr = Un.useRecoilCallback,
        nr = Un.useGotoRecoilSnapshot,
        rr = Un.useRecoilSnapshot,
        or = Un.useRecoilTransactionObserver_UNSTABLE,
        ar = Un.useTransactionObservation_UNSTABLE,
        ir = Un.useSetUnvalidatedAtomValues_UNSTABLE,
        ur = Un.noWait,
        cr = Un.waitForNone,
        sr = Un.waitForAny,
        lr = Un.waitForAll,
        fr = Un.isRecoilValue;
    t.DefaultValue = Bn, t.RecoilRoot = Fn, t.atom = $n, t.atomFamily = Wn, t.constSelector = Hn, t.default = Un, t.errorSelector = Gn, t.isRecoilValue = fr, t.noWait = ur, t.readOnlySelector = Yn, t.selector = zn, t.selectorFamily = qn, t.useGotoRecoilSnapshot = nr, t.useRecoilCallback = tr, t.useRecoilSnapshot = rr, t.useRecoilState = Kn, t.useRecoilStateLoadable = Qn, t.useRecoilTransactionObserver_UNSTABLE = or, t.useRecoilValue = Xn, t.useRecoilValueLoadable = Jn, t.useResetRecoilState = er, t.useSetRecoilState = Zn, t.useSetUnvalidatedAtomValues_UNSTABLE = ir, t.useTransactionObservation_UNSTABLE = ar, t.waitForAll = lr, t.waitForAny = sr, t.waitForNone = cr;
  }, function (e, t, n) {
    var r = n(38),
        o = n(66),
        a = n(67),
        i = n(140),
        u = n(146),
        c = n(149),
        s = n(27),
        l = n(150),
        f = n(152),
        p = n(77),
        d = n(79),
        b = n(29),
        h = n(156),
        y = n(157),
        v = n(162),
        m = n(4),
        g = n(43),
        S = n(163),
        w = n(5),
        O = n(165),
        _ = n(13),
        j = {};

    j["[object Arguments]"] = j["[object Array]"] = j["[object ArrayBuffer]"] = j["[object DataView]"] = j["[object Boolean]"] = j["[object Date]"] = j["[object Float32Array]"] = j["[object Float64Array]"] = j["[object Int8Array]"] = j["[object Int16Array]"] = j["[object Int32Array]"] = j["[object Map]"] = j["[object Number]"] = j["[object Object]"] = j["[object RegExp]"] = j["[object Set]"] = j["[object String]"] = j["[object Symbol]"] = j["[object Uint8Array]"] = j["[object Uint8ClampedArray]"] = j["[object Uint16Array]"] = j["[object Uint32Array]"] = !0, j["[object Error]"] = j["[object Function]"] = j["[object WeakMap]"] = !1, e.exports = function e(t, n, A, R, E, T) {
      var x,
          M = 1 & n,
          k = 2 & n,
          N = 4 & n;
      if (A && (x = E ? A(t, R, E, T) : A(t)), void 0 !== x) return x;
      if (!w(t)) return t;
      var V = m(t);

      if (V) {
        if (x = h(t), !M) return s(t, x);
      } else {
        var P = b(t),
            C = "[object Function]" == P || "[object GeneratorFunction]" == P;
        if (g(t)) return c(t, M);

        if ("[object Object]" == P || "[object Arguments]" == P || C && !E) {
          if (x = k || C ? {} : v(t), !M) return k ? f(t, u(x, t)) : l(t, i(x, t));
        } else {
          if (!j[P]) return E ? t : {};
          x = y(t, P, M);
        }
      }

      T || (T = new r());
      var L = T.get(t);
      if (L) return L;
      T.set(t, x), O(t) ? t.forEach(function (r) {
        x.add(e(r, n, A, r, t, T));
      }) : S(t) && t.forEach(function (r, o) {
        x.set(o, e(r, n, A, o, t, T));
      });
      var I = N ? k ? d : p : k ? keysIn : _,
          D = V ? void 0 : I(t);
      return o(D || t, function (r, o) {
        D && (r = t[o = r]), a(x, o, e(r, n, A, o, t, T));
      }), x;
    };
  }, function (e, t) {
    e.exports = function () {
      this.__data__ = [], this.size = 0;
    };
  }, function (e, t, n) {
    var r = n(21),
        o = Array.prototype.splice;

    e.exports = function (e) {
      var t = this.__data__,
          n = r(t, e);
      return !(n < 0 || (n == t.length - 1 ? t.pop() : o.call(t, n, 1), --this.size, 0));
    };
  }, function (e, t, n) {
    var r = n(21);

    e.exports = function (e) {
      var t = this.__data__,
          n = r(t, e);
      return n < 0 ? void 0 : t[n][1];
    };
  }, function (e, t, n) {
    var r = n(21);

    e.exports = function (e) {
      return r(this.__data__, e) > -1;
    };
  }, function (e, t, n) {
    var r = n(21);

    e.exports = function (e, t) {
      var n = this.__data__,
          o = r(n, e);
      return o < 0 ? (++this.size, n.push([e, t])) : n[o][1] = t, this;
    };
  }, function (e, t, n) {
    var r = n(20);

    e.exports = function () {
      this.__data__ = new r(), this.size = 0;
    };
  }, function (e, t) {
    e.exports = function (e) {
      var t = this.__data__,
          n = t.delete(e);
      return this.size = t.size, n;
    };
  }, function (e, t) {
    e.exports = function (e) {
      return this.__data__.get(e);
    };
  }, function (e, t) {
    e.exports = function (e) {
      return this.__data__.has(e);
    };
  }, function (e, t, n) {
    var r = n(20),
        o = n(39),
        a = n(41);

    e.exports = function (e, t) {
      var n = this.__data__;

      if (n instanceof r) {
        var i = n.__data__;
        if (!o || i.length < 199) return i.push([e, t]), this.size = ++n.size, this;
        n = this.__data__ = new a(i);
      }

      return n.set(e, t), this.size = n.size, this;
    };
  }, function (e, t, n) {
    var r = n(63),
        o = n(125),
        a = n(5),
        i = n(65),
        u = /^\[object .+?Constructor\]$/,
        c = Function.prototype,
        s = Object.prototype,
        l = c.toString,
        f = s.hasOwnProperty,
        p = RegExp("^" + l.call(f).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");

    e.exports = function (e) {
      return !(!a(e) || o(e)) && (r(e) ? p : u).test(i(e));
    };
  }, function (e, t, n) {
    var r = n(10),
        o = Object.prototype,
        a = o.hasOwnProperty,
        i = o.toString,
        u = r ? r.toStringTag : void 0;

    e.exports = function (e) {
      var t = a.call(e, u),
          n = e[u];

      try {
        e[u] = void 0;
        var r = !0;
      } catch (e) {}

      var o = i.call(e);
      return r && (t ? e[u] = n : delete e[u]), o;
    };
  }, function (e, t) {
    var n = Object.prototype.toString;

    e.exports = function (e) {
      return n.call(e);
    };
  }, function (e, t, n) {
    var r,
        o = n(126),
        a = (r = /[^.]+$/.exec(o && o.keys && o.keys.IE_PROTO || "")) ? "Symbol(src)_1." + r : "";

    e.exports = function (e) {
      return !!a && a in e;
    };
  }, function (e, t, n) {
    var r = n(3)["__core-js_shared__"];
    e.exports = r;
  }, function (e, t) {
    e.exports = function (e, t) {
      return null == e ? void 0 : e[t];
    };
  }, function (e, t, n) {
    var r = n(129),
        o = n(20),
        a = n(39);

    e.exports = function () {
      this.size = 0, this.__data__ = {
        hash: new r(),
        map: new (a || o)(),
        string: new r()
      };
    };
  }, function (e, t, n) {
    var r = n(130),
        o = n(131),
        a = n(132),
        i = n(133),
        u = n(134);

    function c(e) {
      var t = -1,
          n = null == e ? 0 : e.length;

      for (this.clear(); ++t < n;) {
        var r = e[t];
        this.set(r[0], r[1]);
      }
    }

    c.prototype.clear = r, c.prototype.delete = o, c.prototype.get = a, c.prototype.has = i, c.prototype.set = u, e.exports = c;
  }, function (e, t, n) {
    var r = n(23);

    e.exports = function () {
      this.__data__ = r ? r(null) : {}, this.size = 0;
    };
  }, function (e, t) {
    e.exports = function (e) {
      var t = this.has(e) && delete this.__data__[e];
      return this.size -= t ? 1 : 0, t;
    };
  }, function (e, t, n) {
    var r = n(23),
        o = Object.prototype.hasOwnProperty;

    e.exports = function (e) {
      var t = this.__data__;

      if (r) {
        var n = t[e];
        return "__lodash_hash_undefined__" === n ? void 0 : n;
      }

      return o.call(t, e) ? t[e] : void 0;
    };
  }, function (e, t, n) {
    var r = n(23),
        o = Object.prototype.hasOwnProperty;

    e.exports = function (e) {
      var t = this.__data__;
      return r ? void 0 !== t[e] : o.call(t, e);
    };
  }, function (e, t, n) {
    var r = n(23);

    e.exports = function (e, t) {
      var n = this.__data__;
      return this.size += this.has(e) ? 0 : 1, n[e] = r && void 0 === t ? "__lodash_hash_undefined__" : t, this;
    };
  }, function (e, t, n) {
    var r = n(24);

    e.exports = function (e) {
      var t = r(this, e).delete(e);
      return this.size -= t ? 1 : 0, t;
    };
  }, function (e, t) {
    e.exports = function (e) {
      var t = typeof e;
      return "string" == t || "number" == t || "symbol" == t || "boolean" == t ? "__proto__" !== e : null === e;
    };
  }, function (e, t, n) {
    var r = n(24);

    e.exports = function (e) {
      return r(this, e).get(e);
    };
  }, function (e, t, n) {
    var r = n(24);

    e.exports = function (e) {
      return r(this, e).has(e);
    };
  }, function (e, t, n) {
    var r = n(24);

    e.exports = function (e, t) {
      var n = r(this, e),
          o = n.size;
      return n.set(e, t), this.size += n.size == o ? 0 : 1, this;
    };
  }, function (e, t, n) {
    var r = n(12),
        o = n(13);

    e.exports = function (e, t) {
      return e && r(t, o(t), e);
    };
  }, function (e, t, n) {
    var r = n(9),
        o = n(7);

    e.exports = function (e) {
      return o(e) && "[object Arguments]" == r(e);
    };
  }, function (e, t) {
    e.exports = function () {
      return !1;
    };
  }, function (e, t, n) {
    var r = n(9),
        o = n(45),
        a = n(7),
        i = {};
    i["[object Float32Array]"] = i["[object Float64Array]"] = i["[object Int8Array]"] = i["[object Int16Array]"] = i["[object Int32Array]"] = i["[object Uint8Array]"] = i["[object Uint8ClampedArray]"] = i["[object Uint16Array]"] = i["[object Uint32Array]"] = !0, i["[object Arguments]"] = i["[object Array]"] = i["[object ArrayBuffer]"] = i["[object Boolean]"] = i["[object DataView]"] = i["[object Date]"] = i["[object Error]"] = i["[object Function]"] = i["[object Map]"] = i["[object Number]"] = i["[object Object]"] = i["[object RegExp]"] = i["[object Set]"] = i["[object String]"] = i["[object WeakMap]"] = !1, e.exports = function (e) {
      return a(e) && o(e.length) && !!i[r(e)];
    };
  }, function (e, t, n) {
    var r = n(47),
        o = n(145),
        a = Object.prototype.hasOwnProperty;

    e.exports = function (e) {
      if (!r(e)) return o(e);
      var t = [];

      for (var n in Object(e)) {
        a.call(e, n) && "constructor" != n && t.push(n);
      }

      return t;
    };
  }, function (e, t, n) {
    var r = n(73)(Object.keys, Object);
    e.exports = r;
  }, function (e, t, n) {
    var r = n(12),
        o = n(74);

    e.exports = function (e, t) {
      return e && r(t, o(t), e);
    };
  }, function (e, t, n) {
    var r = n(5),
        o = n(47),
        a = n(148),
        i = Object.prototype.hasOwnProperty;

    e.exports = function (e) {
      if (!r(e)) return a(e);
      var t = o(e),
          n = [];

      for (var u in e) {
        ("constructor" != u || !t && i.call(e, u)) && n.push(u);
      }

      return n;
    };
  }, function (e, t) {
    e.exports = function (e) {
      var t = [];
      if (null != e) for (var n in Object(e)) {
        t.push(n);
      }
      return t;
    };
  }, function (e, t, n) {
    (function (e) {
      var r = n(3),
          o = t && !t.nodeType && t,
          a = o && "object" == typeof e && e && !e.nodeType && e,
          i = a && a.exports === o ? r.Buffer : void 0,
          u = i ? i.allocUnsafe : void 0;

      e.exports = function (e, t) {
        if (t) return e.slice();
        var n = e.length,
            r = u ? u(n) : new e.constructor(n);
        return e.copy(r), r;
      };
    }).call(this, n(44)(e));
  }, function (e, t, n) {
    var r = n(12),
        o = n(48);

    e.exports = function (e, t) {
      return r(e, o(e), t);
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      for (var n = -1, r = null == e ? 0 : e.length, o = 0, a = []; ++n < r;) {
        var i = e[n];
        t(i, n, e) && (a[o++] = i);
      }

      return a;
    };
  }, function (e, t, n) {
    var r = n(12),
        o = n(76);

    e.exports = function (e, t) {
      return r(e, o(e), t);
    };
  }, function (e, t, n) {
    var r = n(8)(n(3), "DataView");
    e.exports = r;
  }, function (e, t, n) {
    var r = n(8)(n(3), "Promise");
    e.exports = r;
  }, function (e, t, n) {
    var r = n(8)(n(3), "Set");
    e.exports = r;
  }, function (e, t) {
    var n = Object.prototype.hasOwnProperty;

    e.exports = function (e) {
      var t = e.length,
          r = new e.constructor(t);
      return t && "string" == typeof e[0] && n.call(e, "index") && (r.index = e.index, r.input = e.input), r;
    };
  }, function (e, t, n) {
    var r = n(50),
        o = n(158),
        a = n(159),
        i = n(160),
        u = n(161);

    e.exports = function (e, t, n) {
      var c = e.constructor;

      switch (t) {
        case "[object ArrayBuffer]":
          return r(e);

        case "[object Boolean]":
        case "[object Date]":
          return new c(+e);

        case "[object DataView]":
          return o(e, n);

        case "[object Float32Array]":
        case "[object Float64Array]":
        case "[object Int8Array]":
        case "[object Int16Array]":
        case "[object Int32Array]":
        case "[object Uint8Array]":
        case "[object Uint8ClampedArray]":
        case "[object Uint16Array]":
        case "[object Uint32Array]":
          return u(e, n);

        case "[object Map]":
          return new c();

        case "[object Number]":
        case "[object String]":
          return new c(e);

        case "[object RegExp]":
          return a(e);

        case "[object Set]":
          return new c();

        case "[object Symbol]":
          return i(e);
      }
    };
  }, function (e, t, n) {
    var r = n(50);

    e.exports = function (e, t) {
      var n = t ? r(e.buffer) : e.buffer;
      return new e.constructor(n, e.byteOffset, e.byteLength);
    };
  }, function (e, t) {
    var n = /\w*$/;

    e.exports = function (e) {
      var t = new e.constructor(e.source, n.exec(e));
      return t.lastIndex = e.lastIndex, t;
    };
  }, function (e, t, n) {
    var r = n(10),
        o = r ? r.prototype : void 0,
        a = o ? o.valueOf : void 0;

    e.exports = function (e) {
      return a ? Object(a.call(e)) : {};
    };
  }, function (e, t, n) {
    var r = n(50);

    e.exports = function (e, t) {
      var n = t ? r(e.buffer) : e.buffer;
      return new e.constructor(n, e.byteOffset, e.length);
    };
  }, function (e, t, n) {
    var r = n(30),
        o = n(49),
        a = n(47);

    e.exports = function (e) {
      return "function" != typeof e.constructor || a(e) ? {} : r(o(e));
    };
  }, function (e, t, n) {
    var r = n(164),
        o = n(26),
        a = n(46),
        i = a && a.isMap,
        u = i ? o(i) : r;
    e.exports = u;
  }, function (e, t, n) {
    var r = n(29),
        o = n(7);

    e.exports = function (e) {
      return o(e) && "[object Map]" == r(e);
    };
  }, function (e, t, n) {
    var r = n(166),
        o = n(26),
        a = n(46),
        i = a && a.isSet,
        u = i ? o(i) : r;
    e.exports = u;
  }, function (e, t, n) {
    var r = n(29),
        o = n(7);

    e.exports = function (e) {
      return o(e) && "[object Set]" == r(e);
    };
  }, function (e, t, n) {
    var r = n(31),
        o = n(173),
        a = n(174),
        i = n(16);

    e.exports = function (e, t) {
      return t = r(t, e), null == (e = a(e, t)) || delete e[i(o(t))];
    };
  }, function (e, t, n) {
    var r = n(169),
        o = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
        a = /\\(\\)?/g,
        i = r(function (e) {
      var t = [];
      return 46 === e.charCodeAt(0) && t.push(""), e.replace(o, function (e, n, r, o) {
        t.push(r ? o.replace(a, "$1") : n || e);
      }), t;
    });
    e.exports = i;
  }, function (e, t, n) {
    var r = n(170);

    e.exports = function (e) {
      var t = r(e, function (e) {
        return 500 === n.size && n.clear(), e;
      }),
          n = t.cache;
      return t;
    };
  }, function (e, t, n) {
    var r = n(41);

    function o(e, t) {
      if ("function" != typeof e || null != t && "function" != typeof t) throw new TypeError("Expected a function");

      var n = function n() {
        var r = arguments,
            o = t ? t.apply(this, r) : r[0],
            a = n.cache;
        if (a.has(o)) return a.get(o);
        var i = e.apply(this, r);
        return n.cache = a.set(o, i) || a, i;
      };

      return n.cache = new (o.Cache || r)(), n;
    }

    o.Cache = r, e.exports = o;
  }, function (e, t, n) {
    var r = n(172);

    e.exports = function (e) {
      return null == e ? "" : r(e);
    };
  }, function (e, t, n) {
    var r = n(10),
        o = n(37),
        a = n(4),
        i = n(15),
        u = r ? r.prototype : void 0,
        c = u ? u.toString : void 0;

    e.exports = function e(t) {
      if ("string" == typeof t) return t;
      if (a(t)) return o(t, e) + "";
      if (i(t)) return c ? c.call(t) : "";
      var n = t + "";
      return "0" == n && 1 / t == -1 / 0 ? "-0" : n;
    };
  }, function (e, t) {
    e.exports = function (e) {
      var t = null == e ? 0 : e.length;
      return t ? e[t - 1] : void 0;
    };
  }, function (e, t, n) {
    var r = n(52),
        o = n(175);

    e.exports = function (e, t) {
      return t.length < 2 ? e : r(e, o(t, 0, -1));
    };
  }, function (e, t) {
    e.exports = function (e, t, n) {
      var r = -1,
          o = e.length;
      t < 0 && (t = -t > o ? 0 : o + t), (n = n > o ? o : n) < 0 && (n += o), o = t > n ? 0 : n - t >>> 0, t >>>= 0;

      for (var a = Array(o); ++r < o;) {
        a[r] = e[r + t];
      }

      return a;
    };
  }, function (e, t, n) {
    var r = n(177);

    e.exports = function (e) {
      return r(e) ? void 0 : e;
    };
  }, function (e, t, n) {
    var r = n(9),
        o = n(49),
        a = n(7),
        i = Function.prototype,
        u = Object.prototype,
        c = i.toString,
        s = u.hasOwnProperty,
        l = c.call(Object);

    e.exports = function (e) {
      if (!a(e) || "[object Object]" != r(e)) return !1;
      var t = o(e);
      if (null === t) return !0;
      var n = s.call(t, "constructor") && t.constructor;
      return "function" == typeof n && n instanceof n && c.call(n) == l;
    };
  }, function (e, t, n) {
    var r = n(10),
        o = n(42),
        a = n(4),
        i = r ? r.isConcatSpreadable : void 0;

    e.exports = function (e) {
      return a(e) || o(e) || !!(i && e && e[i]);
    };
  }, function (e, t, n) {
    var r = n(180),
        o = n(69),
        a = n(11),
        i = o ? function (e, t) {
      return o(e, "toString", {
        configurable: !0,
        enumerable: !1,
        value: r(t),
        writable: !0
      });
    } : a;
    e.exports = i;
  }, function (e, t) {
    e.exports = function (e) {
      return function () {
        return e;
      };
    };
  }, function (e, t, n) {
    "use strict";

    var r = "function" == typeof Symbol && Symbol.for,
        o = r ? Symbol.for("react.element") : 60103,
        a = r ? Symbol.for("react.portal") : 60106,
        i = r ? Symbol.for("react.fragment") : 60107,
        u = r ? Symbol.for("react.strict_mode") : 60108,
        c = r ? Symbol.for("react.profiler") : 60114,
        s = r ? Symbol.for("react.provider") : 60109,
        l = r ? Symbol.for("react.context") : 60110,
        f = r ? Symbol.for("react.async_mode") : 60111,
        p = r ? Symbol.for("react.concurrent_mode") : 60111,
        d = r ? Symbol.for("react.forward_ref") : 60112,
        b = r ? Symbol.for("react.suspense") : 60113,
        h = r ? Symbol.for("react.suspense_list") : 60120,
        y = r ? Symbol.for("react.memo") : 60115,
        v = r ? Symbol.for("react.lazy") : 60116,
        m = r ? Symbol.for("react.block") : 60121,
        g = r ? Symbol.for("react.fundamental") : 60117,
        S = r ? Symbol.for("react.responder") : 60118,
        w = r ? Symbol.for("react.scope") : 60119;

    function O(e) {
      if ("object" == typeof e && null !== e) {
        var t = e.$$typeof;

        switch (t) {
          case o:
            switch (e = e.type) {
              case f:
              case p:
              case i:
              case c:
              case u:
              case b:
                return e;

              default:
                switch (e = e && e.$$typeof) {
                  case l:
                  case d:
                  case v:
                  case y:
                  case s:
                    return e;

                  default:
                    return t;
                }

            }

          case a:
            return t;
        }
      }
    }

    function _(e) {
      return O(e) === p;
    }

    t.AsyncMode = f, t.ConcurrentMode = p, t.ContextConsumer = l, t.ContextProvider = s, t.Element = o, t.ForwardRef = d, t.Fragment = i, t.Lazy = v, t.Memo = y, t.Portal = a, t.Profiler = c, t.StrictMode = u, t.Suspense = b, t.isAsyncMode = function (e) {
      return _(e) || O(e) === f;
    }, t.isConcurrentMode = _, t.isContextConsumer = function (e) {
      return O(e) === l;
    }, t.isContextProvider = function (e) {
      return O(e) === s;
    }, t.isElement = function (e) {
      return "object" == typeof e && null !== e && e.$$typeof === o;
    }, t.isForwardRef = function (e) {
      return O(e) === d;
    }, t.isFragment = function (e) {
      return O(e) === i;
    }, t.isLazy = function (e) {
      return O(e) === v;
    }, t.isMemo = function (e) {
      return O(e) === y;
    }, t.isPortal = function (e) {
      return O(e) === a;
    }, t.isProfiler = function (e) {
      return O(e) === c;
    }, t.isStrictMode = function (e) {
      return O(e) === u;
    }, t.isSuspense = function (e) {
      return O(e) === b;
    }, t.isValidElementType = function (e) {
      return "string" == typeof e || "function" == typeof e || e === i || e === p || e === c || e === u || e === b || e === h || "object" == typeof e && null !== e && (e.$$typeof === v || e.$$typeof === y || e.$$typeof === s || e.$$typeof === l || e.$$typeof === d || e.$$typeof === g || e.$$typeof === S || e.$$typeof === w || e.$$typeof === m);
    }, t.typeOf = O;
  }, function (e, t, n) {
    "use strict";

    !function () {
      var e = "function" == typeof Symbol && Symbol.for,
          n = e ? Symbol.for("react.element") : 60103,
          r = e ? Symbol.for("react.portal") : 60106,
          o = e ? Symbol.for("react.fragment") : 60107,
          a = e ? Symbol.for("react.strict_mode") : 60108,
          i = e ? Symbol.for("react.profiler") : 60114,
          u = e ? Symbol.for("react.provider") : 60109,
          c = e ? Symbol.for("react.context") : 60110,
          s = e ? Symbol.for("react.async_mode") : 60111,
          l = e ? Symbol.for("react.concurrent_mode") : 60111,
          f = e ? Symbol.for("react.forward_ref") : 60112,
          p = e ? Symbol.for("react.suspense") : 60113,
          d = e ? Symbol.for("react.suspense_list") : 60120,
          b = e ? Symbol.for("react.memo") : 60115,
          h = e ? Symbol.for("react.lazy") : 60116,
          y = e ? Symbol.for("react.block") : 60121,
          v = e ? Symbol.for("react.fundamental") : 60117,
          m = e ? Symbol.for("react.responder") : 60118,
          g = e ? Symbol.for("react.scope") : 60119;

      function S(e) {
        if ("object" == typeof e && null !== e) {
          var t = e.$$typeof;

          switch (t) {
            case n:
              var d = e.type;

              switch (d) {
                case s:
                case l:
                case o:
                case i:
                case a:
                case p:
                  return d;

                default:
                  var y = d && d.$$typeof;

                  switch (y) {
                    case c:
                    case f:
                    case h:
                    case b:
                    case u:
                      return y;

                    default:
                      return t;
                  }

              }

            case r:
              return t;
          }
        }
      }

      var w = s,
          O = l,
          _ = c,
          j = u,
          A = n,
          R = f,
          E = o,
          T = h,
          x = b,
          M = r,
          k = i,
          N = a,
          V = p,
          P = !1;

      function C(e) {
        return S(e) === l;
      }

      t.AsyncMode = w, t.ConcurrentMode = O, t.ContextConsumer = _, t.ContextProvider = j, t.Element = A, t.ForwardRef = R, t.Fragment = E, t.Lazy = T, t.Memo = x, t.Portal = M, t.Profiler = k, t.StrictMode = N, t.Suspense = V, t.isAsyncMode = function (e) {
        return P || (P = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), C(e) || S(e) === s;
      }, t.isConcurrentMode = C, t.isContextConsumer = function (e) {
        return S(e) === c;
      }, t.isContextProvider = function (e) {
        return S(e) === u;
      }, t.isElement = function (e) {
        return "object" == typeof e && null !== e && e.$$typeof === n;
      }, t.isForwardRef = function (e) {
        return S(e) === f;
      }, t.isFragment = function (e) {
        return S(e) === o;
      }, t.isLazy = function (e) {
        return S(e) === h;
      }, t.isMemo = function (e) {
        return S(e) === b;
      }, t.isPortal = function (e) {
        return S(e) === r;
      }, t.isProfiler = function (e) {
        return S(e) === i;
      }, t.isStrictMode = function (e) {
        return S(e) === a;
      }, t.isSuspense = function (e) {
        return S(e) === p;
      }, t.isValidElementType = function (e) {
        return "string" == typeof e || "function" == typeof e || e === o || e === l || e === i || e === a || e === p || e === d || "object" == typeof e && null !== e && (e.$$typeof === h || e.$$typeof === b || e.$$typeof === u || e.$$typeof === c || e.$$typeof === f || e.$$typeof === v || e.$$typeof === m || e.$$typeof === g || e.$$typeof === y);
      }, t.typeOf = S;
    }();
  }, function (e, t, n) {
    "use strict";

    var r,
        o = n(85),
        a = n(184),
        i = n(56),
        u = n(185),
        c = Function.call.bind(Object.prototype.hasOwnProperty);

    function s() {
      return null;
    }

    r = function r(e) {
      var t = "Warning: " + e;
      "undefined" != typeof console && console.error(t);

      try {
        throw new Error(t);
      } catch (e) {}
    }, e.exports = function (e, t) {
      var n = "function" == typeof Symbol && Symbol.iterator,
          l = {
        array: b("array"),
        bool: b("boolean"),
        func: b("function"),
        number: b("number"),
        object: b("object"),
        string: b("string"),
        symbol: b("symbol"),
        any: d(s),
        arrayOf: function arrayOf(e) {
          return d(function (t, n, r, o, a) {
            if ("function" != typeof e) return new p("Property `" + a + "` of component `" + r + "` has invalid PropType notation inside arrayOf.");
            var u = t[n];
            if (!Array.isArray(u)) return new p("Invalid " + o + " `" + a + "` of type `" + y(u) + "` supplied to `" + r + "`, expected an array.");

            for (var c = 0; c < u.length; c++) {
              var s = e(u, c, r, o, a + "[" + c + "]", i);
              if (s instanceof Error) return s;
            }

            return null;
          });
        },
        element: d(function (t, n, r, o, a) {
          var i = t[n];
          return e(i) ? null : new p("Invalid " + o + " `" + a + "` of type `" + y(i) + "` supplied to `" + r + "`, expected a single ReactElement.");
        }),
        elementType: d(function (e, t, n, r, a) {
          var i = e[t];
          return o.isValidElementType(i) ? null : new p("Invalid " + r + " `" + a + "` of type `" + y(i) + "` supplied to `" + n + "`, expected a single ReactElement type.");
        }),
        instanceOf: function instanceOf(e) {
          return d(function (t, n, r, o, a) {
            if (!(t[n] instanceof e)) {
              var i = e.name || "<<anonymous>>";
              return new p("Invalid " + o + " `" + a + "` of type `" + function (e) {
                return e.constructor && e.constructor.name ? e.constructor.name : "<<anonymous>>";
              }(t[n]) + "` supplied to `" + r + "`, expected instance of `" + i + "`.");
            }

            return null;
          });
        },
        node: d(function (e, t, n, r, o) {
          return h(e[t]) ? null : new p("Invalid " + r + " `" + o + "` supplied to `" + n + "`, expected a ReactNode.");
        }),
        objectOf: function objectOf(e) {
          return d(function (t, n, r, o, a) {
            if ("function" != typeof e) return new p("Property `" + a + "` of component `" + r + "` has invalid PropType notation inside objectOf.");
            var u = t[n],
                s = y(u);
            if ("object" !== s) return new p("Invalid " + o + " `" + a + "` of type `" + s + "` supplied to `" + r + "`, expected an object.");

            for (var l in u) {
              if (c(u, l)) {
                var f = e(u, l, r, o, a + "." + l, i);
                if (f instanceof Error) return f;
              }
            }

            return null;
          });
        },
        oneOf: function oneOf(e) {
          if (!Array.isArray(e)) return r(arguments.length > 1 ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), s;

          function t(t, n, r, o, a) {
            for (var i = t[n], u = 0; u < e.length; u++) {
              if (f(i, e[u])) return null;
            }

            var c = JSON.stringify(e, function (e, t) {
              return "symbol" === v(t) ? String(t) : t;
            });
            return new p("Invalid " + o + " `" + a + "` of value `" + String(i) + "` supplied to `" + r + "`, expected one of " + c + ".");
          }

          return d(t);
        },
        oneOfType: function oneOfType(e) {
          if (!Array.isArray(e)) return r("Invalid argument supplied to oneOfType, expected an instance of array."), s;

          for (var t = 0; t < e.length; t++) {
            var n = e[t];
            if ("function" != typeof n) return r("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + m(n) + " at index " + t + "."), s;
          }

          return d(function (t, n, r, o, a) {
            for (var u = 0; u < e.length; u++) {
              if (null == (0, e[u])(t, n, r, o, a, i)) return null;
            }

            return new p("Invalid " + o + " `" + a + "` supplied to `" + r + "`.");
          });
        },
        shape: function shape(e) {
          return d(function (t, n, r, o, a) {
            var u = t[n],
                c = y(u);
            if ("object" !== c) return new p("Invalid " + o + " `" + a + "` of type `" + c + "` supplied to `" + r + "`, expected `object`.");

            for (var s in e) {
              var l = e[s];

              if (l) {
                var f = l(u, s, r, o, a + "." + s, i);
                if (f) return f;
              }
            }

            return null;
          });
        },
        exact: function exact(e) {
          return d(function (t, n, r, o, u) {
            var c = t[n],
                s = y(c);
            if ("object" !== s) return new p("Invalid " + o + " `" + u + "` of type `" + s + "` supplied to `" + r + "`, expected `object`.");
            var l = a({}, t[n], e);

            for (var f in l) {
              var d = e[f];
              if (!d) return new p("Invalid " + o + " `" + u + "` key `" + f + "` supplied to `" + r + "`.\nBad object: " + JSON.stringify(t[n], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(e), null, "  "));
              var b = d(c, f, r, o, u + "." + f, i);
              if (b) return b;
            }

            return null;
          });
        }
      };

      function f(e, t) {
        return e === t ? 0 !== e || 1 / e == 1 / t : e != e && t != t;
      }

      function p(e) {
        this.message = e, this.stack = "";
      }

      function d(e) {
        var n = {},
            o = 0;

        function a(a, u, c, s, l, f, d) {
          if (s = s || "<<anonymous>>", f = f || c, d !== i) {
            if (t) {
              var b = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
              throw b.name = "Invariant Violation", b;
            }

            if ("undefined" != typeof console) {
              var h = s + ":" + c;
              !n[h] && o < 3 && (r("You are manually calling a React.PropTypes validation function for the `" + f + "` prop on `" + s + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), n[h] = !0, o++);
            }
          }

          return null == u[c] ? a ? null === u[c] ? new p("The " + l + " `" + f + "` is marked as required in `" + s + "`, but its value is `null`.") : new p("The " + l + " `" + f + "` is marked as required in `" + s + "`, but its value is `undefined`.") : null : e(u, c, s, l, f);
        }

        var u = a.bind(null, !1);
        return u.isRequired = a.bind(null, !0), u;
      }

      function b(e) {
        return d(function (t, n, r, o, a, i) {
          var u = t[n];
          return y(u) !== e ? new p("Invalid " + o + " `" + a + "` of type `" + v(u) + "` supplied to `" + r + "`, expected `" + e + "`.") : null;
        });
      }

      function h(t) {
        switch (typeof t) {
          case "number":
          case "string":
          case "undefined":
            return !0;

          case "boolean":
            return !t;

          case "object":
            if (Array.isArray(t)) return t.every(h);
            if (null === t || e(t)) return !0;

            var r = function (e) {
              var t = e && (n && e[n] || e["@@iterator"]);
              if ("function" == typeof t) return t;
            }(t);

            if (!r) return !1;
            var o,
                a = r.call(t);

            if (r !== t.entries) {
              for (; !(o = a.next()).done;) {
                if (!h(o.value)) return !1;
              }
            } else for (; !(o = a.next()).done;) {
              var i = o.value;
              if (i && !h(i[1])) return !1;
            }

            return !0;

          default:
            return !1;
        }
      }

      function y(e) {
        var t = typeof e;
        return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : function (e, t) {
          return "symbol" === e || !!t && ("Symbol" === t["@@toStringTag"] || "function" == typeof Symbol && t instanceof Symbol);
        }(t, e) ? "symbol" : t;
      }

      function v(e) {
        if (null == e) return "" + e;
        var t = y(e);

        if ("object" === t) {
          if (e instanceof Date) return "date";
          if (e instanceof RegExp) return "regexp";
        }

        return t;
      }

      function m(e) {
        var t = v(e);

        switch (t) {
          case "array":
          case "object":
            return "an " + t;

          case "boolean":
          case "date":
          case "regexp":
            return "a " + t;

          default:
            return t;
        }
      }

      return p.prototype = Error.prototype, l.checkPropTypes = u, l.resetWarningCache = u.resetWarningCache, l.PropTypes = l, l;
    };
  }, function (e, t, n) {
    "use strict";

    var r = Object.getOwnPropertySymbols,
        o = Object.prototype.hasOwnProperty,
        a = Object.prototype.propertyIsEnumerable;

    function i(e) {
      if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
      return Object(e);
    }

    e.exports = function () {
      try {
        if (!Object.assign) return !1;
        var e = new String("abc");
        if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;

        for (var t = {}, n = 0; n < 10; n++) {
          t["_" + String.fromCharCode(n)] = n;
        }

        if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
          return t[e];
        }).join("")) return !1;
        var r = {};
        return "abcdefghijklmnopqrst".split("").forEach(function (e) {
          r[e] = e;
        }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
      } catch (e) {
        return !1;
      }
    }() ? Object.assign : function (e, t) {
      for (var n, u, c = i(e), s = 1; s < arguments.length; s++) {
        for (var l in n = Object(arguments[s])) {
          o.call(n, l) && (c[l] = n[l]);
        }

        if (r) {
          u = r(n);

          for (var f = 0; f < u.length; f++) {
            a.call(n, u[f]) && (c[u[f]] = n[u[f]]);
          }
        }
      }

      return c;
    };
  }, function (e, t, n) {
    "use strict";

    var r = function r() {},
        o = n(56),
        a = {},
        i = Function.call.bind(Object.prototype.hasOwnProperty);

    function u(e, t, n, u, c) {
      for (var s in e) {
        if (i(e, s)) {
          var l;

          try {
            if ("function" != typeof e[s]) {
              var f = Error((u || "React class") + ": " + n + " type `" + s + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[s] + "`.");
              throw f.name = "Invariant Violation", f;
            }

            l = e[s](t, s, u, n, null, o);
          } catch (e) {
            l = e;
          }

          if (!l || l instanceof Error || r((u || "React class") + ": type specification of " + n + " `" + s + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof l + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), l instanceof Error && !(l.message in a)) {
            a[l.message] = !0;
            var p = c ? c() : "";
            r("Failed " + n + " type: " + l.message + (null != p ? p : ""));
          }
        }
      }
    }

    r = function r(e) {
      var t = "Warning: " + e;
      "undefined" != typeof console && console.error(t);

      try {
        throw new Error(t);
      } catch (e) {}
    }, u.resetWarningCache = function () {
      a = {};
    }, e.exports = u;
  }, function (e, t, n) {
    "use strict";

    var r = n(56);

    function o() {}

    function a() {}

    a.resetWarningCache = o, e.exports = function () {
      function e(e, t, n, o, a, i) {
        if (i !== r) {
          var u = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw u.name = "Invariant Violation", u;
        }
      }

      function t() {
        return e;
      }

      e.isRequired = e;
      var n = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        elementType: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t,
        checkPropTypes: a,
        resetWarningCache: o
      };
      return n.PropTypes = n, n;
    };
  }, function (e, t, n) {
    var r = n(57),
        o = n(82),
        a = n(59),
        i = n(87),
        u = n(4),
        c = n(88);

    e.exports = function (e) {
      return o(function (t) {
        var n = t.length,
            o = n,
            s = r.prototype.thru;

        for (e && t.reverse(); o--;) {
          var l = t[o];
          if ("function" != typeof l) throw new TypeError("Expected a function");
          if (s && !f && "wrapper" == i(l)) var f = new r([], !0);
        }

        for (o = f ? o : n; ++o < n;) {
          l = t[o];
          var p = i(l),
              d = "wrapper" == p ? a(l) : void 0;
          f = d && c(d[0]) && 424 == d[1] && !d[4].length && 1 == d[9] ? f[i(d[0])].apply(f, d[3]) : 1 == l.length && c(l) ? f[p]() : f.thru(l);
        }

        return function () {
          var e = arguments,
              r = e[0];
          if (f && 1 == e.length && u(r)) return f.plant(r).value();

          for (var o = 0, a = n ? t[o].apply(this, e) : r; ++o < n;) {
            a = t[o].call(this, a);
          }

          return a;
        };
      });
    };
  }, function (e, t) {
    e.exports = function () {};
  }, function (e, t) {
    e.exports = {};
  }, function (e, t, n) {
    var r = n(60),
        o = n(57),
        a = n(58),
        i = n(4),
        u = n(7),
        c = n(191),
        s = Object.prototype.hasOwnProperty;

    function l(e) {
      if (u(e) && !i(e) && !(e instanceof r)) {
        if (e instanceof o) return e;
        if (s.call(e, "__wrapped__")) return c(e);
      }

      return new o(e);
    }

    l.prototype = a.prototype, l.prototype.constructor = l, e.exports = l;
  }, function (e, t, n) {
    var r = n(60),
        o = n(57),
        a = n(27);

    e.exports = function (e) {
      if (e instanceof r) return e.clone();
      var t = new o(e.__wrapped__, e.__chain__);
      return t.__actions__ = a(e.__actions__), t.__index__ = e.__index__, t.__values__ = e.__values__, t;
    };
  }, function (e, t, n) {
    var r = n(90),
        o = n(193),
        a = n(194),
        i = n(91),
        u = n(205),
        c = n(59),
        s = n(206),
        l = n(95),
        f = n(96),
        p = n(97),
        d = Math.max;

    e.exports = function (e, t, n, b, h, y, v, m) {
      var g = 2 & t;
      if (!g && "function" != typeof e) throw new TypeError("Expected a function");
      var S = b ? b.length : 0;

      if (S || (t &= -97, b = h = void 0), v = void 0 === v ? v : d(p(v), 0), m = void 0 === m ? m : p(m), S -= h ? h.length : 0, 64 & t) {
        var w = b,
            O = h;
        b = h = void 0;
      }

      var _ = g ? void 0 : c(e),
          j = [e, t, n, b, h, w, O, y, v, m];

      if (_ && s(j, _), e = j[0], t = j[1], n = j[2], b = j[3], h = j[4], !(m = j[9] = void 0 === j[9] ? g ? 0 : e.length : d(j[9] - S, 0)) && 24 & t && (t &= -25), t && 1 != t) A = 8 == t || 16 == t ? a(e, t, m) : 32 != t && 33 != t || h.length ? i.apply(void 0, j) : u(e, t, n, b);else var A = o(e, t, n);
      return f((_ ? r : l)(A, j), e, t);
    };
  }, function (e, t, n) {
    var r = n(32),
        o = n(3);

    e.exports = function (e, t, n) {
      var a = 1 & t,
          i = r(e);
      return function t() {
        var r = this && this !== o && this instanceof t ? i : e;
        return r.apply(a ? n : this, arguments);
      };
    };
  }, function (e, t, n) {
    var r = n(54),
        o = n(32),
        a = n(91),
        i = n(94),
        u = n(61),
        c = n(33),
        s = n(3);

    e.exports = function (e, t, n) {
      var l = o(e);
      return function o() {
        for (var f = arguments.length, p = Array(f), d = f, b = u(o); d--;) {
          p[d] = arguments[d];
        }

        var h = f < 3 && p[0] !== b && p[f - 1] !== b ? [] : c(p, b);
        if ((f -= h.length) < n) return i(e, t, a, o.placeholder, void 0, p, h, void 0, void 0, n - f);
        var y = this && this !== s && this instanceof o ? l : e;
        return r(y, this, p);
      };
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      for (var n = e.length, r = 0; n--;) {
        e[n] === t && ++r;
      }

      return r;
    };
  }, function (e, t) {
    var n = /\{\n\/\* \[wrapped with (.+)\] \*/,
        r = /,? & /;

    e.exports = function (e) {
      var t = e.match(n);
      return t ? t[1].split(r) : [];
    };
  }, function (e, t) {
    var n = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;

    e.exports = function (e, t) {
      var r = t.length;
      if (!r) return e;
      var o = r - 1;
      return t[o] = (r > 1 ? "& " : "") + t[o], t = t.join(r > 2 ? ", " : " "), e.replace(n, "{\n/* [wrapped with " + t + "] */\n");
    };
  }, function (e, t, n) {
    var r = n(66),
        o = n(199),
        a = [["ary", 128], ["bind", 1], ["bindKey", 2], ["curry", 8], ["curryRight", 16], ["flip", 512], ["partial", 32], ["partialRight", 64], ["rearg", 256]];

    e.exports = function (e, t) {
      return r(a, function (n) {
        var r = "_." + n[0];
        t & n[1] && !o(e, r) && e.push(r);
      }), e.sort();
    };
  }, function (e, t, n) {
    var r = n(200);

    e.exports = function (e, t) {
      return !(null == e || !e.length) && r(e, t, 0) > -1;
    };
  }, function (e, t, n) {
    var r = n(201),
        o = n(202),
        a = n(203);

    e.exports = function (e, t, n) {
      return t == t ? a(e, t, n) : r(e, o, n);
    };
  }, function (e, t) {
    e.exports = function (e, t, n, r) {
      for (var o = e.length, a = n + (r ? 1 : -1); r ? a-- : ++a < o;) {
        if (t(e[a], a, e)) return a;
      }

      return -1;
    };
  }, function (e, t) {
    e.exports = function (e) {
      return e != e;
    };
  }, function (e, t) {
    e.exports = function (e, t, n) {
      for (var r = n - 1, o = e.length; ++r < o;) {
        if (e[r] === t) return r;
      }

      return -1;
    };
  }, function (e, t, n) {
    var r = n(27),
        o = n(25),
        a = Math.min;

    e.exports = function (e, t) {
      for (var n = e.length, i = a(t.length, n), u = r(e); i--;) {
        var c = t[i];
        e[i] = o(c, n) ? u[c] : void 0;
      }

      return e;
    };
  }, function (e, t, n) {
    var r = n(54),
        o = n(32),
        a = n(3);

    e.exports = function (e, t, n, i) {
      var u = 1 & t,
          c = o(e);
      return function t() {
        for (var o = -1, s = arguments.length, l = -1, f = i.length, p = Array(f + s), d = this && this !== a && this instanceof t ? c : e; ++l < f;) {
          p[l] = i[l];
        }

        for (; s--;) {
          p[l++] = arguments[++o];
        }

        return r(d, u ? n : this, p);
      };
    };
  }, function (e, t, n) {
    var r = n(92),
        o = n(93),
        a = n(33),
        i = Math.min;

    e.exports = function (e, t) {
      var n = e[1],
          u = t[1],
          c = n | u,
          s = c < 131,
          l = 128 == u && 8 == n || 128 == u && 256 == n && e[7].length <= t[8] || 384 == u && t[7].length <= t[8] && 8 == n;
      if (!s && !l) return e;
      1 & u && (e[2] = t[2], c |= 1 & n ? 0 : 4);
      var f = t[3];

      if (f) {
        var p = e[3];
        e[3] = p ? r(p, f, t[4]) : f, e[4] = p ? a(e[3], "__lodash_placeholder__") : t[4];
      }

      return (f = t[5]) && (p = e[5], e[5] = p ? o(p, f, t[6]) : f, e[6] = p ? a(e[5], "__lodash_placeholder__") : t[6]), (f = t[7]) && (e[7] = f), 128 & u && (e[8] = null == e[8] ? t[8] : i(e[8], t[8])), null == e[9] && (e[9] = t[9]), e[0] = t[0], e[1] = c, e;
    };
  }, function (e, t, n) {
    var r = n(98);

    e.exports = function (e) {
      return e ? (e = r(e)) === 1 / 0 || e === -1 / 0 ? 17976931348623157e292 * (e < 0 ? -1 : 1) : e == e ? e : 0 : 0 === e ? e : 0;
    };
  }, function (e, t, n) {
    var r = n(5),
        o = n(209),
        a = n(98),
        i = Math.max,
        u = Math.min;

    e.exports = function (e, t, n) {
      var c,
          s,
          l,
          f,
          p,
          d,
          b = 0,
          h = !1,
          y = !1,
          v = !0;
      if ("function" != typeof e) throw new TypeError("Expected a function");

      function m(t) {
        var n = c,
            r = s;
        return c = s = void 0, b = t, f = e.apply(r, n);
      }

      function g(e) {
        return b = e, p = setTimeout(w, t), h ? m(e) : f;
      }

      function S(e) {
        var n = e - d;
        return void 0 === d || n >= t || n < 0 || y && e - b >= l;
      }

      function w() {
        var e = o();
        if (S(e)) return O(e);
        p = setTimeout(w, function (e) {
          var n = t - (e - d);
          return y ? u(n, l - (e - b)) : n;
        }(e));
      }

      function O(e) {
        return p = void 0, v && c ? m(e) : (c = s = void 0, f);
      }

      function _() {
        var e = o(),
            n = S(e);

        if (c = arguments, s = this, d = e, n) {
          if (void 0 === p) return g(d);
          if (y) return clearTimeout(p), p = setTimeout(w, t), m(d);
        }

        return void 0 === p && (p = setTimeout(w, t)), f;
      }

      return t = a(t) || 0, r(n) && (h = !!n.leading, l = (y = "maxWait" in n) ? i(a(n.maxWait) || 0, t) : l, v = "trailing" in n ? !!n.trailing : v), _.cancel = function () {
        void 0 !== p && clearTimeout(p), b = 0, c = d = s = p = void 0;
      }, _.flush = function () {
        return void 0 === p ? f : O(o());
      }, _;
    };
  }, function (e, t, n) {
    var r = n(3);

    e.exports = function () {
      return r.Date.now();
    };
  }, function (e, t, n) {
    var r = n(37),
        o = n(211),
        a = n(233),
        i = n(239),
        u = n(26),
        c = n(240),
        s = n(11);

    e.exports = function (e, t, n) {
      var l = -1;
      t = r(t.length ? t : [s], u(o));
      var f = a(e, function (e, n, o) {
        return {
          criteria: r(t, function (t) {
            return t(e);
          }),
          index: ++l,
          value: e
        };
      });
      return i(f, function (e, t) {
        return c(e, t, n);
      });
    };
  }, function (e, t, n) {
    var r = n(212),
        o = n(225),
        a = n(11),
        i = n(4),
        u = n(230);

    e.exports = function (e) {
      return "function" == typeof e ? e : null == e ? a : "object" == typeof e ? i(e) ? o(e[0], e[1]) : r(e) : u(e);
    };
  }, function (e, t, n) {
    var r = n(213),
        o = n(224),
        a = n(102);

    e.exports = function (e) {
      var t = o(e);
      return 1 == t.length && t[0][2] ? a(t[0][0], t[0][1]) : function (n) {
        return n === e || r(n, e, t);
      };
    };
  }, function (e, t, n) {
    var r = n(38),
        o = n(99);

    e.exports = function (e, t, n, a) {
      var i = n.length,
          u = i,
          c = !a;
      if (null == e) return !u;

      for (e = Object(e); i--;) {
        var s = n[i];
        if (c && s[2] ? s[1] !== e[s[0]] : !(s[0] in e)) return !1;
      }

      for (; ++i < u;) {
        var l = (s = n[i])[0],
            f = e[l],
            p = s[1];

        if (c && s[2]) {
          if (void 0 === f && !(l in e)) return !1;
        } else {
          var d = new r();
          if (a) var b = a(f, p, l, e, t, d);
          if (!(void 0 === b ? o(p, f, 3, a, d) : b)) return !1;
        }
      }

      return !0;
    };
  }, function (e, t, n) {
    var r = n(38),
        o = n(100),
        a = n(220),
        i = n(223),
        u = n(29),
        c = n(4),
        s = n(43),
        l = n(72),
        f = "[object Object]",
        p = Object.prototype.hasOwnProperty;

    e.exports = function (e, t, n, d, b, h) {
      var y = c(e),
          v = c(t),
          m = y ? "[object Array]" : u(e),
          g = v ? "[object Array]" : u(t),
          S = (m = "[object Arguments]" == m ? f : m) == f,
          w = (g = "[object Arguments]" == g ? f : g) == f,
          O = m == g;

      if (O && s(e)) {
        if (!s(t)) return !1;
        y = !0, S = !1;
      }

      if (O && !S) return h || (h = new r()), y || l(e) ? o(e, t, n, d, b, h) : a(e, t, m, n, d, b, h);

      if (!(1 & n)) {
        var _ = S && p.call(e, "__wrapped__"),
            j = w && p.call(t, "__wrapped__");

        if (_ || j) {
          var A = _ ? e.value() : e,
              R = j ? t.value() : t;
          return h || (h = new r()), b(A, R, n, d, h);
        }
      }

      return !!O && (h || (h = new r()), i(e, t, n, d, b, h));
    };
  }, function (e, t, n) {
    var r = n(41),
        o = n(216),
        a = n(217);

    function i(e) {
      var t = -1,
          n = null == e ? 0 : e.length;

      for (this.__data__ = new r(); ++t < n;) {
        this.add(e[t]);
      }
    }

    i.prototype.add = i.prototype.push = o, i.prototype.has = a, e.exports = i;
  }, function (e, t) {
    e.exports = function (e) {
      return this.__data__.set(e, "__lodash_hash_undefined__"), this;
    };
  }, function (e, t) {
    e.exports = function (e) {
      return this.__data__.has(e);
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      for (var n = -1, r = null == e ? 0 : e.length; ++n < r;) {
        if (t(e[n], n, e)) return !0;
      }

      return !1;
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      return e.has(t);
    };
  }, function (e, t, n) {
    var r = n(10),
        o = n(81),
        a = n(22),
        i = n(100),
        u = n(221),
        c = n(222),
        s = r ? r.prototype : void 0,
        l = s ? s.valueOf : void 0;

    e.exports = function (e, t, n, r, s, f, p) {
      switch (n) {
        case "[object DataView]":
          if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
          e = e.buffer, t = t.buffer;

        case "[object ArrayBuffer]":
          return !(e.byteLength != t.byteLength || !f(new o(e), new o(t)));

        case "[object Boolean]":
        case "[object Date]":
        case "[object Number]":
          return a(+e, +t);

        case "[object Error]":
          return e.name == t.name && e.message == t.message;

        case "[object RegExp]":
        case "[object String]":
          return e == t + "";

        case "[object Map]":
          var d = u;

        case "[object Set]":
          var b = 1 & r;
          if (d || (d = c), e.size != t.size && !b) return !1;
          var h = p.get(e);
          if (h) return h == t;
          r |= 2, p.set(e, t);
          var y = i(d(e), d(t), r, s, f, p);
          return p.delete(e), y;

        case "[object Symbol]":
          if (l) return l.call(e) == l.call(t);
      }

      return !1;
    };
  }, function (e, t) {
    e.exports = function (e) {
      var t = -1,
          n = Array(e.size);
      return e.forEach(function (e, r) {
        n[++t] = [r, e];
      }), n;
    };
  }, function (e, t) {
    e.exports = function (e) {
      var t = -1,
          n = Array(e.size);
      return e.forEach(function (e) {
        n[++t] = e;
      }), n;
    };
  }, function (e, t, n) {
    var r = n(77),
        o = Object.prototype.hasOwnProperty;

    e.exports = function (e, t, n, a, i, u) {
      var c = 1 & n,
          s = r(e),
          l = s.length;
      if (l != r(t).length && !c) return !1;

      for (var f = l; f--;) {
        var p = s[f];
        if (!(c ? p in t : o.call(t, p))) return !1;
      }

      var d = u.get(e);
      if (d && u.get(t)) return d == t;
      var b = !0;
      u.set(e, t), u.set(t, e);

      for (var h = c; ++f < l;) {
        var y = e[p = s[f]],
            v = t[p];
        if (a) var m = c ? a(v, y, p, t, e, u) : a(y, v, p, e, t, u);

        if (!(void 0 === m ? y === v || i(y, v, n, a, u) : m)) {
          b = !1;
          break;
        }

        h || (h = "constructor" == p);
      }

      if (b && !h) {
        var g = e.constructor,
            S = t.constructor;
        g == S || !("constructor" in e) || !("constructor" in t) || "function" == typeof g && g instanceof g && "function" == typeof S && S instanceof S || (b = !1);
      }

      return u.delete(e), u.delete(t), b;
    };
  }, function (e, t, n) {
    var r = n(101),
        o = n(13);

    e.exports = function (e) {
      for (var t = o(e), n = t.length; n--;) {
        var a = t[n],
            i = e[a];
        t[n] = [a, i, r(i)];
      }

      return t;
    };
  }, function (e, t, n) {
    var r = n(99),
        o = n(226),
        a = n(227),
        i = n(51),
        u = n(101),
        c = n(102),
        s = n(16);

    e.exports = function (e, t) {
      return i(e) && u(t) ? c(s(e), t) : function (n) {
        var i = o(n, e);
        return void 0 === i && i === t ? a(n, e) : r(t, i, 3);
      };
    };
  }, function (e, t, n) {
    var r = n(52);

    e.exports = function (e, t, n) {
      var o = null == e ? void 0 : r(e, t);
      return void 0 === o ? n : o;
    };
  }, function (e, t, n) {
    var r = n(228),
        o = n(229);

    e.exports = function (e, t) {
      return null != e && o(e, t, r);
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      return null != e && t in Object(e);
    };
  }, function (e, t, n) {
    var r = n(31),
        o = n(42),
        a = n(4),
        i = n(25),
        u = n(45),
        c = n(16);

    e.exports = function (e, t, n) {
      for (var s = -1, l = (t = r(t, e)).length, f = !1; ++s < l;) {
        var p = c(t[s]);
        if (!(f = null != e && n(e, p))) break;
        e = e[p];
      }

      return f || ++s != l ? f : !!(l = null == e ? 0 : e.length) && u(l) && i(p, l) && (a(e) || o(e));
    };
  }, function (e, t, n) {
    var r = n(231),
        o = n(232),
        a = n(51),
        i = n(16);

    e.exports = function (e) {
      return a(e) ? r(i(e)) : o(e);
    };
  }, function (e, t) {
    e.exports = function (e) {
      return function (t) {
        return null == t ? void 0 : t[e];
      };
    };
  }, function (e, t, n) {
    var r = n(52);

    e.exports = function (e) {
      return function (t) {
        return r(t, e);
      };
    };
  }, function (e, t, n) {
    var r = n(234),
        o = n(14);

    e.exports = function (e, t) {
      var n = -1,
          a = o(e) ? Array(e.length) : [];
      return r(e, function (e, r, o) {
        a[++n] = t(e, r, o);
      }), a;
    };
  }, function (e, t, n) {
    var r = n(235),
        o = n(238)(r);
    e.exports = o;
  }, function (e, t, n) {
    var r = n(236),
        o = n(13);

    e.exports = function (e, t) {
      return e && r(e, t, o);
    };
  }, function (e, t, n) {
    var r = n(237)();
    e.exports = r;
  }, function (e, t) {
    e.exports = function (e) {
      return function (t, n, r) {
        for (var o = -1, a = Object(t), i = r(t), u = i.length; u--;) {
          var c = i[e ? u : ++o];
          if (!1 === n(a[c], c, a)) break;
        }

        return t;
      };
    };
  }, function (e, t, n) {
    var r = n(14);

    e.exports = function (e, t) {
      return function (n, o) {
        if (null == n) return n;
        if (!r(n)) return e(n, o);

        for (var a = n.length, i = t ? a : -1, u = Object(n); (t ? i-- : ++i < a) && !1 !== o(u[i], i, u);) {
          ;
        }

        return n;
      };
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      var n = e.length;

      for (e.sort(t); n--;) {
        e[n] = e[n].value;
      }

      return e;
    };
  }, function (e, t, n) {
    var r = n(241);

    e.exports = function (e, t, n) {
      for (var o = -1, a = e.criteria, i = t.criteria, u = a.length, c = n.length; ++o < u;) {
        var s = r(a[o], i[o]);
        if (s) return o >= c ? s : s * ("desc" == n[o] ? -1 : 1);
      }

      return e.index - t.index;
    };
  }, function (e, t, n) {
    var r = n(15);

    e.exports = function (e, t) {
      if (e !== t) {
        var n = void 0 !== e,
            o = null === e,
            a = e == e,
            i = r(e),
            u = void 0 !== t,
            c = null === t,
            s = t == t,
            l = r(t);
        if (!c && !l && !i && e > t || i && u && s && !c && !l || o && u && s || !n && s || !a) return 1;
        if (!o && !i && !l && e < t || l && n && a && !o && !i || c && n && a || !u && a || !s) return -1;
      }

      return 0;
    };
  }, function (e, t, n) {
    var r = n(22),
        o = n(14),
        a = n(25),
        i = n(5);

    e.exports = function (e, t, n) {
      if (!i(n)) return !1;
      var u = typeof t;
      return !!("number" == u ? o(n) && a(t, n.length) : "string" == u && t in n) && r(n[t], e);
    };
  }, function (e, t, n) {
    var r = n(11);

    e.exports = function (e) {
      return "function" == typeof e ? e : r;
    };
  }, function (e, t, n) {
    "use strict";

    n.r(t), n.d(t, "slidesToShowPlugin", function () {
      return vn;
    }), n.d(t, "infinitePlugin", function () {
      return mn;
    }), n.d(t, "clickToChangePlugin", function () {
      return gn;
    }), n.d(t, "autoplayPlugin", function () {
      return Sn;
    }), n.d(t, "rtlPlugin", function () {
      return wn;
    }), n.d(t, "centeredPlugin", function () {
      return On;
    }), n.d(t, "slidesToScrollPlugin", function () {
      return _n;
    }), n.d(t, "arrowsPlugin", function () {
      return jn;
    }), n.d(t, "fastSwipePlugin", function () {
      return An;
    }), n.d(t, "Dots", function () {
      return Rn;
    });

    var r = n(0),
        o = n.n(r),
        a = n(1),
        i = n(17),
        u = n.n(i),
        c = n(103),
        s = n.n(c),
        l = n(2),
        f = Object(a.atom)({
      key: "@brainhubeu/react-carousel/slideMovementState",
      default: {
        clicked: null,
        dragStart: null,
        dragEnd: null,
        dragOffset: 0
      }
    }),
        p = Object(a.atom)({
      key: "@brainhubeu/react-carousel/transitionEnabledState",
      default: !1
    }),
        d = Object(a.atom)({
      key: "@brainhubeu/react-carousel/trackWidthState",
      default: 0
    }),
        b = Object(a.atom)({
      key: "@brainhubeu/react-carousel/trackStylesState",
      default: {
        marginLeft: 0,
        transform: 0
      }
    }),
        h = Object(a.atom)({
      key: "@brainhubeu/react-carousel/carouselStrategiesState",
      default: []
    }),
        y = Object(a.atom)({
      key: "@brainhubeu/react-carousel/carouselValueState",
      default: 0
    }),
        v = n(18),
        m = n.n(v),
        g = n(19),
        S = n.n(g),
        w = function w(e, t) {
      var n = (t || []).length - 1;
      return e > n ? n : e < 0 ? 0 : e;
    },
        O = "CHANGE_SLIDE",
        _ = "GET_CURRENT_VALUE",
        j = "GET_TRANSFORM_OFFSET",
        A = "GET_NEAREST_SLIDE",
        R = Object(a.atom)({
      key: "@brainhubeu/react-carousel/activeSlideIndexState",
      default: 0
    }),
        E = Object(a.atom)({
      key: "@brainhubeu/react-carousel/itemWidthState",
      default: 0
    }),
        T = Object(a.atom)({
      key: "@brainhubeu/react-carousel/itemOffsetState",
      default: 0
    }),
        x = Object(a.atom)({
      key: "@brainhubeu/react-carousel/slidesState",
      default: []
    });

    function M(e) {
      return function (e) {
        if (Array.isArray(e)) return k(e);
      }(e) || function (e) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
      }(e) || function (e, t) {
        if (e) {
          if ("string" == typeof e) return k(e, t);
          var n = Object.prototype.toString.call(e).slice(8, -1);
          return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? k(e, t) : void 0;
        }
      }(e) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function k(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var n = 0, r = new Array(t); n < t; n++) {
        r[n] = e[n];
      }

      return r;
    }

    var N = Object(a.selector)({
      key: "@brainhubeu/react-carousel/getCurrentSlideSelector",
      get: function get(e) {
        var t = e.get,
            n = t(y),
            r = t(x),
            o = function o() {
          return w(n, r);
        },
            a = t(h).map(function (e) {
          return e && e[_];
        }).filter(function (e) {
          return "function" == typeof e;
        });

        return a.map(function (e) {
          return S()(e, null, n);
        }).length ? m()([o].concat(M(a)))() : o();
      },
      set: function set(e, t) {
        var n = e.set,
            r = e.get,
            o = r(x),
            a = function a() {
          return w(t, o);
        },
            i = r(h).map(function (e) {
          return e && e[O];
        }).filter(function (e) {
          return "function" == typeof e;
        }),
            u = i.map(function (e) {
          return S()(e, null, t);
        }),
            c = i.length ? m()([a].concat(M(u)))() : a();

        n(y, c);
      }
    }),
        V = Object(a.selector)({
      key: "@brainhubeu/react-carousel/transformOffsetSelector",
      get: function get(e) {
        var t = e.get,
            n = t(E),
            r = t(T),
            o = t(f).dragOffset,
            a = t(y),
            i = function i() {
          return o - a * (n + r);
        },
            u = t(h).map(function (e) {
          return e && e[j];
        }).filter(function (e) {
          return "function" == typeof e;
        }),
            c = u.map(function (e) {
          return S()(e, null, a);
        });

        return u.length ? m()([i].concat(M(c)))() : i();
      }
    }),
        P = Object(a.selector)({
      key: "@brainhubeu/react-carousel/nearestSlideSelector",
      get: function get(e) {
        var t = e.get,
            n = t(E),
            r = t(f).dragOffset,
            o = t(y),
            a = t(x),
            i = function i() {
          var e = -Math.round(r / n);
          return w(o + e, a);
        },
            u = t(h).map(function (e) {
          return e && e[A];
        }).filter(function (e) {
          return "function" == typeof e;
        }),
            c = u.map(function (e) {
          return S()(e, null, o);
        });

        return u.length ? m()([i].concat(M(c)))() : i();
      }
    }),
        C = n(34),
        L = n(36),
        I = function I(e) {
      var t = typeof e;
      return null != e && ("object" == t || "function" == t);
    },
        D = n(108),
        U = "object" == typeof self && self && self.Object === Object && self,
        B = D.a || U || Function("return this")(),
        F = function F() {
      return B.Date.now();
    },
        $ = B.Symbol,
        z = Object.prototype,
        W = z.hasOwnProperty,
        q = z.toString,
        H = $ ? $.toStringTag : void 0,
        G = Object.prototype.toString,
        Y = $ ? $.toStringTag : void 0,
        X = function X(e) {
      return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : Y && Y in Object(e) ? function (e) {
        var t = W.call(e, H),
            n = e[H];

        try {
          e[H] = void 0;
          var r = !0;
        } catch (e) {}

        var o = q.call(e);
        return r && (t ? e[H] = n : delete e[H]), o;
      }(e) : function (e) {
        return G.call(e);
      }(e);
    },
        J = /^\s+|\s+$/g,
        K = /^[-+]0x[0-9a-f]+$/i,
        Q = /^0b[01]+$/i,
        Z = /^0o[0-7]+$/i,
        ee = parseInt,
        te = function te(e) {
      if ("number" == typeof e) return e;
      if (function (e) {
        return "symbol" == typeof e || function (e) {
          return null != e && "object" == typeof e;
        }(e) && "[object Symbol]" == X(e);
      }(e)) return NaN;

      if (I(e)) {
        var t = "function" == typeof e.valueOf ? e.valueOf() : e;
        e = I(t) ? t + "" : t;
      }

      if ("string" != typeof e) return 0 === e ? e : +e;
      e = e.replace(J, "");
      var n = Q.test(e);
      return n || Z.test(e) ? ee(e.slice(2), n ? 2 : 8) : K.test(e) ? NaN : +e;
    },
        ne = Math.max,
        re = Math.min,
        oe = function oe(e, t, n) {
      var r,
          o,
          a,
          i,
          u,
          c,
          s = 0,
          l = !1,
          f = !1,
          p = !0;
      if ("function" != typeof e) throw new TypeError("Expected a function");

      function d(t) {
        var n = r,
            a = o;
        return r = o = void 0, s = t, i = e.apply(a, n);
      }

      function b(e) {
        return s = e, u = setTimeout(y, t), l ? d(e) : i;
      }

      function h(e) {
        var n = e - c;
        return void 0 === c || n >= t || n < 0 || f && e - s >= a;
      }

      function y() {
        var e = F();
        if (h(e)) return v(e);
        u = setTimeout(y, function (e) {
          var n = t - (e - c);
          return f ? re(n, a - (e - s)) : n;
        }(e));
      }

      function v(e) {
        return u = void 0, p && r ? d(e) : (r = o = void 0, i);
      }

      function m() {
        var e = F(),
            n = h(e);

        if (r = arguments, o = this, c = e, n) {
          if (void 0 === u) return b(c);
          if (f) return clearTimeout(u), u = setTimeout(y, t), d(c);
        }

        return void 0 === u && (u = setTimeout(y, t)), i;
      }

      return t = te(t) || 0, I(n) && (l = !!n.leading, a = (f = "maxWait" in n) ? ne(te(n.maxWait) || 0, t) : a, p = "trailing" in n ? !!n.trailing : p), m.cancel = function () {
        void 0 !== u && clearTimeout(u), s = 0, r = c = o = u = void 0;
      }, m.flush = function () {
        return void 0 === u ? i : v(F());
      }, m;
    },
        ae = {
      debounce: oe,
      throttle: function throttle(e, t, n) {
        var r = !0,
            o = !0;
        if ("function" != typeof e) throw new TypeError("Expected a function");
        return I(n) && (r = "leading" in n ? !!n.leading : r, o = "trailing" in n ? !!n.trailing : o), oe(e, t, {
          leading: r,
          maxWait: t,
          trailing: o
        });
      }
    },
        ie = function ie(e) {
      return "function" == typeof e;
    },
        ue = function ue() {
      return "undefined" == typeof window;
    },
        ce = function ce(e) {
      return e instanceof Element || e instanceof HTMLDocument;
    };

    function se(e) {
      return (se = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function le(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function fe(e, t) {
      return (fe = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function pe(e, t) {
      return !t || "object" !== se(t) && "function" != typeof t ? de(e) : t;
    }

    function de(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function be(e) {
      return (be = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function he(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    var ye = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && fe(e, t);
      }(i, e);

      var t,
          n,
          a = function (e) {
        var t = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }();

        return function () {
          var n,
              r = be(e);

          if (t) {
            var o = be(this).constructor;
            n = Reflect.construct(r, arguments, o);
          } else n = r.apply(this, arguments);

          return pe(this, n);
        };
      }(i);

      function i(e) {
        var t;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, i), he(de(t = a.call(this, e)), "cancelHandler", function () {
          t.resizeHandler && t.resizeHandler.cancel && (t.resizeHandler.cancel(), t.resizeHandler = null);
        }), he(de(t), "rafClean", function () {
          t.raf && t.raf.cancel && (t.raf.cancel(), t.raf = null);
        }), he(de(t), "toggleObserver", function (e) {
          var n = t.getElement();
          n && t.resizeObserver[e] && t.resizeObserver[e](n);
        }), he(de(t), "getElement", function () {
          var e = t.props,
              n = e.querySelector,
              r = e.targetDomEl;

          if (!ue()) {
            if (n) return document.querySelector(n);
            if (r && ce(r)) return r;
            if (t.targetRef && ce(t.targetRef.current)) return t.targetRef.current;
            var o = Object(C.findDOMNode)(de(t));
            if (o) switch (t.getRenderType()) {
              case "renderProp":
              case "childFunction":
              case "child":
              case "childArray":
                return o;

              default:
                return o.parentElement;
            }
          }
        }), he(de(t), "createUpdater", function () {
          return t.rafClean(), t.raf = function (e) {
            var t = [],
                n = null,
                r = function r() {
              for (var r = arguments.length, o = new Array(r), a = 0; a < r; a++) {
                o[a] = arguments[a];
              }

              t = o, n || (n = requestAnimationFrame(function () {
                n = null, e.apply(void 0, t);
              }));
            };

            return r.cancel = function () {
              n && (cancelAnimationFrame(n), n = null);
            }, r;
          }(function (e) {
            var n = e.width,
                r = e.height,
                o = t.props.onResize;
            ie(o) && o(n, r), t.setState({
              width: n,
              height: r
            });
          }), t.raf;
        }), he(de(t), "createResizeHandler", function (e) {
          var n = t.state,
              r = n.width,
              o = n.height,
              a = t.props,
              i = a.handleWidth,
              u = a.handleHeight;

          if (i || u) {
            var c = t.createUpdater();
            e.forEach(function (e) {
              var n = e && e.contentRect || {},
                  a = n.width,
                  s = n.height,
                  l = i && r !== a || u && o !== s;
              !t.skipOnMount && l && !ue() && c({
                width: a,
                height: s
              }), t.skipOnMount = !1;
            });
          }
        }), he(de(t), "getRenderType", function () {
          var e = t.props,
              n = e.render,
              o = e.children;
          return ie(n) ? "renderProp" : ie(o) ? "childFunction" : Object(r.isValidElement)(o) ? "child" : Array.isArray(o) ? "childArray" : "parent";
        });
        var n = e.skipOnMount,
            o = e.refreshMode,
            u = e.refreshRate,
            c = e.refreshOptions;
        t.state = {
          width: void 0,
          height: void 0
        }, t.skipOnMount = n, t.raf = null, t.unmounted = !1, t.targetRef = Object(r.createRef)();
        var s = ae[o];
        return t.resizeHandler = s ? s(t.createResizeHandler, u, c) : t.createResizeHandler, t.resizeObserver = new L.a(t.resizeHandler), t;
      }

      return t = i, (n = [{
        key: "componentDidMount",
        value: function value() {
          var e = this.props.targetRef;
          e && e.current && (this.targetRef.current = e.current), this.toggleObserver("observe");
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.toggleObserver("unobserve"), this.rafClean(), this.cancelHandler(), this.unmounted = !0;
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.render,
              n = e.children,
              a = e.nodeType,
              i = this.state,
              u = {
            width: i.width,
            height: i.height,
            targetRef: this.targetRef
          };

          switch (this.getRenderType()) {
            case "renderProp":
              return t(u);

            case "childFunction":
              return n(u);

            case "child":
              if ("string" == typeof n.type) {
                var c = function (e, t) {
                  if (null == e) return {};

                  var n,
                      r,
                      o = function (e, t) {
                    if (null == e) return {};
                    var n,
                        r,
                        o = {},
                        a = Object.keys(e);

                    for (r = 0; r < a.length; r++) {
                      n = a[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
                    }

                    return o;
                  }(e, t);

                  if (Object.getOwnPropertySymbols) {
                    var a = Object.getOwnPropertySymbols(e);

                    for (r = 0; r < a.length; r++) {
                      n = a[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
                    }
                  }

                  return o;
                }(u, ["targetRef"]);

                return Object(r.cloneElement)(n, c);
              }

              return Object(r.cloneElement)(n, u);

            case "childArray":
              return n.map(function (e) {
                return !!e && Object(r.cloneElement)(e, u);
              });

            default:
              return o.a.createElement(a, null);
          }
        }
      }]) && le(t.prototype, n), i;
    }(r.PureComponent);

    ye.propTypes = {
      handleWidth: l.bool,
      handleHeight: l.bool,
      skipOnMount: l.bool,
      refreshRate: l.number,
      refreshMode: l.string,
      refreshOptions: Object(l.shape)({
        leading: l.bool,
        trailing: l.bool
      }),
      querySelector: l.string,
      targetDomEl: l.any,
      targetRef: Object(l.oneOfType)([l.func, Object(l.shape)({
        current: l.any
      })]),
      onResize: l.func,
      render: l.func,
      children: l.any,
      nodeType: l.node
    }, ye.defaultProps = {
      handleWidth: !0,
      handleHeight: !0,
      skipOnMount: !1,
      refreshRate: 1e3,
      refreshMode: void 0,
      refreshOptions: void 0,
      querySelector: null,
      targetDomEl: null,
      targetRef: null,
      onResize: null,
      render: void 0,
      children: null,
      nodeType: "div"
    };
    var ve = ye;

    function me(e) {
      return (me = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function ge() {
      return (ge = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var r in n) {
            Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function Se(e, t) {
      if (null == e) return {};

      var n,
          r,
          o = function (e, t) {
        if (null == e) return {};
        var n,
            r,
            o = {},
            a = Object.keys(e);

        for (r = 0; r < a.length; r++) {
          n = a[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
        }

        return o;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);

        for (r = 0; r < a.length; r++) {
          n = a[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
        }
      }

      return o;
    }

    function we(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Oe(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function _e(e, t, n) {
      return t && Oe(e.prototype, t), n && Oe(e, n), e;
    }

    function je(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && function (e, t) {
        (Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        })(e, t);
      }(e, t);
    }

    function Ae(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = Te(e);

        if (t) {
          var o = Te(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return Re(this, n);
      };
    }

    function Re(e, t) {
      return !t || "object" !== me(t) && "function" != typeof t ? Ee(e) : t;
    }

    function Ee(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function Te(e) {
      return (Te = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function xe(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    var Me = n(6),
        ke = n.n(Me),
        Ne = n(104),
        Ve = n.n(Ne),
        Pe = function Pe(e, t) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : window,
          a = Object(r.useRef)();
      Object(r.useEffect)(function () {
        a.current = t;
      }, [t]), Object(r.useEffect)(function () {
        if (o && o.addEventListener) {
          var t = function t(e) {
            return a.current(e);
          };

          return o.addEventListener(e, t, n), function () {
            o.removeEventListener(e, t);
          };
        }
      }, [e, o]);
    },
        Ce = n(105),
        Le = n.n(Ce),
        Ie = function Ie(e) {
      var t = e.changedTouches[0],
          n = t.screenX,
          r = t.screenY,
          o = t.clientX,
          a = t.clientY,
          i = new MouseEvent({
        touchstart: "mousedown",
        touchmove: "mousemove",
        touchend: "mouseup"
      }[e.type], {
        bubbles: !0,
        cancelable: !0,
        view: window,
        detail: 1,
        screenX: n,
        screenY: r,
        clientX: o,
        clientY: a
      });
      t.target.dispatchEvent(i);
    },
        De = function De(e, t) {
      return e ? Array.isArray(e) ? e : [e] : t || [];
    },
        Ue = n(35),
        Be = n.n(Ue),
        Fe = n(106),
        $e = n.n(Fe),
        ze = {
      numberOfSlides: 3
    },
        We = function We(e) {
      var t = e.carouselProps,
          n = e.refs,
          o = e.options,
          i = void 0 === o ? ze : o;
      return {
        name: Ft.SLIDES_TO_SHOW,
        plugin: function plugin() {
          var e = Object(r.useRef)(!0),
              o = Object(a.useSetRecoilState)(E),
              u = function u() {
            o(n.trackContainerRef.current.offsetWidth / i.numberOfSlides);
          };

          Object(r.useEffect)(function () {
            e.current ? e.current = !1 : u();
          }, [t.width, n.trackContainerRef.current]), Pe("resize", u), Pe("load", u);
        }
      };
    },
        qe = n(62),
        He = n.n(qe),
        Ge = n(107),
        Ye = n.n(Ge);

    function Xe(e) {
      return function (e) {
        if (Array.isArray(e)) return et(e);
      }(e) || function (e) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
      }(e) || Ze(e) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function Je(e, t) {
      var n = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function Ke(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Je(Object(n), !0).forEach(function (t) {
          Qe(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Je(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }

    function Qe(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    function Ze(e, t) {
      if (e) {
        if ("string" == typeof e) return et(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? et(e, t) : void 0;
      }
    }

    function et(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var n = 0, r = new Array(t); n < t; n++) {
        r[n] = e[n];
      }

      return r;
    }

    var tt = {
      numberOfInfiniteClones: 2
    },
        nt = function nt(e) {
      var t = e.options,
          n = void 0 === t ? tt : t,
          o = e.carouselProps,
          i = Object(a.useRecoilValue)(E),
          c = De(o.children, o.slides),
          s = function s() {
        return function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
              t = u()(e) ? o.value : e,
              n = c.length;
          return t >= 0 ? t % n : (n - Math.abs(t % n)) % n;
        }(0) + o.value;
      },
          l = function l() {
        return Math.abs(o.value) > c.length ? Math.ceil(o.value / c.length) : 0;
      },
          p = function p() {
        var e = l();
        return e < 0 ? -e : 0;
      },
          h = function h() {
        return -c.length * i * p();
      };

      return {
        name: Ft.INFINITE,
        plugin: function plugin() {
          var e = Object(a.useSetRecoilState)(d),
              t = Object(a.useSetRecoilState)(R),
              i = function (e, t) {
            return function (e) {
              if (Array.isArray(e)) return e;
            }(e) || function (e, t) {
              if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
                var n = [],
                    r = !0,
                    o = !1,
                    a = void 0;

                try {
                  for (var i, u = e[Symbol.iterator](); !(r = (i = u.next()).done) && (n.push(i.value), !t || n.length !== t); r = !0) {
                    ;
                  }
                } catch (e) {
                  o = !0, a = e;
                } finally {
                  try {
                    r || null == u.return || u.return();
                  } finally {
                    if (o) throw a;
                  }
                }

                return n;
              }
            }(e, t) || Ze(e, t) || function () {
              throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
          }(Object(a.useRecoilState)(b), 2),
              u = i[0],
              f = i[1],
              y = Object(a.useSetRecoilState)(x),
              v = n.numberOfInfiniteClones,
              m = function m() {
            return v + p();
          },
              g = function g() {
            return v + ((e = l()) > 0 ? e : 0);
            var e;
          };

          Object(r.useEffect)(function () {
            t(s() + m() * c.length), f(Ke(Ke({}, u), {}, {
              marginLeft: h()
            }));
          }, [o.value]), Object(r.useEffect)(function () {
            var t = 1 + m() + g(),
                n = He()(m(), function () {
              return c;
            }),
                r = He()(g(), function () {
              return c;
            });
            e(o.width * c.length * t), y(Ye.a.apply(void 0, Xe(n).concat([c], Xe(r))));
          }, [o.width, c.length, o.value]);
        },
        strategies: function strategies() {
          var e,
              t = Object(a.useRecoilValue)(f),
              n = Object(a.useRecoilValue)(R),
              r = Object(a.useRecoilValue)(E),
              u = (t.marginLeft || "0").match(/\d/g).join("");
          return Qe(e = {}, O, function (e) {
            return e;
          }), Qe(e, A, function (e) {
            return e + -Math.round(t.dragOffset / r);
          }), Qe(e, _, function () {
            return o.value;
          }), Qe(e, j, function () {
            var e = i;
            return t.dragOffset - n * e - u - h();
          }), e;
        }
      };
    };

    function rt(e, t) {
      var n = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function ot(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? rt(Object(n), !0).forEach(function (t) {
          it(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : rt(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }

    function at(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var n = 0, r = new Array(t); n < t; n++) {
        r[n] = e[n];
      }

      return r;
    }

    function it(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    var ut = 0,
        ct = function ct(e) {
      var t = e.carouselProps;
      return {
        name: Ft.CLICK_TO_CHANGE,
        strategies: function strategies() {
          var e = Object(a.useRecoilValue)(f),
              n = Object(a.useRecoilValue)(R);
          return it({}, O, function (r, o) {
            var a,
                i,
                u = (a = Math.abs(e.dragStart)) < (i = Math.abs(e.dragEnd) || 0) ? "LEFT" : a > i ? "RIGHT" : "NONE";
            return "NONE" === u ? o : ut !== e.clicked ? "LEFT" === u && o <= e.clicked ? (ut = o, o) : (ut = e.clicked, n ? t.value + e.clicked - n : e.clicked) : (ut = o || r, o || r);
          });
        },
        slideCustomProps: function slideCustomProps() {
          var e = Object(a.useSetRecoilState)(p),
              t = function (e, t) {
            return function (e) {
              if (Array.isArray(e)) return e;
            }(e) || function (e, t) {
              if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
                var n = [],
                    r = !0,
                    o = !1,
                    a = void 0;

                try {
                  for (var i, u = e[Symbol.iterator](); !(r = (i = u.next()).done) && (n.push(i.value), !t || n.length !== t); r = !0) {
                    ;
                  }
                } catch (e) {
                  o = !0, a = e;
                } finally {
                  try {
                    r || null == u.return || u.return();
                  } finally {
                    if (o) throw a;
                  }
                }

                return n;
              }
            }(e, t) || function (e, t) {
              if (e) {
                if ("string" == typeof e) return at(e, t);
                var n = Object.prototype.toString.call(e).slice(8, -1);
                return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? at(e, t) : void 0;
              }
            }(e, t) || function () {
              throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
          }(Object(a.useRecoilState)(f), 2),
              n = t[0],
              o = t[1];

          return {
            onMouseDown: Object(r.useCallback)(function (t, r) {
              t.preventDefault(), t.stopPropagation(), e(!0);
              var a = t.pageX;
              o(ot(ot({}, n), {}, {
                clicked: r,
                dragStart: a
              }));
            }, [n, e])
          };
        },
        itemClassNames: function itemClassNames() {
          return ["BrainhubCarouselItem--clickable"];
        }
      };
    };

    function st(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var n = 0, r = new Array(t); n < t; n++) {
        r[n] = e[n];
      }

      return r;
    }

    function lt(e, t) {
      var n = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function ft(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? lt(Object(n), !0).forEach(function (t) {
          pt(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : lt(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }

    function pt(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    var dt = null,
        bt = {
      interval: 2e3,
      stopAutoPlayOnHover: !0,
      direction: "RIGHT"
    },
        ht = function ht(e) {
      var t = e.carouselProps,
          n = e.options,
          o = void 0 === n ? {} : n,
          i = ft(ft({}, bt), o);
      return {
        name: Ft.AUTOPLAY,
        trackCustomProps: function trackCustomProps() {
          var e = Object(a.useSetRecoilState)(N),
              n = function (e, t) {
            return function (e) {
              if (Array.isArray(e)) return e;
            }(e) || function (e, t) {
              if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
                var n = [],
                    r = !0,
                    o = !1,
                    a = void 0;

                try {
                  for (var i, u = e[Symbol.iterator](); !(r = (i = u.next()).done) && (n.push(i.value), !t || n.length !== t); r = !0) {
                    ;
                  }
                } catch (e) {
                  o = !0, a = e;
                } finally {
                  try {
                    r || null == u.return || u.return();
                  } finally {
                    if (o) throw a;
                  }
                }

                return n;
              }
            }(e, t) || function (e, t) {
              if (e) {
                if ("string" == typeof e) return st(e, t);
                var n = Object.prototype.toString.call(e).slice(8, -1);
                return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? st(e, t) : void 0;
              }
            }(e, t) || function () {
              throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
          }(Object(r.useState)(!1), 2),
              o = n[0],
              u = n[1],
              c = function c() {
            dt && clearInterval(dt), dt = setInterval(function () {
              var n;
              document.hidden || o || e(t.value + ("LEFT" === (n = i.direction.toUpperCase()) ? -1 : "RIGHT" === n ? 1 : 0));
            }, i.interval);
          };

          return c(), {
            onMouseEnter: i.stopAutoPlayOnHover ? function () {
              u(!0);
            } : null,
            onMouseLeave: i.stopAutoPlayOnHover ? function () {
              u(!1), c();
            } : null
          };
        }
      };
    };

    function yt(e, t) {
      var n = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function vt(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? yt(Object(n), !0).forEach(function (t) {
          mt(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : yt(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }

    function mt(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    function gt(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
          var n = [],
              r = !0,
              o = !1,
              a = void 0;

          try {
            for (var i, u = e[Symbol.iterator](); !(r = (i = u.next()).done) && (n.push(i.value), !t || n.length !== t); r = !0) {
              ;
            }
          } catch (e) {
            o = !0, a = e;
          } finally {
            try {
              r || null == u.return || u.return();
            } finally {
              if (o) throw a;
            }
          }

          return n;
        }
      }(e, t) || function (e, t) {
        if (e) {
          if ("string" == typeof e) return St(e, t);
          var n = Object.prototype.toString.call(e).slice(8, -1);
          return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? St(e, t) : void 0;
        }
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function St(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var n = 0, r = new Array(t); n < t; n++) {
        r[n] = e[n];
      }

      return r;
    }

    n(246);

    var wt,
        Ot = function Ot(e) {
      var t = e.carouselProps;
      return {
        name: Ft.RTL,
        plugin: function plugin() {
          var e = gt(Object(a.useRecoilState)(b), 2),
              n = e[0],
              o = e[1],
              i = Object(a.useRecoilValue)(x);
          Object(r.useEffect)(function () {
            var e;
            (null == t || null === (e = t.children) || void 0 === e ? void 0 : e.length) !== i.length && o(vt(vt({}, n), {}, {
              transform: -t.transformOffset
            }));
          }, [t.transformOffset]);
        },
        strategies: function strategies() {
          var e,
              t = Object(a.useRecoilValue)(x),
              n = Object(a.useRecoilValue)(f),
              r = Object(a.useRecoilValue)(y);
          return mt(e = {}, O, function (e, o) {
            if (n.dragOffset) return w(e, t);
            var a = r + (o - r);
            return e !== o ? w(a, t) : a;
          }), mt(e, j, function (e, t) {
            return -t;
          }), e;
        },
        carouselClassNames: function carouselClassNames() {
          var e = Object(a.useRecoilValue)(x),
              n = [];
          return t.children.length === e.length && n.push("BrainhubCarousel--isRTL"), n;
        },
        carouselCustomProps: function carouselCustomProps() {
          var e = gt(Object(a.useRecoilState)(f), 2),
              t = e[0],
              n = e[1];
          return {
            onMouseMove: Object(r.useCallback)(function (e) {
              var r = e.pageX;
              null !== t.dragStart && n(function (e) {
                return vt(vt({}, t), {}, {
                  dragOffset: e.dragStart - r,
                  dragEnd: r
                });
              });
            }, [t])
          };
        }
      };
    },
        _t = function _t(e) {
      var t = e.refs;
      return {
        name: Ft.CENTERED,
        strategies: function strategies() {
          var e,
              n,
              r,
              o,
              i,
              u = Object(a.useRecoilValue)(E),
              c = Object(a.useRecoilValue)(T),
              s = null === (e = t.trackContainerRef) || void 0 === e || null === (n = e.current) || void 0 === n ? void 0 : n.offsetWidth;
          return i = function i(e, t) {
            return t + (s / 2 - (u + c) / 2);
          }, (o = j) in (r = {}) ? Object.defineProperty(r, o, {
            value: i,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : r[o] = i, r;
        }
      };
    },
        jt = {
      numberOfSlides: 3
    },
        At = function At(e) {
      var t = e.carouselProps,
          n = e.options,
          r = void 0 === n ? jt : n;
      return {
        name: Ft.SLIDES_TO_SCROLL,
        strategies: function strategies() {
          var e,
              n,
              o,
              i = Object(a.useRecoilValue)(y),
              u = Object(a.useRecoilValue)(x);
          return o = function o(e, n) {
            var o,
                a = function (e, t) {
              return e < 0 ? -e - t : e > 0 ? t - e : 0;
            }(n - i, r.numberOfSlides);

            return (null == t || null === (o = t.children) || void 0 === o ? void 0 : o.length) !== u.length ? n + a : w(n + a, u);
          }, (n = O) in (e = {}) ? Object.defineProperty(e, n, {
            value: o,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[n] = o, e;
        }
      };
    },
        Rt = (n(250), function (e, t, n, r, a) {
      var i = arguments.length > 5 && void 0 !== arguments[5] && arguments[5];
      return o.a.createElement("div", {
        key: a,
        className: ke()("BrainhubCarousel__customArrows", {
          "BrainhubCarousel__arrow--disable": i
        }, "BrainhubCarousel__custom-".concat(n)),
        onClick: r ? t : null
      }, e);
    }),
        Et = o.a.createElement("span", null, "prev"),
        Tt = o.a.createElement("span", null, "next"),
        xt = function xt(e) {
      var t = e.carouselProps,
          n = e.options,
          i = void 0 === n ? {} : n;
      return {
        name: Ft.ARROWS,
        beforeCarouselItems: function beforeCarouselItems() {
          var e,
              n = Object(a.useRecoilValue)(x),
              u = Object(r.useCallback)(function () {
            return t.onChange(t.value - 1);
          }, [t.value, t.onChange]),
              c = t.value <= 0 && (null == t || null === (e = t.children) || void 0 === e ? void 0 : e.length) === n.length;

          if (i.arrowLeft) {
            if (!c) return Rt(i.arrowLeft, u, "arrowLeft", i.addArrowClickHandler, "@brainhubeu/react-carousel/custom-arrow-left");
            var s = i.arrowLeftDisabled ? i.arrowLeftDisabled : i.arrowLeft;
            return Rt(s, u, "arrowLeft", i.addArrowClickHandler, "@brainhubeu/react-carousel/custom-arrow-left", c);
          }

          return o.a.createElement("button", {
            key: "@brainhubeu/react-carousel/arrow-left",
            className: "BrainhubCarousel__arrows BrainhubCarousel__arrowLeft",
            onClick: u,
            disabled: c
          }, Et);
        },
        afterCarouselItems: function afterCarouselItems() {
          var e,
              n = Object(a.useRecoilValue)(x),
              u = Object(r.useCallback)(function () {
            return t.onChange(t.value + 1);
          }, [t.value, t.onChange]),
              c = t.value >= n.length - 1 && (null == t || null === (e = t.children) || void 0 === e ? void 0 : e.length) === n.length;

          if (i.arrowRight) {
            if (!c) return Rt(i.arrowRight, u, "arrowLeft", i.addArrowClickHandler, "@brainhubeu/react-carousel/custom-arrow-right");
            var s = i.arrowRightDisabled ? i.arrowRightDisabled : i.arrowRight;
            return Rt(s, u, "arrowLeft", i.addArrowClickHandler, "@brainhubeu/react-carousel/custom-arrow-right", c);
          }

          return o.a.createElement("button", {
            key: "@brainhubeu/react-carousel/arrow-right",
            className: "BrainhubCarousel__arrows BrainhubCarousel__arrowRight",
            onClick: u,
            disabled: c
          }, Tt);
        }
      };
    },
        Mt = function Mt(e) {
      var t = e.carouselProps;
      return {
        name: Ft.FAST_SWIPE,
        strategies: function strategies() {
          var e = Object(a.useRecoilValue)(f).dragOffset,
              n = Object(a.useRecoilValue)(y);
          return function (e, t, n) {
            return t in e ? Object.defineProperty(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : e[t] = n, e;
          }({}, A, function () {
            var r = e > 0 ? -Math.ceil(e / t.width) : -Math.floor(e / t.width);
            return n + r;
          });
        }
      };
    };

    function kt(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    var Nt = We,
        Vt = nt,
        Pt = ct,
        Ct = ht,
        Lt = Ot,
        It = _t,
        Dt = At,
        Ut = xt,
        Bt = Mt,
        Ft = {
      SLIDES_TO_SHOW: "SLIDESTOSHOW",
      CLICK_TO_CHANGE: "CLICKTOCHANGE",
      INFINITE: "INFINITE",
      AUTOPLAY: "AUTOPLAY",
      RTL: "RTL",
      CENTERED: "CENTERED",
      SLIDES_TO_SCROLL: "SLIDESTOSCROLL",
      ARROWS: "ARROWS",
      FAST_SWIPE: "FASTSWIPE"
    },
        $t = (kt(wt = {}, Ft.SLIDES_TO_SHOW, Nt), kt(wt, Ft.CLICK_TO_CHANGE, Pt), kt(wt, Ft.INFINITE, Vt), kt(wt, Ft.RTL, Lt), kt(wt, Ft.AUTOPLAY, Ct), kt(wt, Ft.CENTERED, It), kt(wt, Ft.SLIDES_TO_SCROLL, Dt), kt(wt, Ft.ARROWS, Ut), kt(wt, Ft.FAST_SWIPE, Bt), wt),
        zt = [Ft.FAST_SWIPE, Ft.ARROWS, Ft.SLIDES_TO_SHOW, Ft.AUTOPLAY, Ft.INFINITE, Ft.RTL, Ft.CLICK_TO_CHANGE, Ft.CENTERED, Ft.SLIDES_TO_SCROLL];

    function Wt(e) {
      return function (e) {
        if (Array.isArray(e)) return qt(e);
      }(e) || function (e) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
      }(e) || function (e, t) {
        if (e) {
          if ("string" == typeof e) return qt(e, t);
          var n = Object.prototype.toString.call(e).slice(8, -1);
          return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? qt(e, t) : void 0;
        }
      }(e) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function qt(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var n = 0, r = new Array(t); n < t; n++) {
        r[n] = e[n];
      }

      return r;
    }

    function Ht(e, t) {
      var n = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function Gt(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Ht(Object(n), !0).forEach(function (t) {
          Yt(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ht(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }

    function Yt(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    function Xt(e) {
      return function (e) {
        if (Array.isArray(e)) return Jt(e);
      }(e) || function (e) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
      }(e) || function (e, t) {
        if (e) {
          if ("string" == typeof e) return Jt(e, t);
          var n = Object.prototype.toString.call(e).slice(8, -1);
          return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Jt(e, t) : void 0;
        }
      }(e) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function Jt(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var n = 0, r = new Array(t); n < t; n++) {
        r[n] = e[n];
      }

      return r;
    }

    n(252);
    var Kt = Object(r.memo)(function (e) {
      var t = e.index,
          n = e.onMouseDown,
          a = e.onTouchStart,
          i = e.currentSlideIndex,
          u = e.isDraggingEnabled,
          c = e.itemClassNames,
          s = e.width,
          l = e.offset,
          f = e.isDragging,
          p = e.children,
          d = Object(r.useRef)(null),
          b = Object(r.useRef)(!0),
          h = function h() {
        d.current && (d.current.style = null, d.current.offsetWidth > s && (d.current.style.width = "".concat(s, "px")));
      };

      return Object(r.useEffect)(function () {
        var e;
        b.current ? b.current = !1 : (e = new L.a(function () {
          h(), d.current && e.unobserve(d.current);
        }), d.current && e.observe(d.current));
      }, []), Object(r.useEffect)(function () {
        h();
      }, [s]), o.a.createElement("li", {
        className: ke.a.apply(void 0, ["BrainhubCarouselItem", {
          "BrainhubCarouselItem--active": t === i
        }].concat(Xt(c || []))),
        style: {
          marginRight: "".concat(l / 2, "px"),
          marginLeft: "".concat(l / 2, "px"),
          width: "".concat(s, "px"),
          maxWidth: "".concat(s, "px"),
          minWidth: "".concat(s, "px"),
          pointerEvents: f ? "none" : null
        },
        onMouseDown: u ? function (e) {
          n(e, t);
        } : null,
        onTouchStart: u ? function (e) {
          a(e, t);
        } : null
      }, d.current ? o.a.cloneElement(p, {
        ref: d
      }) : p);
    });

    function Qt(e) {
      return function (e) {
        if (Array.isArray(e)) return an(e);
      }(e) || function (e) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
      }(e) || on(e) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function Zt() {
      return (Zt = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var r in n) {
            Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function en(e, t) {
      var n = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function tn(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? en(Object(n), !0).forEach(function (t) {
          nn(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : en(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }

    function nn(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    function rn(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
          var n = [],
              r = !0,
              o = !1,
              a = void 0;

          try {
            for (var i, u = e[Symbol.iterator](); !(r = (i = u.next()).done) && (n.push(i.value), !t || n.length !== t); r = !0) {
              ;
            }
          } catch (e) {
            o = !0, a = e;
          } finally {
            try {
              r || null == u.return || u.return();
            } finally {
              if (o) throw a;
            }
          }

          return n;
        }
      }(e, t) || on(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function on(e, t) {
      if (e) {
        if ("string" == typeof e) return an(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? an(e, t) : void 0;
      }
    }

    function an(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var n = 0, r = new Array(t); n < t; n++) {
        r[n] = e[n];
      }

      return r;
    }

    n(254);

    var un = function un(e) {
      var t = rn(Object(a.useRecoilState)(f), 2),
          n = t[0],
          i = t[1],
          u = rn(Object(a.useRecoilState)(E), 2),
          c = u[0],
          s = u[1],
          l = Object(a.useSetRecoilState)(T),
          y = rn(Object(a.useRecoilState)(d), 2),
          v = y[0],
          m = y[1],
          g = rn(Object(a.useRecoilState)(R), 1)[0],
          S = rn(Object(a.useRecoilState)(p), 2),
          w = S[0],
          O = S[1],
          _ = rn(Object(a.useRecoilState)(b), 2),
          j = _[0],
          A = _[1],
          M = De(e.children, e.slides),
          k = rn(Object(a.useRecoilState)(x), 2),
          N = k[0],
          V = k[1],
          P = Object(a.useSetRecoilState)(h),
          C = Object(r.useRef)(!0),
          L = Object(r.useRef)(null),
          I = Object(r.useRef)(null),
          D = function (e, t, n, r) {
        var o = null == t ? void 0 : t.plugins.map(function (e) {
          return "string" == typeof e ? $t[e.toUpperCase()] && $t[e.toUpperCase()]({
            carouselProps: Gt(Gt({}, t), {}, {
              children: t.children ? t.children : t.slides
            }),
            options: e.options,
            refs: {
              trackContainerRef: n,
              carouselRef: r
            }
          }) : e.resolve({
            carouselProps: t,
            options: e.options,
            refs: {
              trackContainerRef: n,
              carouselRef: r
            }
          });
        }),
            a = Be()(o.map(function (e) {
          return e.itemClassNames && e.itemClassNames({
            carouselProps: t,
            options: e.options,
            refs: {
              trackContainerRef: n,
              carouselRef: r
            }
          });
        })).filter(function (e) {
          return "string" == typeof e;
        }),
            i = Be()(o.map(function (e) {
          return e.carouselClassNames && e.carouselClassNames({
            carouselProps: t,
            options: e.options,
            refs: {
              trackContainerRef: n,
              carouselRef: r
            }
          });
        })).filter(function (e) {
          return "string" == typeof e;
        }),
            u = Object.assign.apply(Object, [{}].concat(Wt(o.map(function (e) {
          return e.carouselCustomProps && e.carouselCustomProps();
        })))),
            c = Object.assign.apply(Object, [{}].concat(Wt(o.map(function (e) {
          return e.trackCustomProps && e.trackCustomProps();
        })))),
            s = Object.assign.apply(Object, [{}].concat(Wt(o.map(function (e) {
          return e.slideCustomProps && e.slideCustomProps();
        }))));
        return {
          itemClassNames: a,
          carouselClassNames: i,
          beforeCarouselItems: o.map(function (e) {
            return e.beforeCarouselItems && e.beforeCarouselItems();
          }) || [],
          afterCarouselItems: o.map(function (e) {
            return e.afterCarouselItems && e.afterCarouselItems();
          }) || [],
          strategies: $e()(o, function (e) {
            return zt.indexOf(e.name);
          }).map(function (e) {
            return e.strategies && e.strategies();
          }),
          carouselCustomProps: u,
          trackCustomProps: c,
          slideCustomProps: s,
          carouselPlugins: o
        };
      }(e.plugins, e, I, L),
          U = D.carouselPlugins,
          B = D.itemClassNames,
          F = D.carouselClassNames,
          $ = D.beforeCarouselItems,
          z = D.afterCarouselItems,
          W = D.strategies,
          q = D.carouselCustomProps,
          H = D.trackCustomProps,
          G = D.slideCustomProps;

      P(W);
      var Y,
          X,
          J,
          K = Object(r.useCallback)(function (e) {
        var t = e.pageX;
        null !== n.dragStart && i(function (e) {
          return tn(tn({}, n), {}, {
            dragOffset: t - e.dragStart,
            dragEnd: t
          });
        });
      }, [n, O]),
          Q = Object(r.useCallback)(function (e, t) {
        e.preventDefault(), e.stopPropagation(), O(!1);
        var r = e.pageX;
        i(tn(tn({}, n), {}, {
          clicked: t,
          dragStart: r
        }));
      }, [n, O]),
          Z = Object(r.useCallback)(function (e, t) {
        var n = e.changedTouches;
        i({
          clicked: t,
          dragStart: n[0].pageX
        });
      }, []),
          ee = Object(r.useCallback)(function () {
        null !== n.dragStart && (e.onChange(e.nearestSlideIndex), i({
          clicked: null,
          dragOffset: 0,
          dragStart: null,
          dragEnd: null
        })), O(!0);
      }, [O, i, n]);
      return function (e) {
        var t = e.width,
            n = e.carouselRef,
            o = e.setItemWidth,
            a = e.trackContainerRef,
            i = Object(r.useRef)(!0),
            u = Le()(function () {
          n && a && o(a.current.offsetWidth);
        }, 300);
        Object(r.useEffect)(function () {
          i.current ? i.current = !1 : u();
        }, [t, a.current]);
      }({
        carouselRef: L,
        itemWidth: c,
        setItemWidth: s,
        trackContainerRef: I,
        width: e.width
      }), Object(r.useEffect)(function () {
        V(M);
      }, [M]), Object(r.useEffect)(function () {
        l(e.offset);
      }, [e.offset]), Object(r.useEffect)(function () {
        C.current ? C.current = !1 : O(!0);
      }, [e.value]), Object(r.useEffect)(function () {
        var t = e.width * M.length;
        m(t);
      }, [e.width]), Object(r.useEffect)(function () {
        A(tn(tn({}, j), {}, {
          transform: e.transformOffset
        }));
      }, [e.transformOffset]), Pe("mouseup", ee, {
        passive: !0,
        capture: !0
      }), Pe("touchstart", Ie, {
        passive: !0,
        capture: !0
      }, L.current), Pe("touchmove", Ie, L.current), Pe("touchend", Ie, {
        passive: !0,
        capture: !0
      }, L.current), null == U || U.forEach(function (e) {
        return "function" == typeof e ? e() : e.plugin && e.plugin();
      }), o.a.createElement("div", {
        className: "BrainhubCarousel__container"
      }, o.a.createElement("div", Zt({
        className: ke.a.apply(void 0, ["BrainhubCarousel", e.className].concat(Qt(F || []))),
        onMouseMove: K,
        ref: L
      }, q), o.a.createElement(o.a.Fragment, null, $), (Y = e.animationSpeed, X = e.draggable && M && M.length > 1, J = {
        width: "".concat(v, "px"),
        transitionDuration: w ? "".concat(Y, "ms, ").concat(Y, "ms") : null,
        transform: "translateX(".concat(j.transform, "px)"),
        marginLeft: "".concat(j.marginLeft, "px"),
        marginRight: "".concat(j.marginRight, "px")
      }, o.a.createElement("div", {
        className: "BrainhubCarousel__trackContainer",
        ref: I
      }, o.a.createElement("ul", Zt({
        className: ke()("BrainhubCarousel__track", {
          "BrainhubCarousel__track--transition": w,
          "BrainhubCarousel__track--draggable": X
        }),
        style: J
      }, H), Ve()(N).map(function (t, r) {
        return o.a.createElement(Kt, Zt({
          clickable: !0,
          key: r,
          currentSlideIndex: g || e.value,
          index: r,
          width: e.itemWidth || c,
          offset: r !== N.length ? e.offset : 0,
          onMouseDown: Q,
          onTouchStart: Z,
          isDragging: Math.abs(n.dragOffset) > 10,
          itemClassNames: B,
          isDraggingEnabled: e.draggable
        }, G), t);
      })))), o.a.createElement(o.a.Fragment, null, z)));
    };

    un.defaultProps = {
      slidesPerPage: 1,
      offset: 0,
      animationSpeed: 500,
      draggable: !0,
      plugins: []
    };

    var cn = function (e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
        handleWidth: !0,
        handleHeight: !0
      },
          n = function (n) {
        je(i, n);
        var a = Ae(i);

        function i() {
          var e;
          we(this, i);

          for (var t = arguments.length, n = new Array(t), o = 0; o < t; o++) {
            n[o] = arguments[o];
          }

          return xe(Ee(e = a.call.apply(a, [this].concat(n))), "ref", Object(r.createRef)()), e;
        }

        return _e(i, [{
          key: "render",
          value: function value() {
            var n = this.props,
                r = n.forwardedRef,
                a = Se(n, ["forwardedRef"]),
                i = r || this.ref;
            return o.a.createElement(ve, ge({}, t, {
              targetRef: i
            }), o.a.createElement(e, ge({
              targetRef: i
            }, a)));
          }
        }]), i;
      }(o.a.Component);

      function a(e, t) {
        return o.a.createElement(n, ge({}, e, {
          forwardedRef: t
        }));
      }

      var i = e.displayName || e.name;
      return a.displayName = "withResizeDetector(".concat(i, ")"), n.propTypes = {
        forwardedRef: Object(l.oneOfType)([l.func, Object(l.shape)({
          current: l.any
        })])
      }, n.defaultProps = {
        forwardedRef: void 0
      }, Object(r.forwardRef)(a);
    }(o.a.memo(un));

    function sn() {
      return (sn = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var r in n) {
            Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function ln(e, t) {
      var n = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function fn(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? ln(Object(n), !0).forEach(function (t) {
          pn(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ln(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }

    function pn(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    function dn(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
          var n = [],
              r = !0,
              o = !1,
              a = void 0;

          try {
            for (var i, u = e[Symbol.iterator](); !(r = (i = u.next()).done) && (n.push(i.value), !t || n.length !== t); r = !0) {
              ;
            }
          } catch (e) {
            o = !0, a = e;
          } finally {
            try {
              r || null == u.return || u.return();
            } finally {
              if (o) throw a;
            }
          }

          return n;
        }
      }(e, t) || function (e, t) {
        if (e) {
          if ("string" == typeof e) return bn(e, t);
          var n = Object.prototype.toString.call(e).slice(8, -1);
          return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? bn(e, t) : void 0;
        }
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function bn(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var n = 0, r = new Array(t); n < t; n++) {
        r[n] = e[n];
      }

      return r;
    }

    var hn = function hn(e) {
      var t,
          n = Object(a.useSetRecoilState)(N),
          i = Object(a.useRecoilValue)(y),
          c = Object(a.useSetRecoilState)(p);
      Object(r.useEffect)(function () {
        u()(e.value) || n(e.value);
      }, [e.value, c]);

      var l = e.onChange,
          f = e.value,
          d = function (e, t) {
        if (null == e) return {};

        var n,
            r,
            o = function (e, t) {
          if (null == e) return {};
          var n,
              r,
              o = {},
              a = Object.keys(e);

          for (r = 0; r < a.length; r++) {
            n = a[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
          }

          return o;
        }(e, t);

        if (Object.getOwnPropertySymbols) {
          var a = Object.getOwnPropertySymbols(e);

          for (r = 0; r < a.length; r++) {
            n = a[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
          }
        }

        return o;
      }(e, ["onChange", "value"]),
          b = Object(a.useRecoilValue)(V),
          h = Object(a.useRecoilValue)(P),
          v = Object.entries(d.breakpoints || {}).filter(function (e) {
        var t = dn(e, 1)[0];
        return window.innerWidth <= t;
      }).sort(function (e, t) {
        var n = dn(e, 1)[0];
        return dn(t, 1)[0] - n;
      }).reduce(function (e, t) {
        var n = dn(t, 2),
            r = (n[0], n[1]);
        return fn(fn({}, e), r);
      }, s()(d, ["breakpoints"])),
          m = !u()(f);

      return o.a.createElement(cn, sn({
        key: (null == v || null === (t = v.plugins) || void 0 === t ? void 0 : t.length) || 0,
        transformOffset: b,
        nearestSlideIndex: h,
        value: i,
        onChange: m ? l : n
      }, v));
    },
        yn = (n(256), function (e) {
      var t = e.value,
          n = e.thumbnails,
          r = e.number,
          a = e.onChange,
          i = e.rtl,
          u = e.className,
          c = function c() {
        var e = r || n.length;
        return t >= 0 ? t : t + e * Math.ceil(Math.abs(t / e));
      },
          s = function s(e) {
        return function () {
          var o = r || n.length,
              i = c() % o;
          return a(t - (i - e));
        };
      };

      return o.a.createElement("ul", {
        className: ke()("BrainhubCarousel__dots", u, i ? "BrainhubCarousel__dots--isRTL" : "")
      }, function () {
        if (n) {
          var e = isNaN(r) ? n.length : r;
          return n.slice(0, e).map(function (t, n) {
            return o.a.createElement("li", {
              key: n
            }, o.a.createElement("div", {
              className: ke()("BrainhubCarousel__thumbnail", {
                "BrainhubCarousel__thumbnail--selected": n === c() % e
              }),
              type: "button",
              onClick: s(n)
            }, t));
          });
        }

        for (var t = [], a = 0; a < r; a++) {
          t.push(o.a.createElement("li", {
            key: a
          }, o.a.createElement("div", {
            className: ke()("BrainhubCarousel__dot", {
              "BrainhubCarousel__dot--selected": a === c() % r
            }),
            type: "button",
            onClick: s(a)
          }, a + 1)));
        }

        return t;
      }());
    }),
        vn = We,
        mn = nt,
        gn = ct,
        Sn = ht,
        wn = Ot,
        On = _t,
        _n = At,
        jn = xt,
        An = Mt,
        Rn = o.a.memo(yn);

    t.default = function (e) {
      return o.a.createElement(a.RecoilRoot, null, o.a.createElement(hn, e));
    };
  },, function (e, t) {},,,, function (e, t) {},, function (e, t) {},, function (e, t) {},, function (e, t) {}]);
});